import * as t from "maptalks";

import { Coordinate as i, Util as e, Point as s, Polygon as n, Extent as r, Map as h, renderer as o } from "maptalks";

import * as a from "@maptalks/reshader.gl";

import { mat4 as l, vec3 as c, vec2 as u, mat3 as f, quat as d, earcut as m, vec4 as g } from "@maptalks/reshader.gl";

export { earcut } from "@maptalks/reshader.gl";

import { GLContext as p } from "@maptalks/fusiongl";

export { GLContext } from "@maptalks/fusiongl";

import w, { createREGL as v } from "@maptalks/regl";

function _(t) {
    return t && t.t && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}

var y = {
    exports: {}
}, b = {
    exports: {}
}, x = function(t) {
    return !(!t || "string" == typeof t) && (t instanceof Array || Array.isArray(t) || t.length >= 0 && (t.splice instanceof Function || Object.getOwnPropertyDescriptor(t, t.length - 1) && "String" !== t.constructor.name));
}, M = Array.prototype.concat, S = Array.prototype.slice, C = b.exports = function(t) {
    for (var i = [], e = 0, s = t.length; e < s; e++) {
        var n = t[e];
        x(n) ? i = M.call(i, S.call(n)) : i.push(n);
    }
    return i;
};

C.wrap = function(t) {
    return function() {
        return t(C(arguments));
    };
};

var k = b.exports, T = {
    "aliceblue": [ 240, 248, 255 ],
    "antiquewhite": [ 250, 235, 215 ],
    "aqua": [ 0, 255, 255 ],
    "aquamarine": [ 127, 255, 212 ],
    "azure": [ 240, 255, 255 ],
    "beige": [ 245, 245, 220 ],
    "bisque": [ 255, 228, 196 ],
    "black": [ 0, 0, 0 ],
    "blanchedalmond": [ 255, 235, 205 ],
    "blue": [ 0, 0, 255 ],
    "blueviolet": [ 138, 43, 226 ],
    "brown": [ 165, 42, 42 ],
    "burlywood": [ 222, 184, 135 ],
    "cadetblue": [ 95, 158, 160 ],
    "chartreuse": [ 127, 255, 0 ],
    "chocolate": [ 210, 105, 30 ],
    "coral": [ 255, 127, 80 ],
    "cornflowerblue": [ 100, 149, 237 ],
    "cornsilk": [ 255, 248, 220 ],
    "crimson": [ 220, 20, 60 ],
    "cyan": [ 0, 255, 255 ],
    "darkblue": [ 0, 0, 139 ],
    "darkcyan": [ 0, 139, 139 ],
    "darkgoldenrod": [ 184, 134, 11 ],
    "darkgray": [ 169, 169, 169 ],
    "darkgreen": [ 0, 100, 0 ],
    "darkgrey": [ 169, 169, 169 ],
    "darkkhaki": [ 189, 183, 107 ],
    "darkmagenta": [ 139, 0, 139 ],
    "darkolivegreen": [ 85, 107, 47 ],
    "darkorange": [ 255, 140, 0 ],
    "darkorchid": [ 153, 50, 204 ],
    "darkred": [ 139, 0, 0 ],
    "darksalmon": [ 233, 150, 122 ],
    "darkseagreen": [ 143, 188, 143 ],
    "darkslateblue": [ 72, 61, 139 ],
    "darkslategray": [ 47, 79, 79 ],
    "darkslategrey": [ 47, 79, 79 ],
    "darkturquoise": [ 0, 206, 209 ],
    "darkviolet": [ 148, 0, 211 ],
    "deeppink": [ 255, 20, 147 ],
    "deepskyblue": [ 0, 191, 255 ],
    "dimgray": [ 105, 105, 105 ],
    "dimgrey": [ 105, 105, 105 ],
    "dodgerblue": [ 30, 144, 255 ],
    "firebrick": [ 178, 34, 34 ],
    "floralwhite": [ 255, 250, 240 ],
    "forestgreen": [ 34, 139, 34 ],
    "fuchsia": [ 255, 0, 255 ],
    "gainsboro": [ 220, 220, 220 ],
    "ghostwhite": [ 248, 248, 255 ],
    "gold": [ 255, 215, 0 ],
    "goldenrod": [ 218, 165, 32 ],
    "gray": [ 128, 128, 128 ],
    "green": [ 0, 128, 0 ],
    "greenyellow": [ 173, 255, 47 ],
    "grey": [ 128, 128, 128 ],
    "honeydew": [ 240, 255, 240 ],
    "hotpink": [ 255, 105, 180 ],
    "indianred": [ 205, 92, 92 ],
    "indigo": [ 75, 0, 130 ],
    "ivory": [ 255, 255, 240 ],
    "khaki": [ 240, 230, 140 ],
    "lavender": [ 230, 230, 250 ],
    "lavenderblush": [ 255, 240, 245 ],
    "lawngreen": [ 124, 252, 0 ],
    "lemonchiffon": [ 255, 250, 205 ],
    "lightblue": [ 173, 216, 230 ],
    "lightcoral": [ 240, 128, 128 ],
    "lightcyan": [ 224, 255, 255 ],
    "lightgoldenrodyellow": [ 250, 250, 210 ],
    "lightgray": [ 211, 211, 211 ],
    "lightgreen": [ 144, 238, 144 ],
    "lightgrey": [ 211, 211, 211 ],
    "lightpink": [ 255, 182, 193 ],
    "lightsalmon": [ 255, 160, 122 ],
    "lightseagreen": [ 32, 178, 170 ],
    "lightskyblue": [ 135, 206, 250 ],
    "lightslategray": [ 119, 136, 153 ],
    "lightslategrey": [ 119, 136, 153 ],
    "lightsteelblue": [ 176, 196, 222 ],
    "lightyellow": [ 255, 255, 224 ],
    "lime": [ 0, 255, 0 ],
    "limegreen": [ 50, 205, 50 ],
    "linen": [ 250, 240, 230 ],
    "magenta": [ 255, 0, 255 ],
    "maroon": [ 128, 0, 0 ],
    "mediumaquamarine": [ 102, 205, 170 ],
    "mediumblue": [ 0, 0, 205 ],
    "mediumorchid": [ 186, 85, 211 ],
    "mediumpurple": [ 147, 112, 219 ],
    "mediumseagreen": [ 60, 179, 113 ],
    "mediumslateblue": [ 123, 104, 238 ],
    "mediumspringgreen": [ 0, 250, 154 ],
    "mediumturquoise": [ 72, 209, 204 ],
    "mediumvioletred": [ 199, 21, 133 ],
    "midnightblue": [ 25, 25, 112 ],
    "mintcream": [ 245, 255, 250 ],
    "mistyrose": [ 255, 228, 225 ],
    "moccasin": [ 255, 228, 181 ],
    "navajowhite": [ 255, 222, 173 ],
    "navy": [ 0, 0, 128 ],
    "oldlace": [ 253, 245, 230 ],
    "olive": [ 128, 128, 0 ],
    "olivedrab": [ 107, 142, 35 ],
    "orange": [ 255, 165, 0 ],
    "orangered": [ 255, 69, 0 ],
    "orchid": [ 218, 112, 214 ],
    "palegoldenrod": [ 238, 232, 170 ],
    "palegreen": [ 152, 251, 152 ],
    "paleturquoise": [ 175, 238, 238 ],
    "palevioletred": [ 219, 112, 147 ],
    "papayawhip": [ 255, 239, 213 ],
    "peachpuff": [ 255, 218, 185 ],
    "peru": [ 205, 133, 63 ],
    "pink": [ 255, 192, 203 ],
    "plum": [ 221, 160, 221 ],
    "powderblue": [ 176, 224, 230 ],
    "purple": [ 128, 0, 128 ],
    "rebeccapurple": [ 102, 51, 153 ],
    "red": [ 255, 0, 0 ],
    "rosybrown": [ 188, 143, 143 ],
    "royalblue": [ 65, 105, 225 ],
    "saddlebrown": [ 139, 69, 19 ],
    "salmon": [ 250, 128, 114 ],
    "sandybrown": [ 244, 164, 96 ],
    "seagreen": [ 46, 139, 87 ],
    "seashell": [ 255, 245, 238 ],
    "sienna": [ 160, 82, 45 ],
    "silver": [ 192, 192, 192 ],
    "skyblue": [ 135, 206, 235 ],
    "slateblue": [ 106, 90, 205 ],
    "slategray": [ 112, 128, 144 ],
    "slategrey": [ 112, 128, 144 ],
    "snow": [ 255, 250, 250 ],
    "springgreen": [ 0, 255, 127 ],
    "steelblue": [ 70, 130, 180 ],
    "tan": [ 210, 180, 140 ],
    "teal": [ 0, 128, 128 ],
    "thistle": [ 216, 191, 216 ],
    "tomato": [ 255, 99, 71 ],
    "turquoise": [ 64, 224, 208 ],
    "violet": [ 238, 130, 238 ],
    "wheat": [ 245, 222, 179 ],
    "white": [ 255, 255, 255 ],
    "whitesmoke": [ 245, 245, 245 ],
    "yellow": [ 255, 255, 0 ],
    "yellowgreen": [ 154, 205, 50 ]
}, O = k, A = Object.hasOwnProperty, I = Object.create(null);

for (var E in T) A.call(T, E) && (I[T[E]] = E);

var L = y.exports = {
    to: {},
    get: {}
};

function P(t, i, e) {
    return Math.min(Math.max(i, t), e);
}

function R(t) {
    var i = Math.round(t).toString(16).toUpperCase();
    return i.length < 2 ? "0" + i : i;
}

L.get = function(t) {
    var i, e;
    switch (t.substring(0, 3).toLowerCase()) {
      case "hsl":
        i = L.get.hsl(t), e = "hsl";
        break;

      case "hwb":
        i = L.get.hwb(t), e = "hwb";
        break;

      default:
        i = L.get.rgb(t), e = "rgb";
    }
    return i ? {
        model: e,
        value: i
    } : null;
}, L.get.rgb = function(t) {
    if (!t) return null;
    var i, e, s, n = [ 0, 0, 0, 1 ];
    if (i = t.match(/^#([a-f0-9]{6})([a-f0-9]{2})?$/i)) {
        for (s = i[2], i = i[1], e = 0; e < 3; e++) {
            var r = 2 * e;
            n[e] = parseInt(i.slice(r, r + 2), 16);
        }
        s && (n[3] = parseInt(s, 16) / 255);
    } else if (i = t.match(/^#([a-f0-9]{3,4})$/i)) {
        for (s = (i = i[1])[3], e = 0; e < 3; e++) n[e] = parseInt(i[e] + i[e], 16);
        s && (n[3] = parseInt(s + s, 16) / 255);
    } else if (i = t.match(/^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/)) {
        for (e = 0; e < 3; e++) n[e] = parseInt(i[e + 1], 0);
        i[4] && (i[5] ? n[3] = .01 * parseFloat(i[4]) : n[3] = parseFloat(i[4]));
    } else {
        if (!(i = t.match(/^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/))) return (i = t.match(/^(\w+)$/)) ? "transparent" === i[1] ? [ 0, 0, 0, 0 ] : A.call(T, i[1]) ? ((n = T[i[1]])[3] = 1, 
        n) : null : null;
        for (e = 0; e < 3; e++) n[e] = Math.round(2.55 * parseFloat(i[e + 1]));
        i[4] && (i[5] ? n[3] = .01 * parseFloat(i[4]) : n[3] = parseFloat(i[4]));
    }
    for (e = 0; e < 3; e++) n[e] = P(n[e], 0, 255);
    return n[3] = P(n[3], 0, 1), n;
}, L.get.hsl = function(t) {
    if (!t) return null;
    var i = t.match(/^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/);
    if (i) {
        var e = parseFloat(i[4]);
        return [ (parseFloat(i[1]) % 360 + 360) % 360, P(parseFloat(i[2]), 0, 100), P(parseFloat(i[3]), 0, 100), P(isNaN(e) ? 1 : e, 0, 1) ];
    }
    return null;
}, L.get.hwb = function(t) {
    if (!t) return null;
    var i = t.match(/^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/);
    if (i) {
        var e = parseFloat(i[4]);
        return [ (parseFloat(i[1]) % 360 + 360) % 360, P(parseFloat(i[2]), 0, 100), P(parseFloat(i[3]), 0, 100), P(isNaN(e) ? 1 : e, 0, 1) ];
    }
    return null;
}, L.to.hex = function() {
    var t = O(arguments);
    return "#" + R(t[0]) + R(t[1]) + R(t[2]) + (t[3] < 1 ? R(Math.round(255 * t[3])) : "");
}, L.to.rgb = function() {
    var t = O(arguments);
    return t.length < 4 || 1 === t[3] ? "rgb(" + Math.round(t[0]) + ", " + Math.round(t[1]) + ", " + Math.round(t[2]) + ")" : "rgba(" + Math.round(t[0]) + ", " + Math.round(t[1]) + ", " + Math.round(t[2]) + ", " + t[3] + ")";
}, L.to.rgb.percent = function() {
    var t = O(arguments), i = Math.round(t[0] / 255 * 100), e = Math.round(t[1] / 255 * 100), s = Math.round(t[2] / 255 * 100);
    return t.length < 4 || 1 === t[3] ? "rgb(" + i + "%, " + e + "%, " + s + "%)" : "rgba(" + i + "%, " + e + "%, " + s + "%, " + t[3] + ")";
}, L.to.hsl = function() {
    var t = O(arguments);
    return t.length < 4 || 1 === t[3] ? "hsl(" + t[0] + ", " + t[1] + "%, " + t[2] + "%)" : "hsla(" + t[0] + ", " + t[1] + "%, " + t[2] + "%, " + t[3] + ")";
}, L.to.hwb = function() {
    var t = O(arguments), i = "";
    return t.length >= 4 && 1 !== t[3] && (i = ", " + t[3]), "hwb(" + t[0] + ", " + t[1] + "%, " + t[2] + "%" + i + ")";
}, L.to.keyword = function(t) {
    return I[t.slice(0, 3)];
};

var F = y.exports, H = {
    exports: {}
}, D = {
    "aliceblue": [ 240, 248, 255 ],
    "antiquewhite": [ 250, 235, 215 ],
    "aqua": [ 0, 255, 255 ],
    "aquamarine": [ 127, 255, 212 ],
    "azure": [ 240, 255, 255 ],
    "beige": [ 245, 245, 220 ],
    "bisque": [ 255, 228, 196 ],
    "black": [ 0, 0, 0 ],
    "blanchedalmond": [ 255, 235, 205 ],
    "blue": [ 0, 0, 255 ],
    "blueviolet": [ 138, 43, 226 ],
    "brown": [ 165, 42, 42 ],
    "burlywood": [ 222, 184, 135 ],
    "cadetblue": [ 95, 158, 160 ],
    "chartreuse": [ 127, 255, 0 ],
    "chocolate": [ 210, 105, 30 ],
    "coral": [ 255, 127, 80 ],
    "cornflowerblue": [ 100, 149, 237 ],
    "cornsilk": [ 255, 248, 220 ],
    "crimson": [ 220, 20, 60 ],
    "cyan": [ 0, 255, 255 ],
    "darkblue": [ 0, 0, 139 ],
    "darkcyan": [ 0, 139, 139 ],
    "darkgoldenrod": [ 184, 134, 11 ],
    "darkgray": [ 169, 169, 169 ],
    "darkgreen": [ 0, 100, 0 ],
    "darkgrey": [ 169, 169, 169 ],
    "darkkhaki": [ 189, 183, 107 ],
    "darkmagenta": [ 139, 0, 139 ],
    "darkolivegreen": [ 85, 107, 47 ],
    "darkorange": [ 255, 140, 0 ],
    "darkorchid": [ 153, 50, 204 ],
    "darkred": [ 139, 0, 0 ],
    "darksalmon": [ 233, 150, 122 ],
    "darkseagreen": [ 143, 188, 143 ],
    "darkslateblue": [ 72, 61, 139 ],
    "darkslategray": [ 47, 79, 79 ],
    "darkslategrey": [ 47, 79, 79 ],
    "darkturquoise": [ 0, 206, 209 ],
    "darkviolet": [ 148, 0, 211 ],
    "deeppink": [ 255, 20, 147 ],
    "deepskyblue": [ 0, 191, 255 ],
    "dimgray": [ 105, 105, 105 ],
    "dimgrey": [ 105, 105, 105 ],
    "dodgerblue": [ 30, 144, 255 ],
    "firebrick": [ 178, 34, 34 ],
    "floralwhite": [ 255, 250, 240 ],
    "forestgreen": [ 34, 139, 34 ],
    "fuchsia": [ 255, 0, 255 ],
    "gainsboro": [ 220, 220, 220 ],
    "ghostwhite": [ 248, 248, 255 ],
    "gold": [ 255, 215, 0 ],
    "goldenrod": [ 218, 165, 32 ],
    "gray": [ 128, 128, 128 ],
    "green": [ 0, 128, 0 ],
    "greenyellow": [ 173, 255, 47 ],
    "grey": [ 128, 128, 128 ],
    "honeydew": [ 240, 255, 240 ],
    "hotpink": [ 255, 105, 180 ],
    "indianred": [ 205, 92, 92 ],
    "indigo": [ 75, 0, 130 ],
    "ivory": [ 255, 255, 240 ],
    "khaki": [ 240, 230, 140 ],
    "lavender": [ 230, 230, 250 ],
    "lavenderblush": [ 255, 240, 245 ],
    "lawngreen": [ 124, 252, 0 ],
    "lemonchiffon": [ 255, 250, 205 ],
    "lightblue": [ 173, 216, 230 ],
    "lightcoral": [ 240, 128, 128 ],
    "lightcyan": [ 224, 255, 255 ],
    "lightgoldenrodyellow": [ 250, 250, 210 ],
    "lightgray": [ 211, 211, 211 ],
    "lightgreen": [ 144, 238, 144 ],
    "lightgrey": [ 211, 211, 211 ],
    "lightpink": [ 255, 182, 193 ],
    "lightsalmon": [ 255, 160, 122 ],
    "lightseagreen": [ 32, 178, 170 ],
    "lightskyblue": [ 135, 206, 250 ],
    "lightslategray": [ 119, 136, 153 ],
    "lightslategrey": [ 119, 136, 153 ],
    "lightsteelblue": [ 176, 196, 222 ],
    "lightyellow": [ 255, 255, 224 ],
    "lime": [ 0, 255, 0 ],
    "limegreen": [ 50, 205, 50 ],
    "linen": [ 250, 240, 230 ],
    "magenta": [ 255, 0, 255 ],
    "maroon": [ 128, 0, 0 ],
    "mediumaquamarine": [ 102, 205, 170 ],
    "mediumblue": [ 0, 0, 205 ],
    "mediumorchid": [ 186, 85, 211 ],
    "mediumpurple": [ 147, 112, 219 ],
    "mediumseagreen": [ 60, 179, 113 ],
    "mediumslateblue": [ 123, 104, 238 ],
    "mediumspringgreen": [ 0, 250, 154 ],
    "mediumturquoise": [ 72, 209, 204 ],
    "mediumvioletred": [ 199, 21, 133 ],
    "midnightblue": [ 25, 25, 112 ],
    "mintcream": [ 245, 255, 250 ],
    "mistyrose": [ 255, 228, 225 ],
    "moccasin": [ 255, 228, 181 ],
    "navajowhite": [ 255, 222, 173 ],
    "navy": [ 0, 0, 128 ],
    "oldlace": [ 253, 245, 230 ],
    "olive": [ 128, 128, 0 ],
    "olivedrab": [ 107, 142, 35 ],
    "orange": [ 255, 165, 0 ],
    "orangered": [ 255, 69, 0 ],
    "orchid": [ 218, 112, 214 ],
    "palegoldenrod": [ 238, 232, 170 ],
    "palegreen": [ 152, 251, 152 ],
    "paleturquoise": [ 175, 238, 238 ],
    "palevioletred": [ 219, 112, 147 ],
    "papayawhip": [ 255, 239, 213 ],
    "peachpuff": [ 255, 218, 185 ],
    "peru": [ 205, 133, 63 ],
    "pink": [ 255, 192, 203 ],
    "plum": [ 221, 160, 221 ],
    "powderblue": [ 176, 224, 230 ],
    "purple": [ 128, 0, 128 ],
    "rebeccapurple": [ 102, 51, 153 ],
    "red": [ 255, 0, 0 ],
    "rosybrown": [ 188, 143, 143 ],
    "royalblue": [ 65, 105, 225 ],
    "saddlebrown": [ 139, 69, 19 ],
    "salmon": [ 250, 128, 114 ],
    "sandybrown": [ 244, 164, 96 ],
    "seagreen": [ 46, 139, 87 ],
    "seashell": [ 255, 245, 238 ],
    "sienna": [ 160, 82, 45 ],
    "silver": [ 192, 192, 192 ],
    "skyblue": [ 135, 206, 235 ],
    "slateblue": [ 106, 90, 205 ],
    "slategray": [ 112, 128, 144 ],
    "slategrey": [ 112, 128, 144 ],
    "snow": [ 255, 250, 250 ],
    "springgreen": [ 0, 255, 127 ],
    "steelblue": [ 70, 130, 180 ],
    "tan": [ 210, 180, 140 ],
    "teal": [ 0, 128, 128 ],
    "thistle": [ 216, 191, 216 ],
    "tomato": [ 255, 99, 71 ],
    "turquoise": [ 64, 224, 208 ],
    "violet": [ 238, 130, 238 ],
    "wheat": [ 245, 222, 179 ],
    "white": [ 255, 255, 255 ],
    "whitesmoke": [ 245, 245, 245 ],
    "yellow": [ 255, 255, 0 ],
    "yellowgreen": [ 154, 205, 50 ]
}, N = {};

for (var G in D) D.hasOwnProperty(G) && (N[D[G]] = G);

var j = H.exports = {
    rgb: {
        channels: 3,
        labels: "rgb"
    },
    hsl: {
        channels: 3,
        labels: "hsl"
    },
    hsv: {
        channels: 3,
        labels: "hsv"
    },
    hwb: {
        channels: 3,
        labels: "hwb"
    },
    cmyk: {
        channels: 4,
        labels: "cmyk"
    },
    xyz: {
        channels: 3,
        labels: "xyz"
    },
    lab: {
        channels: 3,
        labels: "lab"
    },
    lch: {
        channels: 3,
        labels: "lch"
    },
    hex: {
        channels: 1,
        labels: [ "hex" ]
    },
    keyword: {
        channels: 1,
        labels: [ "keyword" ]
    },
    ansi16: {
        channels: 1,
        labels: [ "ansi16" ]
    },
    ansi256: {
        channels: 1,
        labels: [ "ansi256" ]
    },
    hcg: {
        channels: 3,
        labels: [ "h", "c", "g" ]
    },
    apple: {
        channels: 3,
        labels: [ "r16", "g16", "b16" ]
    },
    gray: {
        channels: 1,
        labels: [ "gray" ]
    }
};

for (var B in j) if (j.hasOwnProperty(B)) {
    if (!("channels" in j[B])) throw new Error("missing channels property: " + B);
    if (!("labels" in j[B])) throw new Error("missing channel labels property: " + B);
    if (j[B].labels.length !== j[B].channels) throw new Error("channel and label counts mismatch: " + B);
    var z = j[B].channels, U = j[B].labels;
    delete j[B].channels, delete j[B].labels, Object.defineProperty(j[B], "channels", {
        value: z
    }), Object.defineProperty(j[B], "labels", {
        value: U
    });
}

j.rgb.hsl = function(t) {
    var i, e, s = t[0] / 255, n = t[1] / 255, r = t[2] / 255, h = Math.min(s, n, r), o = Math.max(s, n, r), a = o - h;
    return o === h ? i = 0 : s === o ? i = (n - r) / a : n === o ? i = 2 + (r - s) / a : r === o && (i = 4 + (s - n) / a), 
    (i = Math.min(60 * i, 360)) < 0 && (i += 360), e = (h + o) / 2, [ i, 100 * (o === h ? 0 : e <= .5 ? a / (o + h) : a / (2 - o - h)), 100 * e ];
}, j.rgb.hsv = function(t) {
    var i, e, s, n, r, h = t[0] / 255, o = t[1] / 255, a = t[2] / 255, l = Math.max(h, o, a), c = l - Math.min(h, o, a), u = function(t) {
        return (l - t) / 6 / c + .5;
    };
    return 0 === c ? n = r = 0 : (r = c / l, i = u(h), e = u(o), s = u(a), h === l ? n = s - e : o === l ? n = 1 / 3 + i - s : a === l && (n = 2 / 3 + e - i), 
    n < 0 ? n += 1 : n > 1 && (n -= 1)), [ 360 * n, 100 * r, 100 * l ];
}, j.rgb.hwb = function(t) {
    var i = t[0], e = t[1], s = t[2];
    return [ j.rgb.hsl(t)[0], 100 * (1 / 255 * Math.min(i, Math.min(e, s))), 100 * (s = 1 - 1 / 255 * Math.max(i, Math.max(e, s))) ];
}, j.rgb.cmyk = function(t) {
    var i, e = t[0] / 255, s = t[1] / 255, n = t[2] / 255;
    return [ 100 * ((1 - e - (i = Math.min(1 - e, 1 - s, 1 - n))) / (1 - i) || 0), 100 * ((1 - s - i) / (1 - i) || 0), 100 * ((1 - n - i) / (1 - i) || 0), 100 * i ];
}, j.rgb.keyword = function(t) {
    var i = N[t];
    if (i) return i;
    var e, s, n, r = 1 / 0;
    for (var h in D) if (D.hasOwnProperty(h)) {
        var o = D[h], a = (s = t, n = o, Math.pow(s[0] - n[0], 2) + Math.pow(s[1] - n[1], 2) + Math.pow(s[2] - n[2], 2));
        a < r && (r = a, e = h);
    }
    return e;
}, j.keyword.rgb = function(t) {
    return D[t];
}, j.rgb.xyz = function(t) {
    var i = t[0] / 255, e = t[1] / 255, s = t[2] / 255;
    return [ 100 * (.4124 * (i = i > .04045 ? Math.pow((i + .055) / 1.055, 2.4) : i / 12.92) + .3576 * (e = e > .04045 ? Math.pow((e + .055) / 1.055, 2.4) : e / 12.92) + .1805 * (s = s > .04045 ? Math.pow((s + .055) / 1.055, 2.4) : s / 12.92)), 100 * (.2126 * i + .7152 * e + .0722 * s), 100 * (.0193 * i + .1192 * e + .9505 * s) ];
}, j.rgb.lab = function(t) {
    var i = j.rgb.xyz(t), e = i[0], s = i[1], n = i[2];
    return s /= 100, n /= 108.883, e = (e /= 95.047) > .008856 ? Math.pow(e, 1 / 3) : 7.787 * e + 16 / 116, 
    [ 116 * (s = s > .008856 ? Math.pow(s, 1 / 3) : 7.787 * s + 16 / 116) - 16, 500 * (e - s), 200 * (s - (n = n > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116)) ];
}, j.hsl.rgb = function(t) {
    var i, e, s, n, r, h = t[0] / 360, o = t[1] / 100, a = t[2] / 100;
    if (0 === o) return [ r = 255 * a, r, r ];
    i = 2 * a - (e = a < .5 ? a * (1 + o) : a + o - a * o), n = [ 0, 0, 0 ];
    for (var l = 0; l < 3; l++) (s = h + 1 / 3 * -(l - 1)) < 0 && s++, s > 1 && s--, 
    r = 6 * s < 1 ? i + 6 * (e - i) * s : 2 * s < 1 ? e : 3 * s < 2 ? i + (e - i) * (2 / 3 - s) * 6 : i, 
    n[l] = 255 * r;
    return n;
}, j.hsl.hsv = function(t) {
    var i = t[0], e = t[1] / 100, s = t[2] / 100, n = e, r = Math.max(s, .01);
    return e *= (s *= 2) <= 1 ? s : 2 - s, n *= r <= 1 ? r : 2 - r, [ i, 100 * (0 === s ? 2 * n / (r + n) : 2 * e / (s + e)), 100 * ((s + e) / 2) ];
}, j.hsv.rgb = function(t) {
    var i = t[0] / 60, e = t[1] / 100, s = t[2] / 100, n = Math.floor(i) % 6, r = i - Math.floor(i), h = 255 * s * (1 - e), o = 255 * s * (1 - e * r), a = 255 * s * (1 - e * (1 - r));
    switch (s *= 255, n) {
      case 0:
        return [ s, a, h ];

      case 1:
        return [ o, s, h ];

      case 2:
        return [ h, s, a ];

      case 3:
        return [ h, o, s ];

      case 4:
        return [ a, h, s ];

      case 5:
        return [ s, h, o ];
    }
}, j.hsv.hsl = function(t) {
    var i, e, s, n = t[0], r = t[1] / 100, h = t[2] / 100, o = Math.max(h, .01);
    return s = (2 - r) * h, e = r * o, [ n, 100 * (e = (e /= (i = (2 - r) * o) <= 1 ? i : 2 - i) || 0), 100 * (s /= 2) ];
}, j.hwb.rgb = function(t) {
    var i, e, s, n, r, h, o, a = t[0] / 360, l = t[1] / 100, c = t[2] / 100, u = l + c;
    switch (u > 1 && (l /= u, c /= u), s = 6 * a - (i = Math.floor(6 * a)), 1 & i && (s = 1 - s), 
    n = l + s * ((e = 1 - c) - l), i) {
      default:
      case 6:
      case 0:
        r = e, h = n, o = l;
        break;

      case 1:
        r = n, h = e, o = l;
        break;

      case 2:
        r = l, h = e, o = n;
        break;

      case 3:
        r = l, h = n, o = e;
        break;

      case 4:
        r = n, h = l, o = e;
        break;

      case 5:
        r = e, h = l, o = n;
    }
    return [ 255 * r, 255 * h, 255 * o ];
}, j.cmyk.rgb = function(t) {
    var i = t[0] / 100, e = t[1] / 100, s = t[2] / 100, n = t[3] / 100;
    return [ 255 * (1 - Math.min(1, i * (1 - n) + n)), 255 * (1 - Math.min(1, e * (1 - n) + n)), 255 * (1 - Math.min(1, s * (1 - n) + n)) ];
}, j.xyz.rgb = function(t) {
    var i, e, s, n = t[0] / 100, r = t[1] / 100, h = t[2] / 100;
    return e = -.9689 * n + 1.8758 * r + .0415 * h, s = .0557 * n + -.204 * r + 1.057 * h, 
    i = (i = 3.2406 * n + -1.5372 * r + -.4986 * h) > .0031308 ? 1.055 * Math.pow(i, 1 / 2.4) - .055 : 12.92 * i, 
    e = e > .0031308 ? 1.055 * Math.pow(e, 1 / 2.4) - .055 : 12.92 * e, s = s > .0031308 ? 1.055 * Math.pow(s, 1 / 2.4) - .055 : 12.92 * s, 
    [ 255 * (i = Math.min(Math.max(0, i), 1)), 255 * (e = Math.min(Math.max(0, e), 1)), 255 * (s = Math.min(Math.max(0, s), 1)) ];
}, j.xyz.lab = function(t) {
    var i = t[0], e = t[1], s = t[2];
    return e /= 100, s /= 108.883, i = (i /= 95.047) > .008856 ? Math.pow(i, 1 / 3) : 7.787 * i + 16 / 116, 
    [ 116 * (e = e > .008856 ? Math.pow(e, 1 / 3) : 7.787 * e + 16 / 116) - 16, 500 * (i - e), 200 * (e - (s = s > .008856 ? Math.pow(s, 1 / 3) : 7.787 * s + 16 / 116)) ];
}, j.lab.xyz = function(t) {
    var i, e, s, n = t[0];
    i = t[1] / 500 + (e = (n + 16) / 116), s = e - t[2] / 200;
    var r = Math.pow(e, 3), h = Math.pow(i, 3), o = Math.pow(s, 3);
    return e = r > .008856 ? r : (e - 16 / 116) / 7.787, i = h > .008856 ? h : (i - 16 / 116) / 7.787, 
    s = o > .008856 ? o : (s - 16 / 116) / 7.787, [ i *= 95.047, e *= 100, s *= 108.883 ];
}, j.lab.lch = function(t) {
    var i, e = t[0], s = t[1], n = t[2];
    return (i = 360 * Math.atan2(n, s) / 2 / Math.PI) < 0 && (i += 360), [ e, Math.sqrt(s * s + n * n), i ];
}, j.lch.lab = function(t) {
    var i, e = t[0], s = t[1];
    return i = t[2] / 360 * 2 * Math.PI, [ e, s * Math.cos(i), s * Math.sin(i) ];
}, j.rgb.ansi16 = function(t) {
    var i = t[0], e = t[1], s = t[2], n = 1 in arguments ? arguments[1] : j.rgb.hsv(t)[2];
    if (0 === (n = Math.round(n / 50))) return 30;
    var r = 30 + (Math.round(s / 255) << 2 | Math.round(e / 255) << 1 | Math.round(i / 255));
    return 2 === n && (r += 60), r;
}, j.hsv.ansi16 = function(t) {
    return j.rgb.ansi16(j.hsv.rgb(t), t[2]);
}, j.rgb.ansi256 = function(t) {
    var i = t[0], e = t[1], s = t[2];
    return i === e && e === s ? i < 8 ? 16 : i > 248 ? 231 : Math.round((i - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(i / 255 * 5) + 6 * Math.round(e / 255 * 5) + Math.round(s / 255 * 5);
}, j.ansi16.rgb = function(t) {
    var i = t % 10;
    if (0 === i || 7 === i) return t > 50 && (i += 3.5), [ i = i / 10.5 * 255, i, i ];
    var e = .5 * (1 + ~~(t > 50));
    return [ (1 & i) * e * 255, (i >> 1 & 1) * e * 255, (i >> 2 & 1) * e * 255 ];
}, j.ansi256.rgb = function(t) {
    if (t >= 232) {
        var i = 10 * (t - 232) + 8;
        return [ i, i, i ];
    }
    var e;
    return t -= 16, [ Math.floor(t / 36) / 5 * 255, Math.floor((e = t % 36) / 6) / 5 * 255, e % 6 / 5 * 255 ];
}, j.rgb.hex = function(t) {
    var i = (((255 & Math.round(t[0])) << 16) + ((255 & Math.round(t[1])) << 8) + (255 & Math.round(t[2]))).toString(16).toUpperCase();
    return "000000".substring(i.length) + i;
}, j.hex.rgb = function(t) {
    var i = t.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!i) return [ 0, 0, 0 ];
    var e = i[0];
    3 === i[0].length && (e = e.split("").map((function(t) {
        return t + t;
    })).join(""));
    var s = parseInt(e, 16);
    return [ s >> 16 & 255, s >> 8 & 255, 255 & s ];
}, j.rgb.hcg = function(t) {
    var i, e = t[0] / 255, s = t[1] / 255, n = t[2] / 255, r = Math.max(Math.max(e, s), n), h = Math.min(Math.min(e, s), n), o = r - h;
    return i = o <= 0 ? 0 : r === e ? (s - n) / o % 6 : r === s ? 2 + (n - e) / o : 4 + (e - s) / o + 4, 
    i /= 6, [ 360 * (i %= 1), 100 * o, 100 * (o < 1 ? h / (1 - o) : 0) ];
}, j.hsl.hcg = function(t) {
    var i = t[1] / 100, e = t[2] / 100, s = 1, n = 0;
    return (s = e < .5 ? 2 * i * e : 2 * i * (1 - e)) < 1 && (n = (e - .5 * s) / (1 - s)), 
    [ t[0], 100 * s, 100 * n ];
}, j.hsv.hcg = function(t) {
    var i = t[1] / 100, e = t[2] / 100, s = i * e, n = 0;
    return s < 1 && (n = (e - s) / (1 - s)), [ t[0], 100 * s, 100 * n ];
}, j.hcg.rgb = function(t) {
    var i = t[0] / 360, e = t[1] / 100, s = t[2] / 100;
    if (0 === e) return [ 255 * s, 255 * s, 255 * s ];
    var n, r = [ 0, 0, 0 ], h = i % 1 * 6, o = h % 1, a = 1 - o;
    switch (Math.floor(h)) {
      case 0:
        r[0] = 1, r[1] = o, r[2] = 0;
        break;

      case 1:
        r[0] = a, r[1] = 1, r[2] = 0;
        break;

      case 2:
        r[0] = 0, r[1] = 1, r[2] = o;
        break;

      case 3:
        r[0] = 0, r[1] = a, r[2] = 1;
        break;

      case 4:
        r[0] = o, r[1] = 0, r[2] = 1;
        break;

      default:
        r[0] = 1, r[1] = 0, r[2] = a;
    }
    return n = (1 - e) * s, [ 255 * (e * r[0] + n), 255 * (e * r[1] + n), 255 * (e * r[2] + n) ];
}, j.hcg.hsv = function(t) {
    var i = t[1] / 100, e = i + t[2] / 100 * (1 - i), s = 0;
    return e > 0 && (s = i / e), [ t[0], 100 * s, 100 * e ];
}, j.hcg.hsl = function(t) {
    var i = t[1] / 100, e = t[2] / 100 * (1 - i) + .5 * i, s = 0;
    return e > 0 && e < .5 ? s = i / (2 * e) : e >= .5 && e < 1 && (s = i / (2 * (1 - e))), 
    [ t[0], 100 * s, 100 * e ];
}, j.hcg.hwb = function(t) {
    var i = t[1] / 100, e = i + t[2] / 100 * (1 - i);
    return [ t[0], 100 * (e - i), 100 * (1 - e) ];
}, j.hwb.hcg = function(t) {
    var i = t[1] / 100, e = 1 - t[2] / 100, s = e - i, n = 0;
    return s < 1 && (n = (e - s) / (1 - s)), [ t[0], 100 * s, 100 * n ];
}, j.apple.rgb = function(t) {
    return [ t[0] / 65535 * 255, t[1] / 65535 * 255, t[2] / 65535 * 255 ];
}, j.rgb.apple = function(t) {
    return [ t[0] / 255 * 65535, t[1] / 255 * 65535, t[2] / 255 * 65535 ];
}, j.gray.rgb = function(t) {
    return [ t[0] / 100 * 255, t[0] / 100 * 255, t[0] / 100 * 255 ];
}, j.gray.hsl = j.gray.hsv = function(t) {
    return [ 0, 0, t[0] ];
}, j.gray.hwb = function(t) {
    return [ 0, 100, t[0] ];
}, j.gray.cmyk = function(t) {
    return [ 0, 0, 0, t[0] ];
}, j.gray.lab = function(t) {
    return [ t[0], 0, 0 ];
}, j.gray.hex = function(t) {
    var i = 255 & Math.round(t[0] / 100 * 255), e = ((i << 16) + (i << 8) + i).toString(16).toUpperCase();
    return "000000".substring(e.length) + e;
}, j.rgb.gray = function(t) {
    return [ (t[0] + t[1] + t[2]) / 3 / 255 * 100 ];
};

var V = H.exports, W = V;

function q(t) {
    var i = function() {
        for (var t = {}, i = Object.keys(W), e = i.length, s = 0; s < e; s++) t[i[s]] = {
            distance: -1,
            parent: null
        };
        return t;
    }(), e = [ t ];
    for (i[t].distance = 0; e.length; ) for (var s = e.pop(), n = Object.keys(W[s]), r = n.length, h = 0; h < r; h++) {
        var o = n[h], a = i[o];
        -1 === a.distance && (a.distance = i[s].distance + 1, a.parent = s, e.unshift(o));
    }
    return i;
}

function $(t, i) {
    return function(e) {
        return i(t(e));
    };
}

function X(t, i) {
    for (var e = [ i[t].parent, t ], s = W[i[t].parent][t], n = i[t].parent; i[n].parent; ) e.unshift(i[n].parent), 
    s = $(W[i[n].parent][n], s), n = i[n].parent;
    return s.conversion = e, s;
}

var Y = V, J = function(t) {
    for (var i = q(t), e = {}, s = Object.keys(i), n = s.length, r = 0; r < n; r++) {
        var h = s[r];
        null !== i[h].parent && (e[h] = X(h, i));
    }
    return e;
}, Z = {};

Object.keys(Y).forEach((function(t) {
    Z[t] = {}, Object.defineProperty(Z[t], "channels", {
        value: Y[t].channels
    }), Object.defineProperty(Z[t], "labels", {
        value: Y[t].labels
    });
    var i = J(t);
    Object.keys(i).forEach((function(e) {
        var s = i[e];
        Z[t][e] = function(t) {
            var i = function(i) {
                if (null == i) return i;
                arguments.length > 1 && (i = Array.prototype.slice.call(arguments));
                var e = t(i);
                if ("object" == typeof e) for (var s = e.length, n = 0; n < s; n++) e[n] = Math.round(e[n]);
                return e;
            };
            return "conversion" in t && (i.conversion = t.conversion), i;
        }(s), Z[t][e].raw = function(t) {
            var i = function(i) {
                return null == i ? i : (arguments.length > 1 && (i = Array.prototype.slice.call(arguments)), 
                t(i));
            };
            return "conversion" in t && (i.conversion = t.conversion), i;
        }(s);
    }));
}));

var K = F, Q = Z, tt = [].slice, it = [ "keyword", "gray", "hex" ], et = {};

Object.keys(Q).forEach((function(t) {
    et[tt.call(Q[t].labels).sort().join("")] = t;
}));

var st = {};

function nt(t, i) {
    if (!(this instanceof nt)) return new nt(t, i);
    if (i && i in it && (i = null), i && !(i in Q)) throw new Error("Unknown model: " + i);
    var e, s;
    if (null == t) this.model = "rgb", this.color = [ 0, 0, 0 ], this.valpha = 1; else if (t instanceof nt) this.model = t.model, 
    this.color = t.color.slice(), this.valpha = t.valpha; else if ("string" == typeof t) {
        var n = K.get(t);
        if (null === n) throw new Error("Unable to parse color from string: " + t);
        this.model = n.model, s = Q[this.model].channels, this.color = n.value.slice(0, s), 
        this.valpha = "number" == typeof n.value[s] ? n.value[s] : 1;
    } else if (t.length) {
        this.model = i || "rgb", s = Q[this.model].channels;
        var r = tt.call(t, 0, s);
        this.color = ot(r, s), this.valpha = "number" == typeof t[s] ? t[s] : 1;
    } else if ("number" == typeof t) t &= 16777215, this.model = "rgb", this.color = [ t >> 16 & 255, t >> 8 & 255, 255 & t ], 
    this.valpha = 1; else {
        this.valpha = 1;
        var h = Object.keys(t);
        "alpha" in t && (h.splice(h.indexOf("alpha"), 1), this.valpha = "number" == typeof t.alpha ? t.alpha : 0);
        var o = h.sort().join("");
        if (!(o in et)) throw new Error("Unable to parse color from object: " + JSON.stringify(t));
        this.model = et[o];
        var a = Q[this.model].labels, l = [];
        for (e = 0; e < a.length; e++) l.push(t[a[e]]);
        this.color = ot(l);
    }
    if (st[this.model]) for (s = Q[this.model].channels, e = 0; e < s; e++) {
        var c = st[this.model][e];
        c && (this.color[e] = c(this.color[e]));
    }
    this.valpha = Math.max(0, Math.min(1, this.valpha)), Object.freeze && Object.freeze(this);
}

function rt(t, i, e) {
    return (t = Array.isArray(t) ? t : [ t ]).forEach((function(t) {
        (st[t] || (st[t] = []))[i] = e;
    })), t = t[0], function(s) {
        var n;
        return arguments.length ? (e && (s = e(s)), (n = this[t]()).color[i] = s, n) : (n = this[t]().color[i], 
        e && (n = e(n)), n);
    };
}

function ht(t) {
    return function(i) {
        return Math.max(0, Math.min(t, i));
    };
}

function ot(t, i) {
    for (var e = 0; e < i; e++) "number" != typeof t[e] && (t[e] = 0);
    return t;
}

nt.prototype = {
    toString: function() {
        return this.string();
    },
    toJSON: function() {
        return this[this.model]();
    },
    string: function(t) {
        var i = this.model in K.to ? this : this.rgb(), e = 1 === (i = i.round("number" == typeof t ? t : 1)).valpha ? i.color : i.color.concat(this.valpha);
        return K.to[i.model](e);
    },
    percentString: function(t) {
        var i = this.rgb().round("number" == typeof t ? t : 1), e = 1 === i.valpha ? i.color : i.color.concat(this.valpha);
        return K.to.rgb.percent(e);
    },
    array: function() {
        return 1 === this.valpha ? this.color.slice() : this.color.concat(this.valpha);
    },
    object: function() {
        for (var t = {}, i = Q[this.model].channels, e = Q[this.model].labels, s = 0; s < i; s++) t[e[s]] = this.color[s];
        return 1 !== this.valpha && (t.alpha = this.valpha), t;
    },
    unitArray: function() {
        var t = this.rgb().color;
        return t[0] /= 255, t[1] /= 255, t[2] /= 255, 1 !== this.valpha && t.push(this.valpha), 
        t;
    },
    unitObject: function() {
        var t = this.rgb().object();
        return t.r /= 255, t.g /= 255, t.b /= 255, 1 !== this.valpha && (t.alpha = this.valpha), 
        t;
    },
    round: function(t) {
        return t = Math.max(t || 0, 0), new nt(this.color.map(function(t) {
            return function(i) {
                return function(t, i) {
                    return Number(t.toFixed(i));
                }(i, t);
            };
        }(t)).concat(this.valpha), this.model);
    },
    alpha: function(t) {
        return arguments.length ? new nt(this.color.concat(Math.max(0, Math.min(1, t))), this.model) : this.valpha;
    },
    red: rt("rgb", 0, ht(255)),
    green: rt("rgb", 1, ht(255)),
    blue: rt("rgb", 2, ht(255)),
    hue: rt([ "hsl", "hsv", "hsl", "hwb", "hcg" ], 0, (function(t) {
        return (t % 360 + 360) % 360;
    })),
    saturationl: rt("hsl", 1, ht(100)),
    lightness: rt("hsl", 2, ht(100)),
    saturationv: rt("hsv", 1, ht(100)),
    value: rt("hsv", 2, ht(100)),
    chroma: rt("hcg", 1, ht(100)),
    gray: rt("hcg", 2, ht(100)),
    white: rt("hwb", 1, ht(100)),
    wblack: rt("hwb", 2, ht(100)),
    cyan: rt("cmyk", 0, ht(100)),
    magenta: rt("cmyk", 1, ht(100)),
    yellow: rt("cmyk", 2, ht(100)),
    black: rt("cmyk", 3, ht(100)),
    x: rt("xyz", 0, ht(100)),
    y: rt("xyz", 1, ht(100)),
    z: rt("xyz", 2, ht(100)),
    l: rt("lab", 0, ht(100)),
    a: rt("lab", 1),
    b: rt("lab", 2),
    keyword: function(t) {
        return arguments.length ? new nt(t) : Q[this.model].keyword(this.color);
    },
    hex: function(t) {
        return arguments.length ? new nt(t) : K.to.hex(this.rgb().round().color);
    },
    rgbNumber: function() {
        var t = this.rgb().color;
        return (255 & t[0]) << 16 | (255 & t[1]) << 8 | 255 & t[2];
    },
    luminosity: function() {
        for (var t = this.rgb().color, i = [], e = 0; e < t.length; e++) {
            var s = t[e] / 255;
            i[e] = s <= .03928 ? s / 12.92 : Math.pow((s + .055) / 1.055, 2.4);
        }
        return .2126 * i[0] + .7152 * i[1] + .0722 * i[2];
    },
    contrast: function(t) {
        var i = this.luminosity(), e = t.luminosity();
        return i > e ? (i + .05) / (e + .05) : (e + .05) / (i + .05);
    },
    level: function(t) {
        var i = this.contrast(t);
        return i >= 7.1 ? "AAA" : i >= 4.5 ? "AA" : "";
    },
    isDark: function() {
        var t = this.rgb().color;
        return (299 * t[0] + 587 * t[1] + 114 * t[2]) / 1e3 < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    negate: function() {
        for (var t = this.rgb(), i = 0; i < 3; i++) t.color[i] = 255 - t.color[i];
        return t;
    },
    lighten: function(t) {
        var i = this.hsl();
        return i.color[2] += i.color[2] * t, i;
    },
    darken: function(t) {
        var i = this.hsl();
        return i.color[2] -= i.color[2] * t, i;
    },
    saturate: function(t) {
        var i = this.hsl();
        return i.color[1] += i.color[1] * t, i;
    },
    desaturate: function(t) {
        var i = this.hsl();
        return i.color[1] -= i.color[1] * t, i;
    },
    whiten: function(t) {
        var i = this.hwb();
        return i.color[1] += i.color[1] * t, i;
    },
    blacken: function(t) {
        var i = this.hwb();
        return i.color[2] += i.color[2] * t, i;
    },
    grayscale: function() {
        var t = this.rgb().color, i = .3 * t[0] + .59 * t[1] + .11 * t[2];
        return nt.rgb(i, i, i);
    },
    fade: function(t) {
        return this.alpha(this.valpha - this.valpha * t);
    },
    opaquer: function(t) {
        return this.alpha(this.valpha + this.valpha * t);
    },
    rotate: function(t) {
        var i = this.hsl(), e = i.color[0];
        return e = (e = (e + t) % 360) < 0 ? 360 + e : e, i.color[0] = e, i;
    },
    mix: function(t, i) {
        if (!t || !t.rgb) throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof t);
        var e = t.rgb(), s = this.rgb(), n = void 0 === i ? .5 : i, r = 2 * n - 1, h = e.alpha() - s.alpha(), o = ((r * h == -1 ? r : (r + h) / (1 + r * h)) + 1) / 2, a = 1 - o;
        return nt.rgb(o * e.red() + a * s.red(), o * e.green() + a * s.green(), o * e.blue() + a * s.blue(), e.alpha() * n + s.alpha() * (1 - n));
    }
}, Object.keys(Q).forEach((function(t) {
    if (-1 === it.indexOf(t)) {
        var i = Q[t].channels;
        nt.prototype[t] = function() {
            if (this.model === t) return new nt(this);
            if (arguments.length) return new nt(arguments, t);
            var e, s = "number" == typeof arguments[i] ? i : this.valpha;
            return new nt((e = Q[this.model][t].raw(this.color), Array.isArray(e) ? e : [ e ]).concat(s), t);
        }, nt[t] = function(e) {
            return "number" == typeof e && (e = ot(tt.call(arguments), i)), new nt(e, t);
        };
    }
}));

var at = _(nt);

const lt = "function" == typeof Object.assign, ct = [];

function ut(t) {
    if (lt) Object.assign.apply(Object, arguments); else for (let i = 1; i < arguments.length; i++) {
        const e = arguments[i];
        for (const i in e) t[i] = e[i];
    }
    return t;
}

function ft(t) {
    return null == t;
}

function dt(t) {
    return "number" == typeof t && !isNaN(t);
}

function mt(t) {
    return !ft(t) && ("function" == typeof t || null !== t.constructor && t.constructor === Function);
}

const gt = [];

function pt(t, i) {
    const e = i._get2DExtentAtRes(i.getGLRes()), s = e.getWidth(), n = e.getHeight(), r = t;
    l.identity(r);
    const h = c.copy(ct, i.cameraLookAt);
    return h[2] = 0, l.translate(r, r, h), l.scale(r, r, c.set(gt, s, n, 1)), r;
}

function wt(t, i) {
    return Object.prototype.hasOwnProperty.call(t, i);
}

function vt(t) {
    for (let i = 1; i < arguments.length; i++) {
        const e = arguments[i];
        if (e) for (let i = 0, s = e.length; i < s; i++) t.push(e[i]);
    }
    return t.length;
}

const _t = {};

function yt(t, i) {
    if (!Array.isArray(i)) {
        const t = i;
        i = _t[t] = _t[t] || at(i).unitArray();
    }
    for (let e = 0; e < i.length; e++) t[e] = i[e];
    return 3 === i.length && (t[3] = 1), t;
}

function bt(t, i) {
    if (!Array.isArray(i)) {
        const t = i;
        i = _t[t] = _t[t] || at(i).unitArray();
    }
    for (let e = 0; e < i.length; e++) t[e] = 255 * i[e];
    return 3 === t.length && t.push(255), t;
}

function xt(t, e, s = 0) {
    if (!(t && e instanceof i)) return null;
    const n = t.coordinateToPointAtRes(e, t.getGLRes());
    return [ n.x, n.y, s ];
}

const Mt = [ 0, 0 ], St = [ 0, 0, 0 ];

let Ct;

class kt {
    static getUniformDeclares() {
        const t = [], i = [];
        return i.push({
            name: "shadow_lightProjViewModelMatrix",
            type: "function",
            fn: function(i, e) {
                const s = e.shadow_lightProjViewMatrix, n = e.modelMatrix;
                return l.multiply(t, s, n);
            }
        }), i;
    }
    constructor(t, i) {
        this.renderer = new a.Renderer(t), this.i = .3, this.h = i, this.o();
    }
    resize() {
        const t = this.canvas;
        t.width = this.h.getRenderer().canvas.width, t.height = this.h.getRenderer().canvas.height;
    }
    o() {
        const t = (this.h.u() || {}).shadow || {}, i = this.m(), e = this.getDefines();
        this.p = new a.ShadowPass(this.renderer, {
            width: i,
            height: i,
            blurOffset: t.blurOffset,
            defines: e
        }), this.v = new a.ShadowDisplayShader(e), this._();
    }
    m() {
        let t = 2048;
        const i = ((this.h.u() || {}).shadow || {}).quality;
        return "medium" === i ? t = 1024 : "low" === i && (t = 512), t;
    }
    getDefines() {
        return {
            "HAS_SHADOWING": 1,
            "PACK_FLOAT": 1,
            "USE_ESM": 1
        };
    }
    render(t, i, e, s, n, r, h, o, a, u) {
        this.M();
        const f = this.h.getMap(), d = this.m();
        let m, g;
        if (u || d !== this.p.width || this.S(f, h, !!t)) {
            d !== this.p.width && this.p.resize(d, d), this.C = this.C || [], this.k = this.k || [];
            const s = l.multiply(this.C, i, e), n = c.normalize(this.k, r);
            Ct || (Ct = f.getContainerExtent());
            let o = f.height;
            f.getPitch() > 62 && (o = f._getVisualHeight(62));
            const a = Ct.set(0, f.height - o, f.width, f.height).convertTo((t => f._containerPointToPointAtRes(t, f.getGLRes()))).toArray();
            t && h.addMesh(this.T);
            const u = a.map((t => [ t.x, t.y, 0, 1 ])), {lightProjViewMatrix: p, shadowMap: w, blurFBO: v} = this.p.render(h, {
                cameraProjViewMatrix: s,
                lightDir: n,
                farPlane: u,
                cameraLookAt: f.cameraLookAt
            });
            m = this.O = p, g = this.A = w, this.I = v, this.L = h.getMeshes().reduce(((t, i) => (i.castShadow && i.geometry && (t[i.uuid] = {
                v0: i.version,
                v1: i.geometry.version
            }), t)), {}), this.P = {
                count: h.getMeshes().length - +!!t,
                displayShadow: !!t
            }, this.R = !0;
        } else m = this.O, g = this.A, this.R = !1;
        this.F = i, this.H = e, ft(n) && (n = 1), t && h.getMeshes().length && this.displayShadow(s, n, o, a);
        return {
            "shadow_lightProjViewMatrix": m,
            "shadow_shadowMap": g,
            "shadow_opacity": n,
            "shadow_color": s || St,
            "esm_shadow_threshold": this.i
        };
    }
    displayShadow(t, i, e, s) {
        const n = this.O, r = this.T, h = this.D || [], o = this.h.getRenderer().canvas, a = this.N = this.N || [];
        a[0] = o.width, a[1] = o.height, this.renderer.render(this.v, {
            "halton": e || Mt,
            "globalTexSize": a,
            "projMatrix": this.F,
            "viewMatrix": this.H,
            "shadow_lightProjViewModelMatrix": l.multiply(h, n, r.localTransform),
            "shadow_shadowMap": this.A,
            "esm_shadow_threshold": this.i,
            "shadow_opacity": i,
            "color": t || St
        }, this.G, s);
    }
    dispose() {
        this.p.dispose(), this.v.dispose(), this.T && (this.T.geometry.dispose(), this.T.dispose()), 
        delete this.renderer;
    }
    isUpdated() {
        return !1 !== this.R;
    }
    S(t, i, e) {
        if (!this.L) return !0;
        const s = this.P;
        if (i.getMeshes().length !== s.count || e !== s.displayShadow) return !0;
        const n = i.getMeshes();
        for (let t = 0; t < n.length; t++) {
            const i = this.L[n[t].uuid];
            if (n[t].castShadow && (n[t].hasSkinAnimation() || !i || i.v0 !== n[t].version || i.v1 !== n[t].geometry.version)) return !0;
        }
        return !1;
    }
    _() {
        const t = new a.Plane;
        t.generateBuffers(this.renderer.regl), this.T = new a.Mesh(t), this.G = new a.Scene([ this.T ]);
    }
    M() {
        const t = this.h.getMap(), i = pt(this.T.localTransform, t);
        this.T.setLocalTransform(i);
    }
}

const Tt = [ 0, 0 ], Ot = new t.Coordinate(0, 0), At = new t.Coordinate(0, 0), It = [], Et = [], Lt = [];

function Pt(t, i, e, s) {
    const n = t.getGLRes(), r = t.distanceToPointAtRes(i, i, n, e ? Ot : null, At);
    return s ? r.y : r.x;
}

const {getIBLResOnCanvas: Rt, logoutIBLResOnCanvas: Ft, getPBRUniforms: Ht, loginIBLResOnCanvas: Dt} = a.pbr.PBRUtils, Nt = [ 0, 0 ], Gt = [ 1, 1 ], jt = [], Bt = [], zt = [], Ut = [], Vt = [];

class Wt {
    static getGroundTransform(t, i) {
        return pt(t, i);
    }
    constructor(t, i) {
        this.j = t, this.renderer = new a.Renderer(t), this.h = i, this.B = new a.ResourceLoader, 
        this.U = (...t) => this.V.call(this, ...t), this.o();
        const e = this.getMap().getRenderer().canvas;
        Dt(e, t, this.getMap());
    }
    needToRedraw() {
        const t = this.W();
        return t && (t[0] || t[1]);
    }
    getMap() {
        return this.h && this.h.getMap();
    }
    getSymbol() {
        const t = this.h.getGroundConfig();
        return t && t.symbol;
    }
    isEnable() {
        const t = this.h.getGroundConfig();
        return t && t.enable;
    }
    paint(t) {
        if (!this.isEnable()) return !1;
        const i = this.q();
        if (this.$(t) && i === this.X) return !1;
        const e = this.Y(t);
        e && this.T.setDefines(e), this.T.material !== this.material && this.T.setMaterial(this.material);
        const s = this.h.getGroundConfig();
        (s && s.symbol).ssr ? this.T.ssr = 1 : this.T.ssr = 0, this.M();
        const n = this.J(t);
        n.offsetFactor = t.offsetFactor, n.offsetUnits = t.offsetUnits;
        const r = t && t.renderTarget && t.renderTarget.fbo;
        return i === this.X ? (this.renderer.render(i, n, this.G, r), this.h.getRenderer().setCanvasUpdated(), 
        !0) : (i.filter = t.sceneFilter, this.renderer.render(i, n, this.G, r), this.h.getRenderer().setCanvasUpdated(), 
        !0);
    }
    $(t) {
        return !(!this.h.getRenderer().isEnableSSR || !this.h.getRenderer().isEnableSSR()) && !(!t || !t.ssr);
    }
    update() {
        const t = this.h.getGroundConfig();
        if (!t) return;
        const i = t && t.symbol, e = t.urlModifier;
        if (i) {
            this.Z = this.K(i.polygonFill || [ 1, 1, 1, 1 ]), this.tt = void 0 === i.polygonOpacity ? 1 : i.polygonOpacity;
            const t = i.polygonPatternFile;
            if (t) {
                if (!this.it || this.it._pattern_src !== t) {
                    const i = new Image;
                    i.onload = () => {
                        this.it && this.it.destroy(), this.it = this.et(i), this.it._pattern_src = t, this.setToRedraw();
                    }, i.src = e && e(t) || t;
                }
            } else this.it && (this.it.destroy(), delete this.it);
        } else this.Z = [ 1, 1, 1, 1 ], this.tt = 1, this.it && (this.it.destroy(), delete this.it);
        this.st();
    }
    setToRedraw() {
        const t = this.h.getRenderer();
        t && t.setToRedraw();
    }
    dispose() {
        this.material && (this.material.dispose(), delete this.material), this.T && (this.T.geometry.dispose(), 
        this.T.material && this.T.material.dispose(), this.T.dispose(), delete this.T), 
        this.it && (this.it.destroy(), delete this.it), this.X && (this.X.dispose(), delete this.X), 
        this.nt && (this.nt.dispose(), delete this.nt), this.rt();
    }
    q() {
        const t = this.h.getGroundConfig();
        if (!t || !t.renderPlugin) return this.X;
        const i = t.renderPlugin.type;
        if ("lit" === i) return this.nt;
        if ("fill" === i) return this.X;
        throw new Error("unsupported render plugin of " + i + " for layer ground");
    }
    J(t) {
        const i = this.ht(t);
        i.polygonFill = this.Z, i.polygonOpacity = this.tt;
        return this.q() === this.X && this.it && (i.polygonPatternFile = this.it), i;
    }
    ht(t) {
        let i;
        if ("lit" === this.h.getGroundConfig().renderPlugin.type) {
            const e = this.getMap().getRenderer().canvas, {iblTexes: s, dfgLUT: n} = Rt(e);
            i = Ht(this.getMap(), s, n, t && t.ssr, t && t.jitter);
        } else {
            i = {
                projViewMatrix: this.getMap().projViewMatrix
            };
        }
        return this.ot(i, t), i;
    }
    ot(t, i) {
        const e = i && i.includes;
        if (e) for (const s in e) e[s] && i[s].renderUniforms && ut(t, i[s].renderUniforms);
    }
    rt() {
        const t = this.getMap().getRenderer().canvas;
        Ft(t, this.getMap());
    }
    o() {
        const t = this.lt(), i = kt.getUniformDeclares(), e = [];
        i.push({
            name: "projViewModelMatrix",
            type: "function",
            fn: function(t, i) {
                return l.multiply(e, i.projViewMatrix, i.modelMatrix);
            }
        }), this.X = new a.MeshShader({
            vert: "attribute vec3 aPosition;\nuniform mat4 projViewModelMatrix;\nuniform mat4 modelMatrix;\n#ifdef HAS_PATTERN\n    attribute vec2 aTexCoord;\n    uniform vec2 uvScale;\n    uniform vec2 uvOffset;\n    varying vec2 vTexCoord;\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n    #include <vsm_shadow_vert>\n#endif\nvoid main () {\n    #ifdef HAS_PATTERN\n        vTexCoord = aTexCoord * uvScale + uvOffset;\n    #endif\n    vec3 position = vec3(aPosition);\n    gl_Position = projViewModelMatrix * vec4(position, 1.0);\n    #if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n        shadow_computeShadowPars(vec4(position, 1.0));\n    #endif\n}",
            frag: "precision mediump float;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n    #include <vsm_shadow_frag>\n#endif\n#ifdef HAS_PATTERN\n    uniform sampler2D polygonPatternFile;\n    varying vec2 vTexCoord;\n#endif\nuniform vec4 polygonFill;\nuniform float polygonOpacity;\nvoid main() {\n    #ifdef HAS_PATTERN\n        vec4 color = texture2D(polygonPatternFile, vTexCoord);\n    #else\n        vec4 color = polygonFill;\n    #endif\n    gl_FragColor = color * polygonOpacity;\n    #if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n        float shadowCoeff = shadow_computeShadow();\n        gl_FragColor.rgb = shadow_blend(gl_FragColor.rgb, shadowCoeff);\n    #endif\n}",
            uniforms: i,
            extraCommandProps: t
        });
        const s = kt.getUniformDeclares();
        s.push(...a.SsrPass.getUniformDeclares()), this.nt = new a.pbr.StandardShader({
            uniforms: s,
            extraCommandProps: t
        }), this._(), this.update();
    }
    lt() {
        const t = [ 0, 1 ], i = this.h.getRenderer().canvas;
        return {
            viewport: {
                x: 0,
                y: 0,
                width: () => i.width,
                height: () => i.height
            },
            cull: {
                enable: !0
            },
            depth: {
                enable: !0,
                mask: () => {
                    const t = this.h.getGroundConfig();
                    return t.depth || void 0 === t.depth;
                },
                range: () => {
                    const i = this.h.getGroundConfig(), e = i && i.renderPlugin.sceneConfig;
                    return e && e.depthRange || t;
                },
                func: "<="
            },
            blend: {
                enable: !0,
                func: {
                    src: "src alpha",
                    dst: "one minus src alpha"
                },
                equation: "add"
            },
            polygonOffset: {
                enable: !0,
                offset: {
                    factor: (t, i) => i.offsetFactor,
                    units: (t, i) => i.offsetUnits
                }
            }
        };
    }
    ct() {
        const t = this.getMap().getLightManager();
        return !!(t && t.getAmbientResource());
    }
    _() {
        const t = new a.Plane;
        t.data.aTexCoord = new Uint8Array([ 0, 0, 1, 0, 0, 1, 1, 1 ]), t.createTangent(), 
        t.generateBuffers(this.renderer.regl), this.T = new a.Mesh(t, null, {
            castShadow: !1
        });
        const i = this.nt.getGeometryDefines(t);
        this.T.setDefines(i), this.G = new a.Scene([ this.T ]);
    }
    M() {
        const t = this.getMap(), i = Wt.getGroundTransform(this.T.localTransform, t);
        this.T.setLocalTransform(i);
        const e = t.getGLRes(), s = t._get2DExtentAtRes(e), n = s.getWidth(), r = s.getHeight(), h = t.cameraLookAt, o = h[0] - n, a = h[1] - r, l = this.it ? this.it.width / this.it.height : 1, c = this.getSymbol(), f = this.material ? this.material.get("textureOrigin") : c.polygonPatternFileOrigin, d = !!(this.material ? this.material.get("uvOffsetInMeter") : c.uvOffsetInMeter), m = (this.material ? this.material.get("uvOffset") : c.uvOffset) || Nt, g = this.material && this.material.get("uvScale") || Gt, p = this.material ? this.material.get("textureWidth") : c.polygonPatternFileWidth, w = this.material ? p * (g[1] / g[0]) : c.polygonPatternFileHeight, v = this.W(), [_, y, b, x, M] = function(t, i, e, s, n, r, h, o, a, l, c) {
            const f = t.getGLRes();
            s && (Ot.set(s[0], s[1]), t.coordToPointAtRes(Ot, f, At), i -= At.x, e -= At.y);
            const d = s ? Ot : null;
            l = u.copy(Et, l);
            const m = !a && l || Tt;
            let g = a && l || Tt;
            g = u.copy(It, g), g[0] && (g[0] = Pt(t, g[0], d)), g[1] && (g[1] = Pt(t, g[1], d, 1));
            let p = .5;
            n && (p = Pt(t, n, d));
            let w = p / h;
            if (r && (w = Pt(t, r, d, 1)), c && (c[0] || c[1])) {
                const i = performance.now() / 1e3;
                let e = c[0], s = c[1];
                a && (e = -Pt(t, c[0], d), s = -Pt(t, c[1], d, 1)), c[0] && (a ? g[0] = i * e : m[0] = i * e), 
                c[1] && (a ? g[1] = i * s : m[1] = i * s);
            }
            const v = (i + g[0]) / (p / o[0]), _ = (e - g[1]) / (w / o[1]);
            return Lt[0] = p / o[0], Lt[1] = w / o[1], Lt[2] = v, Lt[3] = _, Lt[4] = m, Lt;
        }(t, o, a, f, p, w, l, g, d, m, v), S = 2 * s.getWidth() / _, C = 2 * s.getHeight() / y;
        if (!this.material) return this.T.setUniform("uvScale", u.set(jt, S, C)), void this.T.setUniform("uvOffset", u.set(Bt, b % 1 + M[0], x % 1 + M[1]));
        this.T.setUniform("uvScale", u.set(Vt, S, C)), this.T.setUniform("uvOffset", u.set(zt, b % 1 + M[0], x % 1 + M[1])), 
        this.T.setUniform("uvOrigin", u.set(Ut, b - b % 1, x - x % 1)), this.T.setUniform("uvRotation", 0);
    }
    Y(t) {
        let i = !1;
        const e = this.T.defines, s = this.h.u && this.h.u(), n = this.h.getGroundConfig();
        function r(t, s) {
            t ? e[s] || (e[s] = 1, i = !0) : e[s] && (delete e[s], i = !0);
        }
        r(this.ct(), "HAS_IBL_LIGHTING");
        r(t && t.ssr && n && n.symbol && n.symbol.ssr, "HAS_SSR");
        const h = t && s && s.shadow && s.shadow.enable;
        r(h, "HAS_SHADOWING"), r(h, "USE_ESM");
        return r(!!this.it, "HAS_PATTERN"), i ? e : null;
    }
    st() {
        const t = this.getSymbol() && this.getSymbol().material;
        if (!t) return;
        const i = {};
        let e = !1;
        const s = this.h.getGroundConfig();
        this.B.setURLModifier(s.urlModifier);
        for (const s in t) if (wt(t, s)) if (s.indexOf("Texture") > 0) {
            let n = t[s];
            if (!n) continue;
            n = "string" == typeof n ? {
                url: n,
                wrap: "repeat"
            } : n, n.flipY = !0, n.min = "linear mipmap linear", n.mag = "linear", n.flipY = !0, 
            i[s] = new a.Texture2D(n, this.B), e = !0;
        } else i[s] = t[s];
        this.material ? (this.ut = new a.pbr.StandardMaterial(i), this.ut.isReady() ? this.V() : this.ut.once("complete", this.U)) : (this.material = new a.pbr.StandardMaterial(i), 
        this.material.once("complete", this.U, this)), e || this.V();
    }
    V() {
        this.ut && (this.material.dispose(), this.material = this.ut, delete this.ut), this.setToRedraw(!0);
    }
    et(t) {
        t = a.Util.resizeToPowerOfTwo(t);
        const i = this.j, e = {
            width: t.width,
            height: t.height,
            data: t,
            mag: "linear",
            min: "linear mipmap linear",
            flipY: !0,
            wrap: "repeat"
        };
        return i.texture(e);
    }
    K(t) {
        return yt([], t);
    }
    W() {
        return this.material && this.material.get("uvOffsetAnim");
    }
    getRenderMeshes() {
        return this.G.getMeshes();
    }
}

const {createIBLTextures: qt, disposeIBLTextures: $t} = a.pbr.PBRUtils, Xt = [ 0, 0, 0 ], Yt = [], Jt = [];

class Zt {
    constructor(t, i) {
        this.ft = 4, this.j = t, this.renderer = new a.Renderer(t), this.h = i, this.o(), 
        this.dt();
    }
    paint(t) {
        if (!this.isEnable() || !this.gt) return;
        const i = this.J(t), e = t && t.renderTarget && t.renderTarget.fbo;
        this.renderer.render(this.wt, i, null, e);
    }
    update() {
        const t = this.getMap();
        if (!t || !this.isEnable()) return;
        const i = t.getLightManager(), e = i && i.getAmbientResource();
        e !== this.gt && this.vt && ($t(this.vt), delete this.vt), this.gt = e, this.dt();
    }
    dispose() {
        this.wt.dispose(), $t(this.vt), delete this.wt, delete this.vt, delete this.gt;
    }
    getMap() {
        return this.h.getMap();
    }
    dt() {
        if (!this.gt) return;
        const t = this.h.u().environment || {};
        this.wt.setMode(t.toneMapping, t.mode ? 1 : 0);
    }
    isEnable() {
        const t = this.h.u();
        return this.ct() && t && t.environment && t.environment.enable;
    }
    ct() {
        const t = this.getMap().getLightManager();
        return !!(t && t.getAmbientResource());
    }
    J() {
        const t = this.getMap(), i = this.getMap().getLightManager(), e = i && i.getAmbientLight();
        let s = this.vt;
        s || (s = this.vt = qt(this.j, t));
        const n = this.h.getRenderer().canvas, r = this.h.u().environment || {}, h = r.level || 0, o = s.prefilterMap.width, a = this._t = this._t || [], l = e && e.hsv || Xt, u = r.brightness || 0, d = r.intensity || 1;
        return c.copy(Yt, l), u && (Yt[2] += u), Jt[0] = n.width, Jt[1] = n.height, {
            "cubeMap": s.prefilterMap,
            "bias": h,
            "size": o / Math.pow(2, Math.max(0, h - 1)),
            "environmentExposure": dt(e && e.exposure) ? e.exposure : 1,
            "backgroundIntensity": d,
            "diffuseSPH": s.sh,
            "viewMatrix": t.viewMatrix,
            "projMatrix": t.projMatrix,
            "resolution": Jt,
            "hsv": Yt,
            "transformMatrix": f.fromRotation(a, e && Math.PI / 180 * -e.orientation || 0)
        };
    }
    o() {
        const t = this.getMap();
        if (t.on("updatelights", this.update, this), this.wt = new a.SkyboxShader, t.options.lights) {
            const t = this.getMap().getLightManager().getAmbientResource();
            this.gt = t;
        }
    }
}

const Kt = [], Qt = [ .03, .03, .03 ], ti = [], ii = [], ei = [], si = [ 1, 1, 1 ], ni = [ -1200, -1200, 0 ], ri = [ 1200, 1200, 1e3 ], hi = {
    min: [],
    max: []
}, oi = l.fromRotationTranslation([], d.fromEuler([], 90, 0, 0), [ 0, 0, 0 ]);

class ai {
    constructor(t, i) {
        this.j = t, this.renderer = new a.Renderer(t), this.h = i, this.yt = new li, this.o();
    }
    getMap() {
        return this.h && this.h.getMap();
    }
    o() {
        const t = this.h.getRenderer().canvas, i = {
            x: 0,
            y: 0,
            width: () => t.width,
            height: () => t.height
        };
        this.wt = new a.MeshShader({
            vert: "attribute vec3 aPosition;\nattribute vec3 aNormal;\nattribute vec2 aTexCoord;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nuniform vec3 cameraPosition;\nuniform float top;\nuniform float bottom;\nuniform float time;\nvarying vec2 vTexCoord;\n#include <get_output>\nfloat angle(float x, float y){\n    return atan(y, x);\n}\nvec2 getFoot(vec2 camera, vec2 normal, vec2 pos) {\n    vec2 position = vec2(0.0, 0.0);\n    float distanceLen = distance(pos, normal);\n    float a = angle(camera.x - normal.x, camera.y - normal.y);\n    pos.x > normal.x ? a -= 0.785 : a += 0.785;\n    position.x = cos(a) * distanceLen;\n    position.y = sin(a) * distanceLen;\n    return position + normal;\n    return position;\n}\nvoid main()\n{\n    vec4 localPosition = getPosition(aPosition);\n    mat4 localPositionMatrix = getPositionMatrix();\n    vec2 foot = getFoot(vec2(cameraPosition.x, cameraPosition.z), vec2(aNormal.x, aNormal.z), vec2(localPosition.x, localPosition.z));\n    float height = top - bottom;\n    float y = aNormal.y - bottom - height * time;\n    y = y + (y < 0.0 ? height : 0.0);\n    float ratio = (1.0 - y / height) * (1.0 - y / height);\n    y = height * (1.0 - ratio);\n    y += bottom;\n    y += aPosition.y - aNormal.y;\n    localPosition = vec4( foot.x, y, foot.y , 1.0);\n    gl_Position = projMatrix * modelViewMatrix * localPositionMatrix * localPosition;\n    vTexCoord = aTexCoord;\n}",
            frag: "precision mediump float;\nvarying vec2 vTexCoord;\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D rainMap;\nvoid main() {\n    vec4 rainColor = texture2D(rainMap, vTexCoord);\n    vec4 diffuseColor = vec4(diffuse, opacity);\n    diffuseColor *= rainColor;\n    gl_FragColor = diffuseColor;\n}",
            uniforms: [ {
                name: "modelViewMatrix",
                type: "function",
                fn: function(t, i) {
                    return l.multiply(Kt, i.viewMatrix, i.modelMatrix);
                }
            } ],
            extraCommandProps: {
                viewport: i,
                depth: {
                    enable: !0,
                    mask: !1,
                    func: "less",
                    range: [ 0, 1 ]
                },
                blend: {
                    enable: !0,
                    func: {
                        src: "src alpha",
                        dst: "one minus src alpha"
                    },
                    equation: "add"
                }
            }
        }), this.bt();
    }
    bt() {
        const t = this.j.texture({
            width: 2,
            height: 2
        });
        if (this.xt = this.Mt(), !this.xt) return;
        this.St = new a.Scene(this.xt);
        const i = this.Ct();
        i.rainTexture ? this.kt(i.rainTexture).then((t => {
            this.xt.material.set("rainMap", t);
        })) : (this.xt.material.set("rainMap", t), console.warn("should set rain texture."));
    }
    Mt() {
        const t = this.getMap(), i = this.Ct();
        if (!i) return null;
        this.Tt = t.getZoom();
        const e = this.Ot(), s = this.At = i.density, n = this.It = i.rainWidth || 1, r = this.Et = i.rainHeight || 1, h = [], o = [], l = [], c = [];
        for (let t = 0; t < s; t++) {
            const i = {};
            i.x = Math.random() * (e.max[0] - e.min[0]) + e.min[0], i.y = Math.random() * (e.max[2] - e.min[2]) + e.min[2], 
            i.z = Math.random() * (e.max[1] - e.min[1]) + e.min[1];
            const s = (e.max[2] - e.min[2]) / 37.5 * r, a = s / 3 * n;
            h.push(i.x + a, i.y + s, i.z, i.x - a, i.y + s, i.z, i.x - a, i.y, i.z, i.x + a, i.y, i.z), 
            o.push(i.x, i.y - s / 2, i.z, i.x, i.y - s / 2, i.z, i.x, i.y - s / 2, i.z, i.x, i.y - s / 2, i.z), 
            l.push(1, 1, 0, 1, 0, 0, 1, 0), c.push(4 * t + 0, 4 * t + 1, 4 * t + 2, 4 * t + 0, 4 * t + 2, 4 * t + 3);
        }
        const u = {};
        u.POSITION = h, u.NORMAL = o, u.TEXCOORD_0 = l;
        const f = new a.Geometry(u, c, 0, {
            primitive: "triangles",
            positionAttribute: "POSITION",
            normalAttribute: "NORMAL",
            uv0Attribute: "TEXCOORD_0"
        });
        f.generateBuffers(this.renderer.regl);
        const d = new a.Material({
            rainMap: this.j.texture({
                width: 2,
                height: 2
            }),
            diffuse: i.color || [ 1, 1, 1 ],
            opacity: i.opacity || 1
        }), m = new a.Mesh(f, d);
        return m.setUniform("top", e.max[2]), m.setUniform("bottom", e.min[2]), this.Lt(m), 
        m.transparent = !0, m;
    }
    kt(t) {
        const i = new Image;
        return i.src = this.Pt = t, new Promise(((t, e) => {
            i.onload = () => {
                const e = this.j.texture({
                    mag: "linear",
                    min: "linear mipmap nearest",
                    wrapS: "clamp",
                    wrapT: "clamp",
                    data: i
                });
                t(e);
            }, i.onerror = t => {
                e(t);
            };
        }));
    }
    paint(t) {
        if (!this.St) return;
        const i = this.Ct(), e = {}, s = this.getMap();
        e.projMatrix = s.projMatrix, e.viewMatrix = s.viewMatrix, e.cameraPosition = s.cameraPosition;
        const n = i.speed || 1, r = this.yt.getElapsedTime() / (2 / n) % 1;
        e.time = r, this.xt.material.set("diffuse", i.color || si), this.xt.material.set("opacity", i.opacity || 1), 
        this.Lt(this.xt);
        const h = t && t.renderTarget && t.renderTarget.fbo;
        this.renderer.render(this.wt, e, this.St, h), this.h.getRenderer().setCanvasUpdated();
    }
    Lt(t) {
        const i = this.getMap(), e = i.coordinateToPointAtRes(i.getCenter(), i.getGLRes()), s = i.getGLScale() / i.getGLScale(this.Tt), n = c.set(ii, s, s, s), r = c.multiply(n, Qt, n), h = l.identity(ei), o = this.Ct(), a = i.getBearing();
        l.fromRotationTranslationScale(h, d.fromEuler(ti, o.windDirectionX || 0, o.windDirectionY || 0, 90 - a), [ e.x, e.y, 0 ], r), 
        l.multiply(h, h, oi), t.setLocalTransform(h);
    }
    setToRedraw() {
        const t = this.h.getRenderer();
        t && t.setToRedraw();
    }
    update() {
        const t = this.Ct();
        if (t) {
            if (this.xt || this.bt(), t.density !== this.At || t.rainWidth !== this.It || t.rainHeight !== this.Et) {
                const t = this.xt.material.get("rainMap");
                this.xt.geometry.dispose(), this.xt.dispose(), this.St.clear(), this.xt = this.Mt(), 
                this.xt.material.set("rainMap", t), this.St.setMeshes(this.xt);
            }
            t.rainTexture !== this.Pt && this.kt(t.rainTexture).then((t => {
                this.xt.material.set("rainMap", t);
            }));
        }
    }
    dispose() {
        this.xt && (this.xt.geometry.dispose(), this.xt.material && this.xt.material.dispose(), 
        this.xt.dispose(), delete this.xt), this.wt && (this.wt.dispose(), delete this.wt);
    }
    isEnable() {
        const t = this.Ct();
        return t && t.enable;
    }
    Ct() {
        const t = this.h.getWeatherConfig();
        return t && t.rain;
    }
    Ot() {
        const t = 16.685648411389433 - this.getMap().getZoom();
        return c.scale(hi.min, ni, Math.pow(2, t)), c.scale(hi.max, ri, Math.pow(2, t)), 
        hi;
    }
}

class li {
    constructor(t) {
        this.autoStart = void 0 === t || t, this.startTime = 0, this.oldTime = 0, this.elapsedTime = 0, 
        this.running = !1;
    }
    start() {
        this.startTime = ("undefined" == typeof performance ? Date : performance).now(), 
        this.oldTime = this.startTime, this.elapsedTime = 0, this.running = !0;
    }
    stop() {
        this.getElapsedTime(), this.running = !1, this.autoStart = !1;
    }
    getElapsedTime() {
        return this.getDelta(), this.elapsedTime;
    }
    getDelta() {
        let t = 0;
        if (this.autoStart && !this.running) return this.start(), 0;
        if (this.running) {
            const i = ("undefined" == typeof performance ? Date : performance).now();
            t = (i - this.oldTime) / 1e3, this.oldTime = i, this.elapsedTime += t;
        }
        return 0;
    }
}

const ci = [], ui = [ .03, .03, .03 ], fi = [], di = [], mi = [], gi = l.fromRotationTranslation([], d.fromEuler([], 90, 0, 0), [ 0, 0, 0 ]);

class pi {
    constructor(t, i) {
        this.j = t, this.h = i, this.o();
    }
    o() {
        const t = this.h.getRenderer().canvas, i = {
            x: 0,
            y: 0,
            width: () => t.width,
            height: () => t.height
        };
        this.wt = new a.MeshShader({
            vert: "#include <gl2_vert>\nattribute vec3 aPosition;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\n#include <get_output>\nvoid main()\n{\n    mat4 localPositionMatrix = getPositionMatrix();\n    vec4 localPosition = getPosition(aPosition);\n    gl_Position = projMatrix * modelViewMatrix * localPositionMatrix * localPosition;\n    vTexCoord = aTexCoord;\n}",
            frag: "#if __VERSION__ == 100\n  #ifdef GL_OES_standard_derivatives\n    #extension GL_OES_standard_derivatives : enable\n  #endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nprecision mediump float;\nuniform sampler2D perlinTexture;\nvarying vec2 vTexCoord;\nfloat lerp(float a, float b, float w) {\n    return a + w * (b - a);\n}\nvoid main() {\n    float snowIntense = texture2D(perlinTexture, vTexCoord).r;\n    vec3 fixedC = vec3(1.0, 1.0, 1.0);\n    float r = lerp(0.5, fixedC.x, snowIntense);\n    float g = lerp(0.5, fixedC.y, snowIntense);\n    float b = lerp(0.5, fixedC.z, snowIntense);\n    glFragColor = vec4(r, g, b, 1.0);\n    #if __VERSION__ == 100\n        gl_FragColor = glFragColor;\n    #endif\n}",
            uniforms: [ {
                name: "modelViewMatrix",
                type: "function",
                fn: function(t, i) {
                    return l.multiply(ci, i.viewMatrix, i.modelMatrix);
                }
            } ],
            extraCommandProps: {
                viewport: i
            }
        }), this.wt.version = 300, this.St = new a.Scene, this.Rt = this.Ft(), this.St.setMeshes(this.Rt), 
        this.renderer = new a.Renderer(this.j);
        const e = this.Ht();
        e && (e.snowGroundTexture ? this.Dt(e.snowGroundTexture) : (this.Nt = this.j.texture({
            width: 2,
            height: 2
        }), console.warn("should set snow ground texture.")));
    }
    render(t) {
        this.Nt && this.Rt.material.set("perlinTexture", this.Nt);
        const i = this.h.getMap();
        this.Gt(i);
        const e = {
            projMatrix: i.projMatrix,
            viewMatrix: i.viewMatrix,
            cameraPosition: i.cameraPosition
        }, s = t && t.renderTarget && t.renderTarget.fbo;
        this.renderer.render(this.wt, e, this.St, s), this.h.getRenderer().setCanvasUpdated();
    }
    Gt(t) {
        const i = t.coordinateToPointAtRes(t.getCenter(), t.getGLRes()), e = t.getGLScale() / t.getGLScale(this.Tt), s = c.set(di, e, e, e), n = c.multiply(s, ui, s), r = l.identity(mi);
        l.fromRotationTranslationScale(r, d.fromEuler(fi, 0, 0, 0), [ i.x, i.y, .005 ], n), 
        l.multiply(r, r, gi), this.Rt.setLocalTransform(r);
    }
    Dt(t) {
        const i = new Image;
        i.onload = () => {
            this.Nt = this.j.texture({
                mag: "linear",
                min: "linear mipmap nearest",
                wrapS: "repeat",
                wrapT: "repeat",
                data: i
            });
        }, i.onerror = t => {
            console.log(t);
        }, i.src = this.jt = t;
    }
    Ft() {
        const t = this.h.getMap();
        this.Tt = t.getZoom();
        const i = 16e3 * Math.pow(2, 16.685648411389433 - this.Tt), e = [ -i, 0, -i, i, 0, -i, -i, 0, i, i, 0, i ], s = {};
        s.POSITION = e, s.NORMAL = [ 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0 ], s.TEXCOORD_0 = [ 0, 0, 1, 0, 0, 1, 1, 1 ];
        const n = new a.Geometry(s, [ 3, 1, 0, 0, 2, 3 ], 0, {
            positionAttribute: "POSITION",
            normalAttribute: "NORMAL",
            uv0Attribute: "TEXCOORD_0"
        });
        n.generateBuffers(this.j);
        const r = new a.Material({
            perlinTexture: this.j.texture({
                with: 2,
                height: 2
            })
        });
        return new a.Mesh(n, r);
    }
    getMeshes() {
        return this.Rt;
    }
    dispose() {
        this.Rt && (this.Rt.geometry.dispose(), this.Rt.material && this.Rt.material.dispose(), 
        this.Rt.dispose(), delete this.Rt), this.wt && (this.wt.dispose(), delete this.wt);
    }
    update() {
        const t = this.Ht();
        t && t.snowGroundTexture === !this.jt && this.Dt(t.snowGroundTexture);
    }
    isEnable() {
        const t = this.Ht();
        return t && t.enable;
    }
    Ht() {
        const t = this.h.getWeatherConfig();
        return t && t.snow;
    }
}

const wi = [];

class vi {
    constructor(t, i, e) {
        this.j = t, this.h = i, this.Bt = e, this.o();
    }
    o() {
        this.renderer = new a.Renderer(this.j);
        const t = this.h.getRenderer(), i = this.zt = {
            x: 0,
            y: 0,
            width: () => t.canvas ? t.canvas.width : 1,
            height: () => t.canvas ? t.canvas.height : 1
        };
        this.Ut = i.width, this.Vt = i.height, this.Wt = this.j.framebuffer({
            color: this.j.texture({
                width: t.canvas ? t.canvas.width : 1,
                height: t.canvas ? t.canvas.height : 1,
                wrap: "clamp",
                mag: "linear",
                min: "linear"
            }),
            depth: !0
        }), this.EMPTY_TEXTURE = this.j.texture({
            with: 2,
            height: 2
        }), this.qt = new ai(this.j, this.h), this.$t = new a.RainRipplesPass(this.j, i), 
        this.Xt = new pi(this.j, this.h), this.Yt = new a.FogPass(this.j, i, this.h), this.Jt = new a.FogShader, 
        this.Jt.version = 300;
    }
    getMap() {
        return this.h && this.h.getMap();
    }
    renderScene(t) {
        this.renderSnowMask(t), this.renderRain(t);
    }
    renderRain(t) {
        this.isEnableRain() && this.qt.paint(t);
    }
    renderSnowMask(t) {
        if (!this.isEnableSnow() || !this.Zt()) return;
        const i = this.getMap();
        this.Xt.render(t, i);
    }
    paint(t, i) {
        if (!i || !i.length) return t;
        this.Kt();
        const e = this.h.getWeatherConfig(), s = {};
        if (this.isEnableRain() ? (s.ripplesMap = this.Qt(), this.Jt.shaderDefines.HAS_RAIN = 1) : delete this.Jt.shaderDefines.HAS_RAIN, 
        this.isEnableSnow() ? (this.Jt.shaderDefines.HAS_SNOW = 1, s.snowIntensity = a.Util.isNumber(e.snow.snowIntensity) ? e.snow.snowIntensity : .5, 
        i.forEach((t => {
            t.defines.HAS_SNOW = 1;
        }))) : (delete this.Jt.shaderDefines.HAS_SNOW, i.forEach((t => {
            delete t.defines.HAS_SNOW;
        }))), this.isEnableFog()) {
            const t = e.fog;
            s.fogColor = t.color || [ .9, .9, .9 ], this.Jt.shaderDefines.HAS_FOG = 1;
        } else delete this.Jt.shaderDefines.HAS_FOG;
        return this.Jt.setDefines(this.Jt.shaderDefines), s.mixFactorMap = this.ti(i) || this.EMPTY_TEXTURE, 
        s.sceneMap = t, s.time = this.ii() / 1e3, s.resolution = u.set(wi, this.Wt.width, this.Wt.height), 
        this.renderer.render(this.Jt, s, null, this.Wt), this.ei = i, this.Wt;
    }
    ti(t) {
        const i = {}, e = this.getMap(), s = e.getZoom(), n = Math.pow(2, 16.685648411389433 - s), r = this.h.getWeatherConfig(), h = r.fog;
        if (!h || !h.enable) return null;
        const o = h.start || .1, a = h.end || 100;
        i.projMatrix = e.projMatrix, i.viewMatrix = e.viewMatrix, i.cameraPosition = e.cameraPosition, 
        i.fogDist = [ o * n, a * n ], i.rainDepth = e.altitudeToPoint(r.rain && r.rain.rainDepth || .1, e.getGLRes());
        const l = this.Yt.render(t, i);
        return this.h.getRenderer().si(l);
    }
    Qt() {
        const t = this.getMap(), i = this.h.getWeatherConfig(), e = i.rain.rippleRadius || 24, s = {};
        s.projMatrix = t.projMatrix, s.viewMatrix = t.viewMatrix, s.time = this.ii() / 1e3, 
        s.rippleRadius = e, s.density = i.rain.density || 2e3;
        return this.$t.render(t, s);
    }
    ii() {
        if (!this.h) return 0;
        if (void 0 === this.ni && (this.ni = 0), this.isPlaying()) {
            const t = this.h.getRenderer();
            this.ni = t.getFrameTime();
        }
        return this.ni;
    }
    isEnable() {
        const t = this.h.getWeatherConfig();
        return t && t.enable;
    }
    isEnableRain() {
        const t = this.h.getWeatherConfig();
        return t && t.enable && t.rain && t.rain.enable;
    }
    isEnableFog() {
        const t = this.h.getWeatherConfig();
        return t && t.enable && t.fog && t.fog.enable;
    }
    isEnableSnow() {
        const t = this.h.getWeatherConfig();
        return t && t.enable && t.snow && t.snow.enable;
    }
    Zt() {
        const t = this.h.getWeatherConfig();
        return this.isEnableSnow() && !1 === t.snow.showGround;
    }
    isPlaying() {
        const t = this.h.getWeatherConfig();
        return !!t && !1 !== t.playing;
    }
    ri() {
        return this.isEnableRain() || this.isEnableFog() || this.isEnableSnow();
    }
    update() {
        !this.isEnable() && this.ei && this.ei.forEach((t => {
            delete t.defines.HAS_SNOW, delete t.defines.HAS_RAIN, delete t.defines.HAS_FOG;
        })), this.isEnableRain() && (this.qt = this.qt || new ai(this.j, this.h), this.qt.update()), 
        this.isEnableSnow() && (this.Xt = this.Xt || new pi(this.j, this.h), this.Xt.update());
    }
    getShadowMeshes() {
        return this.Xt.getMeshes();
    }
    Kt() {
        const t = this.Ut(), i = this.Vt();
        !this.Wt || this.Wt.width === t && this.Wt.height === i || this.Wt.resize(t, i);
    }
    dispose() {
        this.Wt && this.Wt.destroy(), this.Jt && (this.Jt.dispose(), delete this.Jt), this.qt && (this.qt.dispose(), 
        delete this.qt), this.Xt && (this.Xt.dispose(), delete this.Xt);
    }
}

const _i = [], yi = t => !!t.bloom, bi = t => !!t.ssr;

class xi {
    constructor(t, i) {
        this.j = t, this.h = i, this.hi = new a.Renderer(t), this.oi = new a.FxaaShader, 
        this.ai = new a.CopyShader, this.li = new a.SsrPass(this.j);
    }
    setContextIncludes() {}
    bloom(t, i, e, s, n, r, h) {
        this.ci || (this.ci = new a.BloomPass(this.j));
        const o = this.h.getRenderer().si(this.ui);
        return this.ci.render(t, o, s, n, r, i, e, h);
    }
    drawBloom(t) {
        const i = this.h.getRenderer(), e = this.j, s = this.ui;
        if (s) {
            const {width: i, height: n} = t;
            s.width === i && s.height === n || s.resize(i, n), e.clear({
                color: [ 0, 0, 0, 0 ],
                framebuffer: s
            });
        } else {
            const i = this.fi(t);
            this.ui = e.framebuffer(i);
        }
        const n = i.getFrameTime(), r = i.getFrameEvent(), h = i.getFrameContext(), o = h.renderMode, a = h.sceneFilter, l = h.renderTarget;
        h.isPostProcess = !0, h.renderMode = "default", h.sceneFilter = yi, h.renderTarget = {
            fbo: this.ui,
            getFramebuffer: Mi,
            getDepthTexture: Si
        };
        const c = i.glCtx;
        return c.resetDrawCalls(), r ? i.forEachRenderer((t => {
            i.clearStencil(t, s), t.drawOnInteracting(r, n, h);
        })) : i.forEachRenderer((t => {
            i.clearStencil(t, s), t.draw(n, h);
        })), delete h.isPostProcess, h.renderMode = o, h.sceneFilter = a, h.renderTarget = l, 
        c.getDrawCalls();
    }
    genSsrMipmap(t, i) {
        const e = this.h.getMap().projViewMatrix;
        this.li.genMipMap(t, i, e);
    }
    getPrevSsrProjViewMatrix() {
        return this.li && this.li.getPrevProjViewMatrix();
    }
    drawSSR(t, i, e) {
        e && this.li.copyDepthTex(t);
        const s = this.h.getRenderer(), n = s.getFrameTime(), r = s.getFrameEvent(), h = s.getFrameContext();
        h.isPostProcess = !0, h.ssr = this.getSSRContext();
        const o = h.renderMode, a = h.sceneFilter;
        h.renderMode = "default", h.sceneFilter = bi, h.renderTarget.fbo = i;
        const l = s.glCtx;
        let c = !1;
        r ? s.forEachRenderer((t => {
            s.clearStencil(t, i), c || (l.resetDrawCalls(), c = !0), t.drawOnInteracting(r, n, h);
        })) : s.forEachRenderer((t => {
            s.clearStencil(t, i), c || (l.resetDrawCalls(), c = !0), t.draw(n, h);
        }));
        const u = s.drawGround();
        return delete h.ssr, delete h.isPostProcess, h.renderMode = o, h.sceneFilter = a, 
        this.di = l.getDrawCalls() > 0, u;
    }
    getSSRUniforms() {
        const t = this.h.u(), i = t && t.postProcess, e = this.h.getMap();
        return this.li.getSSRUniforms(e, i.ssr.factor, i.ssr.quality);
    }
    getSSRContext() {
        const t = this.h.u(), i = t && t.postProcess, e = this.h.getMap(), s = this.li.getSSRUniforms(e, i.ssr.factor, i.ssr.quality);
        if (!s) return null;
        return {
            renderUniforms: s,
            defines: {
                "HAS_SSR": 1
            }
        };
    }
    fxaa(t, i, e, s, n, r, h, o, a, l, c, f) {
        !t || t.width === i.fbo && t.height === i.height || t.resize(i.width, i.height);
        const d = {};
        o ? d.HAS_OUTLINE_TEX = 1 : delete d.HAS_OUTLINE_TEX, this.oi.setDefines(d), this.hi.render(this.oi, {
            textureSource: i,
            resolution: u.set(_i, i.width, i.height),
            enableFXAA: e,
            enableToneMapping: s,
            enableSharpen: n,
            pixelRatio: r,
            sharpFactor: h,
            textureOutline: o,
            highlightFactor: a,
            outlineFactor: l,
            outlineWidth: c,
            outlineColor: f
        }, null, t);
    }
    renderFBOToScreen(t, i, e, s) {
        this.mi || (this.mi = []), this.mi[0] = t.width, this.mi[1] = t.height;
        const n = this.h.getRenderer();
        this.hi.render(this.ai, {
            texture: t.color && n.si(t) || t,
            size: this.mi,
            enableSharpen: +!!i,
            sharpFactor: e,
            pixelRatio: s
        });
    }
    postprocess(t, i, e) {
        this.gi || (this.gi = new a.PostProcessShader);
        const s = this.h && this.h.getRenderer(), n = e || s.si(t);
        return i.resolution = u.set(_i, n.width, n.height), i.textureSource = n, i.timeGrain = performance.now(), 
        this.hi.render(this.gi, i), this.pi;
    }
    dispose() {
        this.ui && (this.ui.destroy(), delete this.ui), this.ci && (this.ci.dispose(), delete this.ci), 
        this.gi && (this.gi.dispose(), delete this.gi), this.oi && (this.oi.dispose(), delete this.oi), 
        this.ai && (this.ai.dispose(), delete this.ai);
    }
    fi(t, i) {
        const {width: e, height: s} = this.h.getRenderer().canvas, n = this.j;
        let r;
        r = this.h.getRenderer().wi() ? n.renderbuffer({
            width: e,
            height: s,
            samples: this.h.options.multiSamples,
            format: "rgba8"
        }) : n.texture({
            min: "nearest",
            mag: "nearest",
            format: i || "rgba",
            width: e,
            height: s
        });
        const h = {
            width: e,
            height: s,
            colors: [ r ]
        };
        return t && (h.depthStencil = t), h;
    }
}

function Mi(t) {
    return t._framebuffer.framebuffer;
}

function Si(t) {
    return t.depthStencil._texture.texture;
}

class Ci extends a.QuadShader {
    constructor(t) {
        super({
            vert: "#if __VERSION__ == 300\n\t#define attribute in\n\t#define varying out\n#endif\nattribute vec2 aPosition;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\nvoid main()\n{\n  gl_Position = vec4(aPosition, 0., 1.);\n  vTexCoord = aTexCoord;\n}",
            frag: "#if __VERSION__ == 100\n  #ifdef GL_OES_standard_derivatives\n    #extension GL_OES_standard_derivatives : enable\n  #endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nvarying vec2 vTexCoord;\n#ifdef HAS_FLOODANALYSE\n    uniform vec3 flood_waterColor;\n    uniform float flood_waterOpacity;\n    uniform sampler2D floodMap;\n#endif\n#ifdef HAS_SKYLINE\n    uniform sampler2D skylineMap;\n#endif\n#ifdef HAS_VIEWSHED\n    uniform vec4 viewshed_visibleColor;\n    uniform vec4 viewshed_invisibleColor;\n    uniform sampler2D viewshedMap;\n#endif\n#ifdef HAS_INSIGHT\n    uniform vec4 insight_visibleColor;\n    uniform vec4 insight_invisibleColor;\n    uniform sampler2D insightMap;\n#endif\n#ifdef HAS_CUT\n    uniform sampler2D meshesMap;\n    uniform sampler2D invisibleMap;\n#endif\n#ifdef HAS_EXCAVATE\n    uniform sampler2D excavateMap;\n#endif\n#ifdef HAS_CROSSCUT\n    uniform sampler2D crosscutMap;\n    uniform vec4 cutLineColor;\n#endif\n#ifdef HAS_HEIGHTLIMIT\n    uniform vec3 limitColor;\n    uniform sampler2D heightLimitMap;\n#endif\nuniform sampler2D sceneMap;\nvoid main() {\n    vec4 sceneColor = texture2D(sceneMap, vTexCoord);\n    glFragColor = sceneColor;\n    #ifdef HAS_VIEWSHED\n        vec4 viewshedColor = texture2D(viewshedMap, vTexCoord);\n        if (viewshedColor.r > 0.99) {\n            glFragColor = vec4(mix(viewshed_invisibleColor.rgb, sceneColor.rgb, viewshed_invisibleColor.a), sceneColor.a);\n        } else if (viewshedColor.g > 0.99) {\n            glFragColor = vec4(mix(viewshed_visibleColor.rgb, sceneColor.rgb, viewshed_visibleColor.a), sceneColor.a);\n        } else if (viewshedColor.a < 0.01) {\n            glFragColor = vec4(viewshedColor.rgb, 1.0);\n        }\n    #endif\n    #ifdef HAS_FLOODANALYSE\n        vec4 floodColor = texture2D(floodMap, vTexCoord);\n        if (floodColor.r > 0.0) {\n            glFragColor = vec4(mix(glFragColor.rgb, flood_waterColor, flood_waterOpacity), glFragColor.a);\n        }\n    #endif\n    #ifdef HAS_SKYLINE\n        vec4 skylineColor = texture2D(skylineMap, vTexCoord);\n        if (skylineColor.r > 0.0 || skylineColor.g > 0.0 || skylineColor.b > 0.0) {\n            glFragColor = skylineColor;\n        }\n    #endif\n    #ifdef HAS_INSIGHT\n        vec4 insightColor = texture2D(insightMap, vTexCoord);\n        if (insightColor.g > 0.0) {\n            glFragColor = insight_visibleColor;\n        } else if (insightColor.r > 0.0) {\n            glFragColor = insight_invisibleColor;\n        }\n    #endif\n    #ifdef HAS_CUT\n        vec4 cutColor = texture2D(invisibleMap, vTexCoord);\n        vec4 meshesMapColor = texture2D(meshesMap, vTexCoord);\n        if (cutColor.r == 1.0 && cutColor.g == 0.0 && cutColor.b == 0.0) {\n            glFragColor = meshesMapColor;\n        } else if (cutColor.r == 0.0 && cutColor.g == 1.0 && cutColor.b == 0.0) {\n            glFragColor = meshesMapColor;\n        } else if (cutColor.r == 0.0 && cutColor.g == 0.0 && cutColor.b == 1.0) {\n          glFragColor = sceneColor;\n        }\n    #endif\n    #ifdef HAS_EXCAVATE\n        vec4 excavateColor = texture2D(excavateMap, vTexCoord);\n        if (excavateColor.r == 1.0 && excavateColor.g == 0.0 && excavateColor.b == 0.0) {\n          glFragColor = sceneColor;\n        }  else {\n          glFragColor = excavateColor;\n        }\n    #endif\n    #ifdef HAS_CROSSCUT\n        vec4 crosscutColor = texture2D(crosscutMap, vTexCoord);\n        if (crosscutColor.r > 0.0) {\n            glFragColor = vec4(mix(cutLineColor.rgb, glFragColor.rgb, 0.99), glFragColor.a);\n        }\n    #endif\n    #ifdef HAS_HEIGHTLIMIT\n        vec4 heightLimitColor = texture2D(heightLimitMap, vTexCoord);\n        if (heightLimitColor.r > 0.0) {\n            glFragColor = vec4(mix(limitColor, glFragColor.rgb, 0.6), glFragColor.a);\n        }\n    #endif\n    #if __VERSION__ == 100\n        gl_FragColor = glFragColor;\n    #endif\n}",
            extraCommandProps: {
                viewport: t,
                cull: {
                    enable: !0
                },
                blend: {
                    enable: !0,
                    func: {
                        srcRGB: "src alpha",
                        srcAlpha: 1,
                        dstRGB: "one minus src alpha",
                        dstAlpha: "one minus src alpha"
                    },
                    equation: "add"
                }
            }
        });
    }
}

class ki {
    constructor(t, i, e) {
        this.j = t, this.h = i, this.Bt = e, this.o();
    }
    o() {
        this.renderer = new a.Renderer(this.j);
        const t = this.h.getRenderer(), i = this.zt = {
            x: 0,
            y: 0,
            width: () => t.canvas ? t.canvas.width : 1,
            height: () => t.canvas ? t.canvas.height : 1
        };
        this.Wt = this.j.framebuffer({
            color: this.j.texture({
                width: t.canvas ? t.canvas.width : 1,
                height: t.canvas ? t.canvas.height : 1,
                wrap: "clamp",
                mag: "linear",
                min: "linear"
            }),
            depth: !0
        }), this.wt = new Ci(i);
    }
    getMap() {
        return this.h && this.h.getMap();
    }
    paint(t, i) {
        if (!i && i.length) return t;
        this.Kt();
        const e = {}, s = this.h.vi;
        if (!this._i()) return t;
        this.j.clear({
            color: [ 0, 0, 0, 0 ],
            depth: 1,
            stencil: 0,
            framebuffer: this.Wt
        }), delete this.wt.shaderDefines.HAS_FLOODANALYSE, delete this.wt.shaderDefines.HAS_VIEWSHED, 
        delete this.wt.shaderDefines.HAS_SKYLINE, delete this.wt.shaderDefines.HAS_INSIGHT, 
        delete this.wt.shaderDefines.HAS_CUT, delete this.wt.shaderDefines.HAS_CROSSCUT, 
        delete this.wt.shaderDefines.HAS_HEIGHTLIMIT;
        for (let t = 0; t < s.length; t++) {
            const n = s[t];
            if (!n.isEnable()) continue;
            const r = n.getDefines();
            ut(this.wt.shaderDefines, r);
            const h = this.getMap(), o = h.width, a = h.height, l = this.yi(i, n.getExcludeLayers()), c = n.renderAnalysis(l, o, a);
            c && ut(e, c);
        }
        return e.sceneMap = t, this.wt.setDefines(this.wt.shaderDefines), this.renderer.render(this.wt, e, null, this.Wt), 
        this.Wt;
    }
    yi(t, i) {
        let e = [];
        for (let s = 0; s < t.length; s++) {
            if (i.indexOf(t[s].getId()) > -1) continue;
            const n = t[s].getRenderer();
            if (n && n.getAnalysisMeshes) {
                const t = n.getAnalysisMeshes();
                t.forEach((t => {
                    t.setUniform("useAnalysis", 1);
                })), e = e.concat(t);
            }
        }
        return e;
    }
    Kt() {
        const t = e.isFunction(this.zt.width.data) ? this.zt.width.data() : this.zt.width, i = e.isFunction(this.zt.height.data) ? this.zt.height.data() : this.zt.height;
        !this.Wt || this.Wt.width === t && this.Wt.height === i || this.Wt.resize(t, i);
    }
    _i() {
        const t = this.h && this.h.vi;
        if (!t) return !1;
        for (let i = 0; i < t.length; i++) if (t[i].isEnable()) return !0;
        return !1;
    }
}

const Ti = [], Oi = new t.Coordinate(0, 0);

let Ai = {};

class Ii {
    constructor(t, i) {
        this.j = t, this.h = i, this.o();
    }
    o() {
        this.renderer = new a.Renderer(this.j);
        const t = this.h.getRenderer(), i = this.zt = {
            x: 0,
            y: 0,
            width: () => t.canvas ? t.canvas.width : 1,
            height: () => t.canvas ? t.canvas.height : 1
        };
        this.Ut = i.width, this.Vt = i.height, this.Wt = this.j.framebuffer({
            color: this.j.texture({
                width: t.canvas ? t.canvas.width : 1,
                height: t.canvas ? t.canvas.height : 1,
                wrap: "clamp",
                mag: "linear",
                min: "linear"
            }),
            depth: !0
        }), this.EMPTY_TEXTURE = this.j.texture({
            with: 2,
            height: 2
        }), this.wt = new a.ScanEffectShader, this.bi = new a.ScanEffectPass(this.j, i, this.h), 
        this.wt.version = 300;
    }
    getMap() {
        return this.h && this.h.getMap();
    }
    paint(t, i) {
        if (!i || !i.length) return t;
        const e = this.h.getMap();
        this.Kt();
        const s = this.h.getScanEffectConfig(), n = {}, {effects: r} = s, h = e.getGLRes(), o = [];
        this.xi !== r.length && (Ai = {});
        for (let t = 0; t < r.length; t++) {
            const {center: i, radius: s, speed: n, color: l, direction: c, height: u} = r[t], f = Ei(i), d = e.coordinateToPointAtRes(f, h, Oi).toArray(), m = e.distanceToPointAtRes(s, 0, h).x, g = "vertical" === c ? 1 : 0, p = e.altitudeToPoint(u || 0, h);
            Ai[t] = Ai[t] || [];
            const w = a.mat3.set(Ai[t], d[0], d[1], m, n, l[0], l[1], l[2], g, p);
            o.push(w);
        }
        const l = {
            projMatrix: e.projMatrix,
            viewMatrix: e.viewMatrix,
            effectInfos: o,
            effectTime: this.ii() / 1e3
        }, c = this.h.getRenderer(), u = this.bi.render(i, l) || this.EMPTY_TEXTURE;
        return n.scanEffectMap = c.si(u), n.sceneMap = t, n.resolution = a.vec2.set(Ti, this.Wt.width, this.Wt.height), 
        this.renderer.render(this.wt, n, null, this.Wt), this.Wt;
    }
    ii() {
        if (!this.h) return 0;
        if (void 0 === this.ni && (this.ni = 0), this.isPlaying()) {
            const t = this.h.getRenderer();
            this.ni = t.getFrameTime();
        }
        return this.ni;
    }
    isPlaying() {
        const t = this.h.getScanEffectConfig();
        return !!t && !1 !== t.playing;
    }
    Kt() {
        const t = this.Ut(), i = this.Vt();
        !this.Wt || this.Wt.width === t && this.Wt.height === i || this.Wt.resize(t, i);
    }
    dispose() {
        this.Wt && this.Wt.destroy(), this.wt && (this.wt.dispose(), delete this.wt), this.bi && this.bi.dispose();
    }
}

function Ei(t) {
    return Array.isArray(t) ? (Oi.x = t[0], Oi.y = t[1], Oi) : t;
}

const Li = [ 0, 0, 0, 0 ], Pi = [ 1, 1, -1 ], Ri = [ 0, 0 ], Fi = t => !t.bloom && !t.ssr, Hi = t => !t.bloom, Di = t => !t.ssr;

class Ni extends t.renderer.CanvasRenderer {
    setToRedraw() {
        this.setRetireFrames(), super.setToRedraw();
    }
    onAdd() {
        super.onAdd(), this.prepareCanvas();
    }
    updateSceneConfig() {
        this.Mi && this.Mi.update(), this.Si && this.Si.update(), this.Ci && this.Ci.update(), 
        this.setToRedraw();
    }
    render(...t) {
        this.getMap() && this.layer.isVisible() && (this.forEachRenderer((t => {
            t._replacedDrawFn || (t.draw = this.ki(t.draw), t.drawOnInteracting = this.Ti(t.drawOnInteracting), 
            t.setToRedraw = this.Oi(t.setToRedraw), t._replacedDrawFn = !0);
        })), this.prepareRender(), this.prepareCanvas(), this.layer.Ai(), this._toRedraw = !1, 
        this.Ii("render", t), this.Ei(), this.Li());
    }
    prepareCanvas() {
        super.prepareCanvas(), this.forEachRenderer((t => {
            t.prepareCanvas();
        }));
    }
    drawOnInteracting(...t) {
        this.getMap() && this.layer.isVisible() && (this.layer.Ai(), this._toRedraw = !1, 
        this.Ii("drawOnInteracting", t), this.Ei(), this.Li());
    }
    Ii(t, i) {
        this.Pi = "default";
        const e = this.hasRenderTarget(), s = this.Ri(i);
        if (e && (this.Fi.renderTarget = this.Hi()), this.Si.paint(s), this.drawGround(!0), 
        !e) return void this.Di("default", null, t, i, !0);
        const n = this.glCtx, r = this.layer.u(), h = r && r.postProcess, o = this.isSSROn();
        s.jitter = Ri;
        const a = this.layer.getGroundConfig();
        s.hasSSRGround = !!(o && a && a.enable && a.symbol && a.symbol.ssr), n.resetDrawCalls(), 
        this.Di("default", this.Ni, t, i), o && this.Gi.drawSSR(this.ji(), this.Ni);
        h.bloom && h.bloom.enable && (this.Bi = this.Gi.drawBloom(this.zi)), 2 === o && this.Gi.drawSSR(this.ji(), this.Ni, !0), 
        n.resetDrawCalls(), this.Ci.renderScene(s), this.Ui = n.getDrawCalls();
    }
    Di(t, i, e, s, n) {
        this.Pi = t;
        const r = this.Ri(s);
        r.renderMode = this.Pi, r.renderTarget && (r.renderTarget.fbo = i), n && (r.isFinalRender = !0), 
        this.forEachRenderer(((t, n) => {
            n.isVisible() && (this.clearStencil(t, i), t[e].apply(t, s));
        }));
    }
    Ri(t) {
        let i = t[0];
        return Gi(i) || (i = t[1]), i !== this.Vi && (this.forEachRenderer(((t, i) => {
            i.isVisible() && t.needRetireFrames && t.needRetireFrames() && this.setRetireFrames();
        })), this.Fi = this.Wi(i), this.Vi = i, this.qi = Gi(t[0]) ? null : t[0]), this.Fi;
    }
    Ei() {
        if (!this.isEnableOutline()) return;
        const t = this.$i(), i = this.glCtx;
        i.resetDrawCalls(), this.forEachRenderer(((i, e) => {
            e.isVisible() && i.drawOutline && i.drawOutline(t);
        })), this.Xi = i.getDrawCalls();
    }
    $i() {
        const {width: t, height: i} = this.canvas;
        let e = this.Yi;
        if (e) t === e.width && i === e.height || e.resize(t, i); else {
            const s = this.regl.texture({
                width: t,
                height: i,
                format: "rgba4"
            });
            e = this.Yi = this.regl.framebuffer({
                width: t,
                height: i,
                colors: [ s ],
                depth: !1,
                stencil: !1
            });
        }
        return e;
    }
    si(t) {
        if (this.wi()) {
            const i = this.Ji(t);
            return i.width !== t.width || i.height !== t.height ? i.resize(t.width, t.height) : this.regl.clear({
                color: [ 0, 0, 0, 0 ],
                fbo: i
            }), i.blit(t), i.color[0];
        }
        return t.color[0];
    }
    ji() {
        if (this.zi.subimage) return this.zi;
        const {width: t, height: i} = this.zi;
        if (!this.Zi) {
            const e = this.regl, s = {
                depthStencil: e.texture({
                    min: "nearest",
                    mag: "nearest",
                    mipmap: !1,
                    type: "depth stencil",
                    width: t,
                    height: i,
                    format: "depth stencil"
                }),
                colors: [ e.renderbuffer({
                    width: t,
                    height: i,
                    format: "rgba4"
                }) ],
                colorFormat: "rgba4",
                width: t,
                height: i
            };
            this.Zi = e.framebuffer(s);
        }
        return this.Zi.width === t && this.Zi.height === i || this.Zi.resize(t, i), this.regl.clear({
            color: [ 0, 0, 0, 0 ],
            depth: 1,
            fbo: this.Zi
        }), this.Zi.blit(this.Ni, 256, "nearest"), this.Zi.depthStencil;
    }
    Ji(t) {
        if (this.Ki || (this.Ki = []), !t.Qi) {
            const i = this.te(!0, t.width, t.height), e = this.regl.framebuffer(i);
            this.Ki.push(e), t.Qi = e;
        }
        return t.Qi;
    }
    wi() {
        return 0 === this.regl.limits.version.indexOf("WebGL 2.0") && this.layer.options.antialias;
    }
    hasRenderTarget() {
        const t = this.layer.u(), i = t && t.postProcess;
        return !(!i || !i.enable);
    }
    testIfNeedRedraw() {
        if (this.layer.options.forceRedrawPerFrame) return !0;
        if (this._toRedraw) return this._toRedraw = !1, !0;
        if (this.getMap().isInteracting() && (this.Mi && this.Mi.isEnable() || this.Si && this.Si.isEnable())) return !0;
        if (this.Ci && this.Ci.isEnable()) return !0;
        if (this.isEnableScanEffect()) return !0;
        const t = this.layer.getTerrainLayer();
        if (t) {
            const i = t.getRenderer();
            if (i && i.testIfNeedRedraw()) return this.ie = !0, !0;
        }
        const i = this.ee();
        for (const t of i) {
            if (!t) continue;
            const i = t.getRenderer();
            if (i && i.testIfNeedRedraw()) return this.ie = !0, !0;
        }
        return !1;
    }
    isRenderComplete() {
        const t = this.ee();
        for (const i of t) {
            const t = i.getRenderer();
            if (t && !t.isRenderComplete()) return !1;
        }
        return !0;
    }
    mustRenderOnInteracting() {
        const t = this.ee();
        for (const i of t) {
            const t = i.getRenderer();
            if (t && t.mustRenderOnInteracting()) return !0;
        }
        return !1;
    }
    isCanvasUpdated() {
        if (super.isCanvasUpdated()) return !0;
        const t = this.ee();
        for (const i of t) {
            const t = i.getRenderer();
            if (t && t.isCanvasUpdated()) return !0;
        }
        return !1;
    }
    isBlank() {
        if (this.Mi && this.Mi.isEnable()) return !1;
        if (this.Si && this.Si.isEnable()) return !1;
        const t = this.layer.getTerrainLayer();
        if (t) {
            const i = t.getRenderer();
            if (i && !i.isBlank()) return !1;
        }
        const i = this.ee();
        for (const t of i) {
            const i = t.getRenderer();
            if (i && !i.isBlank()) return !1;
        }
        return !0;
    }
    createContext() {
        const t = this.layer, i = t.options.glOptions || {
            alpha: !0,
            depth: !0,
            stencil: !0
        };
        i.preserveDrawingBuffer = !0, i.antialias = !!t.options.antialias, this.glOptions = i;
        const e = this.gl = function(t, i, e) {
            const s = e ? [ "webgl", "experimental-webgl" ] : [ "webgl2", "webgl", "experimental-webgl" ];
            let n = null;
            for (let e = 0; e < s.length; ++e) {
                try {
                    n = t.getContext(s[e], i);
                } catch (t) {}
                if (n) break;
            }
            return n || console.error("Browser doesn't support WebGL."), n;
        }(this.canvas, i, t.options.onlyWebGL1);
        this.se(e), e.wrap = () => new p(this.gl), this.glCtx = e.wrap(), this.canvas.gl = this.gl, 
        this.reglGL = e.wrap(), this.regl = w({
            gl: this.reglGL,
            attributes: i,
            extensions: t.options.extensions,
            optionalExtensions: t.options.optionalExtensions
        }), this.gl.regl = this.regl, this.ne = [ 0, 0 ], this.Mi = new Wt(this.regl, this.layer), 
        this.Si = new Zt(this.regl, this.layer);
        const s = this.layer.getWeatherConfig();
        this.Ci = new vi(this.regl, t, s), this.re = new ki(this.regl, t), this.he = new Ii(this.regl, t);
        const n = this.layer.u() || {}, r = n && n.postProcess, h = r && r.antialias && r.antialias.jitterRatio || .2;
        this.oe = new a.Jitter(h), this.Gi = new xi(this.regl, this.layer, this.oe), this.ae = new kt(this.regl, this.layer);
    }
    se() {
        const t = this.layer, i = this.gl, e = t.options.extensions;
        e && e.forEach((t => {
            i.getExtension(t);
        }));
        const s = t.options.optionalExtensions;
        s && s.forEach((t => {
            i.getExtension(t);
        })), this.gl.clearColor(0, 0, 0, 0);
    }
    clearCanvas() {
        super.clearCanvas(), this.le();
    }
    le() {
        const t = this.regl;
        this.Ni && t.clear({
            color: Li,
            depth: 1,
            stencil: 255,
            framebuffer: this.Ni
        }), this.Yi && t.clear({
            color: Li,
            framebuffer: this.Yi
        }), t.clear({
            color: Li,
            depth: 1,
            stencil: 255
        });
    }
    resizeCanvas() {
        const t = this.canvas.width, i = this.canvas.height;
        !this.Ni || this.Ni.width === t && this.Ni.height === i || (super.resizeCanvas(), 
        this.Ni.resize(t, i), this.le(), this.forEachRenderer((t => {
            t.canvas && t.resizeCanvas();
        })));
    }
    getCanvasImage() {
        return this.forEachRenderer((t => {
            t.getCanvasImage();
        })), super.getCanvasImage();
    }
    ee() {
        return this.layer.ee();
    }
    forEachRenderer(t) {
        const i = this.ee();
        for (const e of i) {
            if (!e.isVisible() || !e.options.beneathTerrain) continue;
            const i = e.getRenderer();
            i && t(i, e);
        }
        const e = this.layer.getTerrainLayer();
        if (e) {
            const i = e.getRenderer();
            i && t(i, e);
        }
        for (const e of i) {
            if (!e.isVisible() || e.options.beneathTerrain) continue;
            const i = e.getRenderer();
            i && t(i, e);
        }
    }
    clearStencil(t, i) {
        const e = {
            stencil: t.getStencilValue ? t.getStencilValue() : 255
        };
        i && (e.framebuffer = i), this.regl.clear(e);
    }
    onRemove() {
        this.canvas.pickingFBO && this.canvas.pickingFBO.destroy && this.canvas.pickingFBO.destroy(), 
        this.ce(), this.Mi && (this.Mi.dispose(), delete this.Mi), this.Si && (this.Si.dispose(), 
        delete this.Si), this.ae && (this.ae.dispose(), delete this.ae), this.Gi && (this.Gi.dispose(), 
        delete this.Gi), this.Yi && (this.Yi.destroy(), delete this.Yi), this.Ci && (this.Ci.dispose(), 
        delete this.Ci), super.onRemove();
    }
    ce() {
        if (this.Ni && (this.Ni.destroy(), delete this.Ni, this.ue && (this.ue.destroy(), 
        delete this.ue), this.Zi && (this.Zi.destroy(), delete this.Zi), this.Ki)) {
            for (let t = 0; t < this.Ki.length; t++) this.Ki[t] && this.Ki[t].destroy();
            delete this.Ki;
        }
    }
    setRetireFrames() {
        this.fe = !0;
    }
    getFrameTime() {
        return this.Vi;
    }
    getFrameEvent() {
        return this.qi;
    }
    getFrameContext() {
        return this.Fi;
    }
    drawGround(t) {
        const i = this.layer.getGroundConfig();
        if (!i || !i.enable) return !1;
        if (!this.Mi) return !1;
        const e = this.getFrameContext(), s = e.jitter;
        e.jitter = Ri;
        const n = this.layer.getPolygonOffsetCount();
        let r;
        e.offsetFactor = n + 1, e.offsetUnits = n + 1, t && (r = e.sceneFilter, delete e.sceneFilter);
        const h = this.Mi.paint(e);
        return this.Mi.needToRedraw() && this.setToRedraw(), r && (e.sceneFilter = r), e.jitter = s, 
        h;
    }
    ki(t) {
        const i = this;
        return function(e, s) {
            return (s = s || i.Fi) && s.renderTarget && (s.renderTarget.getFramebuffer = ji, 
            s.renderTarget.getDepthTexture = Bi), t.call(this, e, s);
        };
    }
    Ti(t) {
        const i = this;
        return function(e, s, n) {
            return (n = n || i.Fi) && n.renderTarget && (n.renderTarget.getFramebuffer = ji, 
            n.renderTarget.getDepthTexture = Bi), t.call(this, e, s, n);
        };
    }
    Oi(t) {
        return function(...i) {
            return t.apply(this, i);
        };
    }
    isEnableSSR() {
        const t = this.layer.u(), i = t && t.postProcess;
        return i && i.enable && i.ssr && i.ssr.enable;
    }
    isSSROn() {
        const t = this.isEnableSSR(), i = this.getMap();
        if (!t || i.getPitch() <= -.001) return 0;
        const e = i.projViewMatrix, s = this.Gi.getPrevSsrProjViewMatrix();
        return s && l.exactEquals(s, e) ? 1 : 2;
    }
    isEnableTAA() {
        return !1;
    }
    isEnableSSAO() {
        return !1;
    }
    isEnableOutline() {
        const t = this.layer.u(), i = t && t.postProcess;
        return i && i.enable && i.outline && i.outline.enable;
    }
    isEnableWeather() {
        const t = this.layer.u(), i = t && t.weather;
        return i && i.enable;
    }
    de() {
        const t = this.layer.getMap();
        if (!this.P) {
            this.P = {
                center: t.getCenter(),
                bearing: t.getBearing(),
                pitch: t.getPitch(),
                res: t.getResolution()
            };
            let i = !1;
            if (t.options.lights) {
                const e = t.getLightManager().getDirectionalLight().direction || Pi;
                this.P.lightDirection = c.copy([], e), i = !0;
            }
            return {
                viewChanged: !0,
                lightDirectionChanged: i
            };
        }
        const i = t.getResolution() / this.P.res, e = t.coordToContainerPoint(this.P.center), s = this.layer.options.viewMoveThreshold, n = e._sub(t.width / 2, t.height / 2).mag() > s || i < .95 || i > 1.05;
        let r = !1;
        if (t.options.lights) {
            const i = t.getLightManager().getDirectionalLight().direction || Pi;
            r = !c.equals(this.P.lightDirection, i), r && (this.P.lightDirection = c.copy([], i));
        }
        return n && (this.P.center = t.getCenter(), this.P.bearing = t.getBearing(), this.P.pitch = t.getPitch(), 
        this.P.res = t.getResolution()), {
            viewChanged: n,
            lightDirectionChanged: r
        };
    }
    Wi(t) {
        const i = this.layer.u(), e = i && i.postProcess, s = i && i.weather, n = {
            timestamp: t,
            renderMode: this.Pi || "default",
            includes: {},
            states: this.de(),
            testSceneFilter: t => !n.sceneFilter || n.sceneFilter(t),
            isFinalRender: !1,
            weather: {
                fog: s && s.fog
            }
        }, r = e && e.antialias && e.antialias.jitterRatio || .2, h = this.oe;
        h && h.setRatio(r);
        const o = this.isSSROn();
        let a;
        if (e && e.enable) {
            if (this.isEnableTAA()) {
                (this.getMap().isInteracting() || this.fe) && h.reset(), h.getJitter(this.ne), h.frame();
            } else u.set(this.ne, 0, 0);
            n.jitter = this.ne;
            const t = e.bloom && e.bloom.enable;
            t && o ? (n.bloom = 1, n.sceneFilter = Fi) : t ? (n.bloom = 1, n.sceneFilter = Hi) : o && (n.sceneFilter = Di), 
            a = this.Hi(), a && (n.renderTarget = a);
        } else this.ce();
        return "noAa" !== this.Pi && (this.me = this.ge(n), this.me && (n.includes.shadow = 1), 
        this.pe = this.we(n)), this.me && (n.shadow = this.me, n.includes.shadow = 1), n.states.includesChanged = this.pe, 
        e && e.enable && this.Gi && this.Gi.setContextIncludes(n), n;
    }
    ve(t) {
        const i = this.ee().filter((t => t.isVisible()));
        return this.layer.getTerrainLayer() && i.push(this.layer.getTerrainLayer()), this.re.paint(t, i);
    }
    we(t) {
        let i = !1;
        const e = Object.keys(t.includes), s = this._e;
        if (s) {
            const t = e.filter((t => -1 === s.indexOf(t))).concat(s.filter((t => -1 === e.indexOf(t))));
            t.length && (i = t.reduce(((t, i) => (t[i] = 1, t)), {}));
        }
        return this._e = e, i;
    }
    ge(t) {
        const i = this.layer.u();
        if (!i || !i.shadow || !i.shadow.enable) return this.ae && (this.ae.dispose(), delete this.ae), 
        null;
        this.ae || (this.ae = new kt(this.regl, this.layer));
        const e = {
            config: i.shadow,
            defines: this.ae.getDefines(),
            uniformDeclares: kt.getUniformDeclares()
        };
        return e.renderUniforms = this.ye(t), e;
    }
    ye(t) {
        const i = t.renderTarget && t.renderTarget.fbo, e = this.layer.u(), s = [];
        let n = t.states.lightDirectionChanged || t.states.viewChanged;
        this.forEachRenderer(((t, i) => {
            if (!t.getShadowMeshes || !i.isVisible()) return;
            const e = t.getShadowMeshes();
            if (Array.isArray(e)) for (let t = 0; t < e.length; t++) e[t] && (e[t].needUpdateShadow && (n = !0, 
            e[t].needUpdateShadow = !1), e[t].hasFunctionUniform && (e[t].hasFunctionUniform("minAltitude") || e[t].setFunctionUniform("minAltitude", (() => i && i.options.altitude || 0)), 
            s.push(e[t])));
        })), this.be || (this.be = new a.Scene), this.be.setMeshes(s);
        const r = this.getMap(), h = e.shadow, o = r.getLightManager(), l = o && o.getDirectionalLight().direction || Pi, c = !e.ground || !e.ground.enable;
        return this.ae.render(c, r.projMatrix, r.viewMatrix, h.color, h.opacity, l, this.be, this.ne, i, n);
    }
    xe(t) {
        let i = [];
        if (this.forEachRenderer(((t, e) => {
            if (!t.getAnalysisMeshes || !e.isVisible()) return;
            const s = t.getAnalysisMeshes();
            i = i.concat(s);
        })), this.Mi) {
            const t = this.Mi.getRenderMeshes();
            i = i.concat(t);
        }
        const e = this.layer.getWeatherConfig();
        return this.Ci.paint(t, i, e);
    }
    Me(t) {
        let i = [];
        if (this.forEachRenderer(((t, e) => {
            if (!t.getAnalysisMeshes || !e.isVisible()) return;
            const s = t.getAnalysisMeshes();
            i = i.concat(s);
        })), this.Mi) {
            const t = this.Mi.getRenderMeshes();
            i = i.concat(t);
        }
        return this.he.paint(t, i);
    }
    getGroundMesh() {
        if (this.Mi) {
            return this.Mi.getRenderMeshes();
        }
        return [];
    }
    Hi() {
        const t = this.layer.u(), i = t && t.postProcess;
        if (!this.Ni) {
            const t = this.regl;
            let e = this.zi;
            (!e || !e._texture || e._texture.refCount <= 0) && (e = null);
            const s = this.createFBOInfo(i, e);
            this.zi = s.depth || s.depthStencil, this.Ni = t.framebuffer(s), this.le();
        }
        return {
            fbo: this.Ni
        };
    }
    te(t, i, e) {
        i = i || this.canvas.width, e = e || this.canvas.height;
        const s = this.regl, n = this.wi();
        let r;
        if (!t && n) r = s.renderbuffer({
            width: i,
            height: e,
            samples: this.layer.options.multiSamples,
            format: "rgba8"
        }); else {
            const t = "uint8";
            r = s.texture({
                min: "nearest",
                mag: "nearest",
                type: t,
                width: i,
                height: e
            });
        }
        return {
            width: i,
            height: e,
            colors: [ r ],
            colorFormat: n ? "rgba8" : "rgba"
        };
    }
    createFBOInfo(t, i) {
        let {width: e, height: s} = this.canvas;
        e = e || 1, s = s || 1;
        const n = this.regl, r = this.te(), h = this.wi(), o = n.hasExtension("WEBGL_depth_texture");
        if (h) {
            const t = i || n.renderbuffer({
                width: e,
                height: s,
                format: "depth24 stencil8",
                samples: this.layer.options.multiSamples
            });
            r.depthStencil = t;
        } else if (o) {
            const t = i || n.texture({
                min: "nearest",
                mag: "nearest",
                mipmap: !1,
                type: "depth stencil",
                width: e,
                height: s,
                format: "depth stencil"
            });
            r.depthStencil = t;
        } else {
            const t = i || n.renderbuffer({
                width: e,
                height: s,
                format: "depth stencil"
            });
            r.depthStencil = t;
        }
        return r;
    }
    Li() {
        if (!this.Ni) return void (this.fe = !1);
        const t = this.layer.u(), i = t && t.postProcess;
        if (!i || !i.enable) {
            if (this.isEnableWeather()) throw new Error("you must enable the post process to turn on weather");
            return;
        }
        this.layer.fire("postprocessstart");
        const e = this.layer.getMap();
        let s = i.sharpen && i.sharpen.factor;
        s || 0 === s || (s = .2);
        let n = 0, r = .2, h = .3, o = 1, a = [ 1, 1, 0 ];
        i.outline && (n = +!!i.outline.enable, r = zi(i.outline, "highlightFactor", r), 
        h = zi(i.outline, "outlineFactor", h), o = zi(i.outline, "outlineWidth", o), a = zi(i.outline, "outlineColor", a));
        const l = i.ssr && i.ssr.enable, c = i.bloom && i.bloom.enable, u = this.re._i(), f = this.Ci.ri(), d = this.isEnableScanEffect(), m = c || l || u || f || d;
        let g = this.ue;
        if (m) {
            if (!g) {
                const t = this.te();
                this.wi() && (t.depthStencil = this.regl.renderbuffer({
                    width: this.canvas.width,
                    height: this.canvas.height,
                    samples: this.layer.options.multiSamples,
                    format: "depth24 stencil8"
                })), g = this.ue = this.regl.framebuffer(t);
            }
            const {width: t, height: i} = this.canvas;
            g.width === t && g.height === i || g.resize(t, i);
        } else g = null, this.ue && (this.ue.destroy(), delete this.ue);
        let p = this.si(this.Ni);
        if (this.Gi.fxaa(g, p, 0, +!(!i.toneMapping || !i.toneMapping.enable), +!(m || !i.sharpen || !i.sharpen.enable), e.getDevicePixelRatio(), s, n && this.Xi > 0 && this.$i(), r, h, o, a), 
        g && (p = this.si(g)), c && this.Bi) {
            const t = i.bloom, e = +t.threshold || 0, s = zi(t, "factor", 1), n = zi(t, "radius", 1);
            p = this.Gi.bloom(p, null, null, e, s, n, 0);
        }
        if (l && (this.Gi.genSsrMipmap(p, this.ji()), this.ie)) {
            const t = this.fe;
            this.setToRedraw(), this.fe = t, this.ie = !1;
        }
        this.he && this.isEnableScanEffect() && (p = this.Me(p)), this.re && (p = this.ve(p)), 
        this.isEnableWeather() && (p = this.xe(p)), m && this.Gi.renderFBOToScreen(p, +!(!i.sharpen || !i.sharpen.enable), s, e.getDevicePixelRatio()), 
        this.layer.fire("postprocessend");
    }
    isEnableScanEffect() {
        const t = this.layer.u(), i = t && t.postProcess && t.postProcess.scanEffect;
        return i && i.enable && i.effects.length;
    }
}

function Gi(t) {
    return "number" == typeof t && !isNaN(t);
}

function ji(t) {
    return t._framebuffer.framebuffer;
}

function Bi(t) {
    return t.depthStencil._texture.texture;
}

function zi(t, i, e) {
    return null == t[i] ? e : t[i];
}

class Ui extends t.worker.Actor {
    constructor(t) {
        super("@maptalks/terrain"), this.mapId = t;
    }
    checkUrl(i) {
        return i && t.Util.isString(i) ? t.Util.getAbsoluteURL(i) : i;
    }
    fetchTerrain(t, i, e) {
        t = this.checkUrl(t);
        const s = i.tileImage, n = {
            actorId: this.actorId,
            mapId: this.mapId,
            command: "fetchTerrain",
            params: {
                url: t,
                origin: location.origin,
                terrainWidth: i.terrainWidth,
                type: i.type,
                accessToken: i.accessToken,
                cesiumIonTokenURL: i.cesiumIonTokenURL,
                error: i.error,
                colors: i.colors,
                tileSize: i.tileSize,
                tileImage: s
            }
        }, r = [];
        s && r.push(s), this.send(n, r, ((t, i) => {
            t ? e(t) : e(t, i);
        }));
    }
    abortTerrain(t, i) {
        const e = {
            actorId: this.actorId,
            mapId: this.mapId,
            command: "abortTerrain",
            params: {
                url: t
            }
        };
        this.broadcast(e, null, i);
    }
    addLayer(t, i, e) {
        const s = {
            actorId: this.actorId,
            mapId: this.mapId,
            layerId: t,
            command: "addLayer",
            params: {}
        };
        this.broadcast(s, null, e);
    }
    createTerrainMesh(t, i) {
        const e = {
            actorId: this.actorId,
            command: "createTerrainMesh",
            params: t
        };
        this.send(e, [ t.terrainHeights.data.buffer ], ((t, e) => {
            t ? i(t) : i(t, e);
        }));
    }
    removeLayer(t, i, e) {
        const s = {
            mapId: this.mapId,
            layerId: t,
            command: "removeLayer"
        };
        this.broadcast(s, null, e);
    }
}

class Vi {
    constructor(t = 257) {
        this.gridSize = t;
        const i = t - 1;
        if (i & i - 1) throw new Error(`Expected grid size to be 2^n+1, got ${t}.`);
        this.numTriangles = i * i * 2 - 2, this.numParentTriangles = this.numTriangles - i * i, 
        this.indices = new Uint32Array(this.gridSize * this.gridSize), this.coords = new Uint16Array(4 * this.numTriangles);
        for (let t = 0; t < this.numTriangles; t++) {
            let e = t + 2, s = 0, n = 0, r = 0, h = 0, o = 0, a = 0;
            for (1 & e ? r = h = o = i : s = n = a = i; (e >>= 1) > 1; ) {
                const t = s + r >> 1, i = n + h >> 1;
                1 & e ? (r = s, h = n, s = o, n = a) : (s = r, n = h, r = o, h = a), o = t, a = i;
            }
            const l = 4 * t;
            this.coords[l + 0] = s, this.coords[l + 1] = n, this.coords[l + 2] = r, this.coords[l + 3] = h;
        }
    }
    createTile(t) {
        return new Wi(t, this);
    }
}

class Wi {
    constructor(t, i) {
        const e = i.gridSize;
        if (t.length !== e * e) throw new Error(`Expected terrain data of length ${e * e} (${e} x ${e}), got ${t.length}.`);
        this.terrain = t, this.martini = i, this.errors = new Float32Array(t.length), this.update();
    }
    update() {
        const {numTriangles: t, numParentTriangles: i, coords: e, gridSize: s} = this.martini, {terrain: n, errors: r} = this;
        for (let h = t - 1; h >= 0; h--) {
            const t = 4 * h, o = e[t + 0], a = e[t + 1], l = e[t + 2], c = e[t + 3], u = o + l >> 1, f = a + c >> 1, d = u + f - a, m = f + o - u, g = (n[a * s + o] + n[c * s + l]) / 2, p = f * s + u, w = Math.abs(g - n[p]);
            if (r[p] = Math.max(r[p], w), h < i) {
                const t = (a + m >> 1) * s + (o + d >> 1), i = (c + m >> 1) * s + (l + d >> 1);
                r[p] = Math.max(r[p], r[t], r[i]);
            }
        }
    }
    getMesh(t = 0) {
        const {gridSize: i, indices: e} = this.martini, {errors: s} = this;
        let n = 0, r = 0;
        const h = i - 1;
        function o(h, a, l, c, u, f) {
            const d = h + l >> 1, m = a + c >> 1;
            Math.abs(h - u) + Math.abs(a - f) > 1 && s[m * i + d] > t ? (o(u, f, h, a, d, m), 
            o(l, c, u, f, d, m)) : (e[a * i + h] = e[a * i + h] || ++n, e[c * i + l] = e[c * i + l] || ++n, 
            e[f * i + u] = e[f * i + u] || ++n, r++);
        }
        e.fill(0), o(0, 0, h, h, h, 0), o(h, h, 0, 0, 0, h);
        const a = new Uint16Array(2 * n), l = new Uint32Array(3 * r);
        let c = 0;
        function u(n, r, h, o, f, d) {
            const m = n + h >> 1, g = r + o >> 1;
            if (Math.abs(n - f) + Math.abs(r - d) > 1 && s[g * i + m] > t) u(f, d, n, r, m, g), 
            u(h, o, f, d, m, g); else {
                const t = e[r * i + n] - 1, s = e[o * i + h] - 1, u = e[d * i + f] - 1;
                a[2 * t] = n, a[2 * t + 1] = r, a[2 * s] = h, a[2 * s + 1] = o, a[2 * u] = f, a[2 * u + 1] = d, 
                l[c++] = t, l[c++] = s, l[c++] = u;
            }
        }
        return u(0, 0, h, h, h, 0), u(h, h, 0, 0, 0, h), {
            vertices: a,
            triangles: l
        };
    }
    getMeshWithSkirts(t = 0, i) {
        const {gridSize: e, indices: s} = this.martini, {errors: n} = this;
        let r = 0, h = 0;
        const o = e - 1;
        let a, l, c = 0;
        const u = [], f = [], d = [], m = [];
        function g(i, p, w, v, _, y) {
            const b = i + w >> 1, x = p + v >> 1;
            Math.abs(i - _) + Math.abs(p - y) > 1 && n[x * e + b] > t ? (g(_, y, i, p, b, x), 
            g(w, v, _, y, b, x)) : (a = p * e + i, l = v * e + w, c = y * e + _, 0 === s[a] && (0 === i ? u.push(r) : i === o && f.push(r), 
            0 === p ? d.push(r) : p === o && m.push(r), s[a] = ++r), 0 === s[l] && (0 === w ? u.push(r) : w === o && f.push(r), 
            0 === v ? d.push(r) : v === o && m.push(r), s[l] = ++r), 0 === s[c] && (0 === _ ? u.push(r) : _ === o && f.push(r), 
            0 === y ? d.push(r) : y === o && m.push(r), s[c] = ++r), h++);
        }
        let p;
        s.fill(0), g(0, 0, o, o, o, 0), g(o, o, 0, 0, 0, o), p = i ? 2 * (r + 3 * u.length - 2 + 3 * f.length - 2 + 3 * d.length - 2 + 3 * m.length - 2) : 2 * (r + u.length + f.length + d.length + m.length);
        const w = 3 * (h + 2 * (u.length - 1) + 2 * (f.length - 1) + 2 * (d.length - 1) + 2 * (m.length - 1)), v = new Uint16Array(p), _ = new Uint32Array(w);
        let y = 0;
        function b(i, r, h, o, a, l) {
            const c = i + h >> 1, u = r + o >> 1;
            if (Math.abs(i - a) + Math.abs(r - l) > 1 && n[u * e + c] > t) b(a, l, i, r, c, u), 
            b(h, o, a, l, c, u); else {
                const t = s[r * e + i] - 1, n = s[o * e + h] - 1, c = s[l * e + a] - 1;
                v[2 * t] = i, v[2 * t + 1] = r, v[2 * n] = h, v[2 * n + 1] = o, v[2 * c] = a, v[2 * c + 1] = l, 
                _[y++] = t, _[y++] = n, _[y++] = c;
            }
        }
        b(0, 0, o, o, o, 0), b(o, o, 0, 0, 0, o), u.sort(((t, i) => v[2 * t + 1] - v[2 * i + 1])), 
        f.sort(((t, i) => v[2 * i + 1] - v[2 * t + 1])), d.sort(((t, i) => v[2 * i] - v[2 * t])), 
        m.sort(((t, i) => v[2 * t] - v[2 * i]));
        let x, M, S, C, k = 2 * r, T = 0;
        function O(t) {
            T = t.length;
            for (let e = 0; e < T - 1; e++) x = t[e], M = t[e + 1], S = k / 2, C = (k + (i ? 6 : 2)) / 2, 
            v[k++] = 2 * x, v[k++] = 2 * x + 1, i && (v[k++] = 2 * x, v[k++] = 2 * x + 1, v[k++] = 2 * M, 
            v[k++] = 2 * M + 1), i ? (_[y++] = S + 1, _[y++] = S, _[y++] = S + 2, _[y++] = S, 
            _[y++] = C, _[y++] = S + 2) : (_[y++] = x, _[y++] = S, _[y++] = M, _[y++] = S, _[y++] = C, 
            _[y++] = M);
            v[k++] = 2 * t[T - 1], v[k++] = 2 * t[T - 1] + 1;
        }
        O(u);
        const A = k;
        O(f);
        const I = k;
        O(d);
        const E = k;
        O(m);
        return {
            vertices: v,
            triangles: _,
            numVerticesWithoutSkirts: r,
            numTrianglesWithoutSkirts: h,
            leftSkirtIndex: A,
            rightSkirtIndex: I,
            bottomSkirtIndex: E,
            topSkirtIndex: k
        };
    }
}

const qi = {};

function $i(t, i, e) {
    let s = qi[e];
    s || (s = qi[e] = new Vi(e));
    const n = s.createTile(i).getMeshWithSkirts(t, !0), {triangles: r, vertices: h, leftSkirtIndex: o, rightSkirtIndex: a, bottomSkirtIndex: l, topSkirtIndex: c} = n;
    let {numVerticesWithoutSkirts: u, numTrianglesWithoutSkirts: f} = n;
    u || (u = h.length / 2, f = r.length / 3);
    const d = h.length / 2, m = new Float32Array(3 * d), g = new Float32Array(2 * d);
    let p = 1 / 0, w = -1 / 0;
    const v = e - 1;
    for (let t = 0; t < d; t++) {
        const s = h[2 * t], n = h[2 * t + 1];
        if (t >= u) {
            const i = s / 2 * 3;
            let e, n = .001;
            (t - (t < o / 2 ? u : t < a / 2 ? o / 2 : t < l / 2 ? a / 2 : l / 2)) % 3 == 0 ? (e = Math.min(0, p), 
            n = 0) : e = m[i + 2];
            m[3 * t] = m[i], m[3 * t + 1] = m[i + 1], m[3 * t + 2] = e, g[2 * t] = m[i] / v + n, 
            g[2 * t + 1] = -m[i + 1] / v + n;
        } else {
            const r = i[n * e + s];
            m[3 * t] = 1 * s, m[3 * t + 1] = 1 * -n, m[3 * t + 2] = r, g[2 * t] = s / v, g[2 * t + 1] = n / v, 
            r < p && (p = r), r > w && (w = r);
        }
    }
    return {
        positions: m,
        texcoords: g,
        triangles: r,
        leftSkirtIndex: o,
        rightSkirtIndex: a,
        bottomSkirtIndex: l,
        topSkirtIndex: c,
        numTrianglesWithoutSkirts: f,
        numVerticesWithoutSkirts: u,
        minHeight: Math.min(0, p),
        maxHeight: w,
        terrainWidth: e
    };
}

function Xi(t, i, e, s, n, r, h, o, a) {
    const l = {};
    for (let c = 0; c < a; c++) l[c + ""] = Ji(t, i, e, s, n, r, h, o, c);
    return l;
}

const Yi = [];

function Ji(t, i, e, s, n, r, h, o, a) {
    if ((s -= a) <= 0) return Yi;
    const l = t.getTileSize().width, c = t._getTileOffset(s, n), u = r[0] - c[0], f = c[1] - r[1], d = t._getTileConfig(), m = t.getSpatialReference().getResolution(s), g = d.tileSystem.scale.y, p = 1e-7;
    let w = 0, v = 0, _ = o /= Math.pow(2, a), y = o;
    if (u < 0 ? _ += Math.ceil(-u / l - p) : u > 0 && (w -= Math.ceil(u / l - p)), f > 0 ? v -= Math.ceil(f / l - p) : f < 0 && (y += Math.ceil(-f / l - p)), 
    0 === w && 0 === v && _ <= 1 && y <= 1) {
        const n = Math.floor(i * o);
        let r = Math.floor(e * o);
        const a = r;
        return g !== h && (r = Qi(d, r, m)), [ {
            x: n,
            y: r,
            skinY: a,
            z: s,
            offset: c,
            tileSize: l,
            id: t._getTileId(n, r, s)
        } ];
    }
    const b = [];
    for (let n = w; n < _; n++) for (let r = v; r < y; r++) {
        const a = i * o + n;
        let u = e * o + r;
        const f = u;
        g !== h && (u = Qi(d, u, m)), b.push({
            x: a,
            y: u,
            skinY: f,
            z: s,
            offset: c,
            tileSize: l,
            id: t._getTileId(a, u, s)
        });
    }
    return b;
}

function Zi(t, i, e, s) {
    let n = t / e * s / i;
    return n < 1 ? (n = 1 / n, n = 1 / Math.round(n)) : n = Math.round(n), n;
}

function Ki(t, i, e) {
    const s = t.getResolution(i), n = i - Math.log(e / s) * Math.LOG2E;
    return {
        zoom: n,
        res: t.getResolution(n)
    };
}

function Qi(t, i, e) {
    const s = t.fullExtent, n = t.tileSize.width, r = Math.max(s.top, s.bottom), h = Math.min(s.top, s.bottom);
    return Math.ceil(r / n / e) - 1 - Math.floor(h / n / e) - i;
}

function te(t, i) {
    const e = i * i, s = 0 !== t ? new Float32Array(e) : new Uint8Array(e);
    return s.fill(t), {
        data: s,
        width: i,
        height: i,
        max: t,
        min: t
    };
}

new t.Point(0, 0);

const ie = te(0, 5), ee = $i(1, ie.data, ie.width);

function se(t, i, e) {
    const s = e && e.includes;
    if (s) for (const n in s) s[n] && (e[n].uniformDeclares && i.push(...e[n].uniformDeclares), 
    e[n].defines && ut(t, e[n].defines));
}

function ne(t, i) {
    const e = i && i.includes;
    if (e) for (const s in e) e[s] && i[s].renderUniforms && ut(t, i[s].renderUniforms);
}

ee.empty = !0;

var re = Object.freeze({
    __proto__: null,
    fillIncludes: se,
    setIncludeUniformValues: ne
});

const he = [], oe = [];

class ae {
    constructor(t) {
        this.layer = t, this.regl = t.getRenderer().regl, this.renderer = new a.Renderer(this.regl), 
        this.Se = new a.Scene;
        const i = new Uint8Array(16);
        i.fill(255), this.Ce = this.regl.texture({
            width: 2,
            height: 2,
            data: i
        }), this.ke = new a.ResourceLoader(this.Ce), this.Te();
    }
    setToRedraw() {
        this.layer.getRenderer().setToRedraw();
    }
    getMap() {
        return this.layer.getMap();
    }
    startFrame(t) {
        t && t.states && t.states.includesChanged && (this.shader.dispose(), delete this.shader), 
        this.shader || this.initShader(t), this.Se.clear();
    }
    createTerrainMesh(t, i) {
        const {mesh: e, image: s} = i;
        let n = i.terrainMesh;
        const {positions: r, texcoords: h, triangles: o, empty: l} = e;
        if (n && n.geometry !== this.Oe) n.geometry.updateData("aPosition", r), n.geometry.updateData("aTexCoord", h), 
        n.geometry.setElements(o); else {
            const t = l ? this.Oe : new a.Geometry({
                aPosition: r,
                aTexCoord: h
            }, o, 0);
            n ? n.geometry = t : (n = new a.Mesh(t, null, {
                disableVAO: !0
            }), t.generateBuffers(this.regl));
        }
        if (!n.uniforms.skin) {
            const t = this.getEmptyTexture();
            n.setUniform("skin", t);
        }
        return n.setUniform("heightTexture", s), this.prepareMesh(n, t, i), n;
    }
    Ae(t) {
        const i = this.layer.getRenderer();
        i && i.updateMaskDefines(t);
    }
    Ie(t) {
        const i = this.Ee(), e = l.identity(t);
        return l.scale(e, e, [ 1, 1, i ]), e;
    }
    Ee() {
        let t = this.layer.options.exaggeration;
        return ft(t) && (t = 1), this.Le(100) / 100 * t;
    }
    Pe(t, i, e) {
        const s = this.getMap(), n = this.layer.getTileSize().width, r = i.res / s.getGLRes(), h = n / (e - 1), {extent2d: o, offset: a} = i;
        c.set(he, (o.xmin - a[0]) * r, (i.extent2d.ymax - a[1]) * r, 0);
        const u = l.identity(t);
        return l.translate(u, u, he), c.set(oe, r * h, r * h, 1), l.scale(u, u, oe), u;
    }
    prepareMesh(t, i, e) {
        if (!t.isValid()) return;
        const {mesh: s} = e;
        this.Ae(t);
        const {triangles: n, numTrianglesWithoutSkirts: r, terrainWidth: h} = s;
        t.localTransform = this.Pe(t.localTransform || [], i, h), t.positionMatrix = this.Ie(t.positionMatrix || []), 
        t.properties.skirtOffset = 3 * r, t.properties.skirtCount = n.length - 3 * r, t.properties.z = i.z, 
        t.properties.minHeight = s.minHeight, t.properties.maxHeight = s.maxHeight, t.properties.terrainWidth = h, 
        t.castShadow = !1, wt(t.uniforms, "minAltitude") || Object.defineProperty(t.uniforms, "minAltitude", {
            enumerable: !0,
            get: () => e.minAltitude || 0
        });
    }
    addTerrainImage(t, i) {
        const e = i.terrainMesh;
        e && e.geometry && i.skin && (e.setUniform("skin", i.skin.color[0]), e.setUniform("polygonOpacity", 1), 
        this.Se.addMesh(e));
    }
    endFrame(t) {
        this.updateIBLDefines(this.shader);
        let i = 0;
        const e = this.getUniformValues(), s = this.Re(t);
        return this.shader.filter = t && t.sceneFilter, ne(e, t), this.Se.getMeshes().forEach((t => {
            this.Ae(t);
        })), i += this.renderer.render(this.shader, e, this.Se, s), i;
    }
    delete() {
        this.shader && (this.shader.dispose(), delete this.shader), this.Ce && (this.Ce.destroy(), 
        delete this.Ce), this.Oe && (this.Oe.dispose(), delete this.Oe);
    }
    deleteMesh(t) {
        if (!t) return;
        const i = t.geometry;
        t.dispose(), i !== this.Oe && i.dispose();
    }
    initShader(t) {
        const i = [], e = [], s = {}, n = [];
        se(s, n, t), this.shader = new a.MeshShader({
            vert: "#define SHADER_NAME TERRAIN_MESH\nattribute vec3 aPosition;\nattribute vec2 aTexCoord;\nuniform float minAltitude;\nuniform mat4 projViewModelMatrix;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nuniform float heightScale;\nvarying vec2 vUv;\n#include <mask_vert>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n    #include <vsm_shadow_vert>\n#endif\nvoid main() {\n    vec4 position = vec4(aPosition.xy, (aPosition.z + minAltitude) * heightScale, 1.0);\n    position = positionMatrix * position;\n    #ifdef HAS_MASK_EXTENT\n        gl_Position = projMatrix * getMaskPosition(position, modelMatrix);\n    #else\n        gl_Position = projViewModelMatrix * position;\n    #endif\n    vUv = aTexCoord;\n    #if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n        shadow_computeShadowPars(position);\n    #endif\n}",
            frag: "#define SHADER_NAME TERRAIN_MESH\nprecision mediump float;\nuniform sampler2D skin;\nuniform float polygonOpacity;\nvarying vec2 vUv;\n#include <mask_frag>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n    #include <vsm_shadow_frag>\n#endif\nvoid main() {\n    vec2 uv = vec2(vUv);\n    uv.y = 1.0 - uv.y;\n    vec4 color = texture2D(skin, uv);\n    #if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n        float shadowCoeff = shadow_computeShadow();\n        color.rgb = shadow_blend(color.rgb, shadowCoeff).rgb;\n    #endif\n    gl_FragColor = color * polygonOpacity;\n    #ifdef HAS_MASK_EXTENT\n      gl_FragColor = setMask(gl_FragColor);\n    #endif\n}",
            uniforms: n.concat([ {
                name: "modelViewMatrix",
                type: "function",
                fn: function(t, i) {
                    return l.multiply(e, i.viewMatrix, i.modelMatrix);
                }
            }, {
                name: "projViewModelMatrix",
                type: "function",
                fn: function(t, e) {
                    return l.multiply(i, e.projViewMatrix, e.modelMatrix);
                }
            } ]),
            defines: s,
            extraCommandProps: this.getExtraCommandProps()
        });
    }
    getExtraCommandProps() {
        const t = this.layer.getRenderer().canvas;
        return {
            viewport: {
                x: 0,
                y: 0,
                width: () => t ? t.width : 1,
                height: () => t ? t.height : 1
            },
            stencil: {
                enable: !1
            },
            cull: {
                enable: !0,
                face: "back"
            },
            depth: {
                enable: !0,
                mask: () => !!this.layer.options.depthMask,
                func: this.layer.options.depthFunc || "<="
            },
            blend: {
                enable: !0,
                func: {
                    src: this.layer.options.blendSrc,
                    dst: this.layer.options.blendDst
                },
                equation: "add"
            }
        };
    }
    Re(t) {
        return t && t.renderTarget && t.renderTarget.fbo;
    }
    getUniformValues() {
        const t = this.getMap(), i = t.projViewMatrix, e = this.layer.getRenderer().getMaskUniforms(), s = {
            viewMatrix: t.viewMatrix,
            projMatrix: t.projMatrix,
            projViewMatrix: i,
            heightScale: 1
        };
        return ut(s, e), s;
    }
    Le(t) {
        const i = this.layer.getMap();
        if (!i) return null;
        return i.altitudeToPoint(t, i.getGLRes());
    }
    getEmptyTexture() {
        return this.Ce;
    }
    hasIBL() {
        const t = this.getMap().getLightManager();
        return !!(t && t.getAmbientResource());
    }
    updateIBLDefines(t) {
        const i = t.shaderDefines;
        let e = !1;
        this.hasIBL() ? i[[ "HAS_IBL_LIGHTING" ]] || (i.HAS_IBL_LIGHTING = 1, e = !0) : i[[ "HAS_IBL_LIGHTING" ]] && (delete i.HAS_IBL_LIGHTING, 
        e = !0), e && (t.shaderDefines = i);
    }
    Te() {
        const t = ee, {positions: i, texcoords: e, triangles: s} = t;
        this.Oe = new a.Geometry({
            aPosition: i,
            aTexCoord: e
        }, s, 0), this.Oe.generateBuffers(this.regl);
    }
}

const {getIBLResOnCanvas: le, getPBRUniforms: ce, loginIBLResOnCanvas: ue, logoutIBLResOnCanvas: fe} = a.pbr.PBRUtils, de = {
    baseColorFactor: [ 1, 1, 1, 1 ],
    emissiveFactor: [ 0, 0, 0 ],
    baseColorIntensity: 1,
    emitColorFactor: 1,
    roughnessFactor: 1,
    metallicFactor: 0,
    emitMultiplicative: 1,
    outputSRGB: 1,
    hsv: [ 0, 0, 0 ],
    contrast: 1,
    alphaTest: 0
};

class me extends ae {
    constructor(...t) {
        super(...t), this.createIBLTextures(), this.Fe = 0;
    }
    updateMaterial(t, i) {
        this.Fe = i, this.He = this.He || {}, ut(this.He, t), this.setToRedraw();
    }
    setMaterial(t, i) {
        this.Fe = i, this.He = ut({}, de, t), this.setToRedraw();
    }
    createIBLTextures() {
        const t = this.getMap().getRenderer().canvas;
        ue(t, this.regl, this.getMap()), this.layer.fire("iblupdated");
    }
    disposeIBLTextures() {
        const t = this.getMap().getRenderer().canvas;
        fe(t, this.getMap());
    }
    createTerrainMesh(t, i) {
        const {mesh: e, image: s} = i, {positions: n, texcoords: r, triangles: h, leftSkirtIndex: o, rightSkirtIndex: l, bottomSkirtIndex: c, numVerticesWithoutSkirts: u} = e, f = new Int8Array(n.length);
        for (let t = 2; t < f.length; t += 3) t < 3 * u ? f[t] = 1 : t < o / 2 * 3 ? f[t - 2] = -1 : t < l / 2 * 3 ? f[t - 2] = 1 : f[t - 1] = t < c / 2 * 3 ? -1 : 1;
        const d = new a.Geometry({
            aPosition: n,
            aTexCoord: r,
            aNormal: f
        }, h, 0);
        let m;
        d.createTangent(), delete d.data.aNormal, d.generateBuffers(this.regl), m = s ? this.regl.texture({
            width: s.width,
            height: s.height,
            data: s,
            min: "linear",
            mag: "linear"
        }) : this.getEmptyTexture();
        const g = this.getEmptyTexture(), p = ut({}, de, this.layer.options.material || {});
        p.skinTexture = g, p.terrainHeightTexture = m;
        const w = new a.pbr.StandardMaterial(p), v = new a.Mesh(d, w);
        v.properties.matVer = this.Fe;
        const _ = v.defines;
        return _.HAS_UV_FLIP = 1, _.HAS_TERRAIN_NORMAL = 1, _.HAS_MAP = 1, v.defines = _, 
        this.prepareMesh(v, t, i), v;
    }
    addTerrainImage(t, i) {
        const e = i.terrainMesh;
        if (e) {
            if (this.He && e.properties.matVer !== this.Fe) {
                for (const t in this.He) e.material.set(t, this.He[t]);
                e.properties.matVer = this.Fe;
            }
            i.skin && e.material.set("skinTexture", i.skin), e.setUniform("polygonOpacity", 1), 
            this.Se.addMesh(e);
        }
    }
    getUniformValues() {
        const t = this.getMap(), i = t.getRenderer().canvas, {iblTexes: e, dfgLUT: s} = le(i), n = ce(t, e, s), r = this.layer.getTileSize().width, h = this.layer.getRenderer().getMaskUniforms();
        return ut(n, {
            viewMatrix: t.viewMatrix,
            projMatrix: t.projMatrix,
            projViewMatrix: t.projViewMatrix,
            outSize: [ i.width, i.height ],
            polygonFill: [ 1, 1, 1, 1 ],
            terrainHeightMapResolution: [ r, r ],
            terrainResolution: [ i.width, i.height ],
            terrainUnpackFactors: [ 6553.6, 25.6, .1, 1e4 ]
        }), ut(n, h), n;
    }
    initShader(t) {
        const i = {}, e = [];
        se(i, e, t), this.shader = new a.pbr.StandardShader({
            uniforms: e,
            defines: i,
            extraCommandProps: this.getExtraCommandProps()
        });
    }
    delete() {
        return this.disposeIBLTextures(), super.delete();
    }
}

function ge(t, i, e, s) {
    const n = pe.call(this, e, s);
    this._projViewMatrix = i;
    const {colorExtent: r, modeExtent: h} = this._extentPass.render(n, i);
    this._maskUniforms = this._maskUniforms || {}, this._maskUniforms.mask_colorExtent = r, 
    this._maskUniforms.mask_extent = t, this._maskUniforms.mask_modeExtent = h, this._maskUniforms.mask_hasFlatOut = ve.call(this, "flat-outside"), 
    this._maskUniforms.mask_hasClipOut = ve.call(this, "clip-outside"), this._maskUniforms.mask_hasVideo = ve.call(this, "video"), 
    this._maskUniforms.mask_heightRatio = e, this._maskUniforms.mask_heightOffset = s, 
    this.setToRedraw();
}

function pe(t, i) {
    const e = [], s = this.layer.getMasks();
    for (let n = 0; n < s.length; n++) {
        const r = s[n].getMesh(this.regl, t, i);
        r && e.push(r);
    }
    return e;
}

function we() {
    if (!this._extentPass || !this._maskUniforms) return;
    const t = this._maskUniforms.mask_heightRatio, i = this._maskUniforms.mask_heightOffset, e = pe.call(this, t, i);
    this._extentPass.render(e, this._projViewMatrix);
    const s = this.layer.getMasks();
    for (let t = 0; t < s.length; t++) s[t].De && s[t].De();
}

function ve(t) {
    const i = this.layer.getMasks();
    for (let e = 0; e < i.length; e++) if (i[e].getMode() === t) return 1;
    return 0;
}

function _e() {
    const t = this.layer.getMasks();
    if (!t) return !1;
    for (let i = 0; i < t.length; i++) if (t[i].Ne) return t[i].Ne();
    return !1;
}

function ye(t) {
    return class extends t {
        setMask(t, i, e, s) {
            this.viewport || (this.viewport = {
                x: 0,
                y: 0,
                width: () => this.canvas ? this.canvas.width : 1,
                height: () => this.canvas ? this.canvas.height : 1
            }), this._extentPass ? ge.call(this, t, i, e, s) : this.regl ? (this._extentPass = new a.ExtentPass(this.regl, this.viewport), 
            ge.call(this, t, i, e, s)) : this.layer.once("contextcreate", (() => {
                this._extentPass = new a.ExtentPass(this.regl, this.viewport), ge.call(this, t, i, e, s);
            }), this);
        }
        needToRedraw() {
            return !!super.needToRedraw() || !!_e.call(this);
        }
        getMaskUniforms() {
            return _e.call(this) && we.call(this), this.layer.updateMaskExtent(), this._maskUniforms;
        }
        getMaskDefines() {
            return this._maskDefines || (this._maskDefines = {}), this._maskUniforms && this._maskUniforms.mask_colorExtent ? this._maskDefines.HAS_MASK_EXTENT = 1 : delete this._maskDefines.HAS_MASK_EXTENT, 
            this._maskDefines;
        }
        updateMaskDefines(t) {
            const i = t.getDefines();
            delete i.HAS_MASK_EXTENT;
            ut(i, this.getMaskDefines()), t.setDefines(i);
        }
        _clearMask() {
            this._deleteMaskUniforms(), this._extentPass && (this._extentPass.dispose(), delete this._extentPass), 
            this.setToRedraw();
        }
        _deleteMaskUniforms() {
            delete this._maskUniforms;
        }
    };
}

class be {
    constructor(t, i) {
        this.max = t, this.onRemove = i, this.reset();
    }
    reset() {
        if (this.data) {
            const t = this.data.values();
            for (const i of t) this.onRemove(i);
        }
        return this.data = new Map, this;
    }
    clear() {
        this.reset(), delete this.onRemove;
    }
    add(t, i) {
        return i ? (this.has(t) ? (this.data.delete(t), this.data.set(t, i)) : this.data.set(t, i), 
        this) : this;
    }
    keys() {
        const t = new Array(this.data.size);
        let i = 0;
        const e = this.data.keys();
        for (const s of e) t[i++] = s;
        return t;
    }
    has(t) {
        return this.data.has(t);
    }
    getAndRemove(t) {
        if (!this.has(t)) return null;
        const i = this.data.get(t);
        return this.data.delete(t), i;
    }
    get(t) {
        if (!this.has(t)) return null;
        return this.data.get(t);
    }
    pop() {
        if (this.data.size < this.max) return null;
        const t = this.data.keys().next();
        return this.data.get(t.value).current ? (this.max += Math.ceil(this.max / 2), null) : this.getAndRemove(t.value);
    }
    remove(t) {
        if (!this.has(t)) return this;
        const i = this.data.get(t);
        return this.data.delete(t), this.onRemove(i), this;
    }
    resetCurrent(t) {
        this.data && this.data.forEach((i => {
            i.current = t;
        }));
    }
}

const xe = new t.Point(0, 0), Me = new t.Point(0, 0), Se = new t.PointExtent(0, 0, 0, 0), Ce = new t.Point(0, 0), ke = new t.Point(20, 20), Te = {
    color: [ 0, 0, 0, 0 ],
    depth: 1,
    stencil: 0
};

class Oe extends(ye(t.renderer.TileLayerCanvasRenderer)){
    isDrawable() {
        return !0;
    }
    getTempTileOnLoading(t, i) {
        if (i.image && !i.image.reset) return i;
        this.Ge(t, "getTempTileOnLoading");
        const e = this.je(t);
        return e.temp = !0, i.image || (i.image = e), delete i.image.reset, i.current = !0, 
        i.info = t, ut(i.image, e), this.Be(i.image, t), i;
    }
    ze(t, i, e) {
        i.reset = !0, delete i.data, delete i.loadTime, delete i.rendered, delete i.minAltitude;
        const s = t.id + "-temp", n = i.skinImages;
        if (n) for (let t = 0; t < n.length; t++) {
            const i = n[t];
            if (i) {
                for (let t = 0; t < i.length; t++) {
                    const n = i[t];
                    n && (n.refs.delete(s), n.refs.size || e.push(n));
                }
                delete i.currentSkins, delete i.tileIds;
            }
        }
        delete i.sourceZoom, delete i.skinImages, delete i.skinStatus, delete i.skinTileIds, 
        i.debugTexture && (i.debugTexture.destroy(), delete i.debugTexture);
    }
    je(t, i) {
        for (i = i || this.findParentTile(t); i && i.image && (-1 === i.image.sourceZoom || i.image.originalError); ) i = this.findParentTile(i.info);
        const e = t.res, s = this.getMap().pointAtResToDistance(1, 1, e), n = i && i.image && i.image.data && this.Ue(i, t), r = n && -1 !== i.image.sourceZoom ? i.info.z : -1;
        if (!n || n.width <= 1) {
            const e = this.Ve(t, i);
            return {
                data: te(e || 0, 5),
                minAltitude: e,
                mesh: ee,
                sourceZoom: r
            };
        }
        const h = n.width;
        return {
            data: n,
            mesh: $i(s / 2, n.data, h),
            sourceZoom: r
        };
    }
    Ve(t, i) {
        if (i && i.minAltitude) return i.minAltitude;
        const {idx: e, idy: s, z: n} = t;
        for (let t = -1; t <= 1; t++) for (let i = -1; i <= 1; i++) {
            if (0 === t && 0 === i) continue;
            const r = this.layer.getTileId(e + t, s + i, n), h = this.layer.tileInfoCache, o = h && h.get(r);
            if (o && o.minAltitude) return o.minAltitude;
        }
        return 0;
    }
    consumeTile(t, i) {
        if (this.Ge(i, "consumeTile"), t.empty && !t.mesh) {
            const e = this.findParentTile(i);
            if (!e || e.image && e.image.empty) {
                t.mesh = ee;
                const e = this.Ve(i);
                t.data = te(e || 0, 5), t.minAltitude = e, t.sourceZoom = -1;
            } else t = this.je(i, e);
        }
        this.Be(t, i), super.consumeTile(t, i), this.We(i);
    }
    Be(t, i) {
        if (t && t.mesh) {
            t.terrainMesh = this.qe.createTerrainMesh(i, t), i.minAltitude = t.data.min, i.maxAltitude = t.data.max, 
            delete t.mesh;
            const e = this.layer.tileInfoCache;
            if (e && i.parent && !t.empty && !t.temp) {
                const t = e.get(i.parent);
                if (t) {
                    const {minAltitude: e, maxAltitude: s} = i;
                    (void 0 === t.minAltitude || t.minAltitude > e) && (t.minAltitude = e), (void 0 === t.maxAltitude || t.maxAltitude < s) && (t.maxAltitude = s);
                }
            }
        }
    }
    We(t) {
        const i = this.getMap();
        if (i.updateCenterAltitude && void 0 === i.centerAltitude && t.z === this.getCurrentTileZoom()) {
            const e = i._getPrjCenter(), s = i._prjToPointAtRes(e, t.res, Ce);
            t.extent2d.contains(s) && i.updateCenterAltitude();
        }
    }
    draw(t, i) {
        this.$e(), this.qe.startFrame(i), super.draw(t, i), this.Xe(i);
    }
    drawTile(t, i) {
        const e = this.getMap();
        if (!t || !e || !i) return;
        if (!this.drawingCurrentTiles && !this.drawingChildTiles) return;
        this.Ge(t, "drawTile");
        let s = this.drawingCurrentTiles ? this.getTileOpacity(i) : 1;
        s *= this.layer.options.opacity || 1, this.qe.addTerrainImage(t, i, s);
    }
    _drawTiles(t, i, e, s, n, r, h) {
        const o = [];
        this.Ye = 0;
        const a = this.layer.getSkinCount(), l = new Set;
        if (h && h.length) {
            vt(r, h.map((t => t.info)));
            for (let t = 0; t < a; t++) this.Je(t, h, l, o);
        }
        vt(t, this.Ze(r, o)), this.Ge(t, "drawTiles");
        for (let i = 0; i < a; i++) this.Je(i, t, l, o);
        for (let i = 0; i < t.length; i++) this.Ke(t[i].info, t[i].image);
        for (let t = 0; t < o.length; t++) o[t] && o[t].texture && !o[t].refs.size && (this.Qe.delete(o[t].tile.id), 
        this.ts(o[t]));
        return this.es(), super._drawTiles(...arguments);
    }
    Ze(t, i) {
        const e = [];
        let s = this.ss;
        s || (s = this.ss = new be(this.layer.options.tempTileCacheSize, (t => {
            const {info: i, image: e} = t;
            this.ns(i, e);
        }))), s.resetCurrent(!1);
        for (let n = 0; n < t.length; n++) {
            const r = t[n];
            let h;
            this.Ge(r, "getTempTilesForMissed"), s.has(r.id) ? h = s.getAndRemove(r.id) : (h = s.pop(), 
            h ? h.image && (this.ze(h.info, h.image, i), h.image.temp = !0) : h = {
                info: r
            }), h.current = !0, s.add(r.id, h), e.push(h);
        }
        for (let i = 0; i < t.length; i++) this.getTempTileOnLoading(t[i], e[i]);
        return e;
    }
    es() {
        if (!this.Qe) return;
        const t = this.getCurrentTimestamp();
        if (this.rs && t - this.rs < 1e3) return;
        const i = new Set;
        for (const t of this.tileCache.data.values()) this.hs(t, i);
        for (const t in this.tilesInView) {
            const e = this.tilesInView[t];
            this.hs(e, i);
        }
        if (this.ss) for (const t of this.ss.data.values()) this.hs(t, i);
        i.size && (this.Qe.forEach(((t, e) => {
            i.has(e) || (console.log("deleted:", e), this.ts(this.Qe.get(e)), this.Qe.delete(e));
        })), this.rs = t);
    }
    hs(t, i) {
        const e = t.image && t.image.skinImages;
        if (e && e.length) for (let t = 0; t < e.length; t++) {
            const s = e[t] && e.currentSkins;
            if (s) for (const t of s) i.add(t);
        }
    }
    Je(t, i, e, s) {
        const n = this.layer.getSkinLayer(t).getRenderer();
        if (!n) return;
        const r = [];
        for (let n = 0; n < i.length; n++) {
            const {info: h, image: o} = i[n];
            if (this.Ge(h, "renderChildTerrainSkin"), this.os(t, h, o, s)) {
                const s = i[n].image.skinImages[t];
                for (let t = 0; t < s.length; t++) {
                    const i = s[t].tile.info.id;
                    e.has(i) || (r.push(s[t]), e.add(i));
                }
            }
        }
        n.renderTerrainSkin(this.regl, this.layer, r);
    }
    os(t, i, e, s) {
        const n = this.getMap();
        if (delete e.path, !i || !n || !e) return !1;
        if (!e.terrainMesh) return !1;
        const r = this.layer.getSkinLayer(t), h = r.getRenderer();
        if (!h) return !1;
        e.skinImages || (e.skinImages = []), e.skinStatus || (e.skinStatus = []), e.skinTileIds || (e.skinTileIds = []);
        const o = h.isAnimating && h.isAnimating(), a = e.skinStatus[t], l = h.needToRefreshTerrainTileOnZooming && h.needToRefreshTerrainTileOnZooming(), c = o || l && e.renderedZoom !== n.getZoom();
        if (a && !c) return !1;
        const u = r.getSpatialReference(), {x: f, y: d, z: m, res: g, offset: p} = i;
        let w = i.nw;
        w || (w = i.nw = this.getMap().pointAtResToCoord(i.extent2d.getMin(xe), i.res));
        const v = this.layer.getTileSize().width;
        let {res: _, zoom: y} = Ki(u, m, g);
        let b = Zi(_, r.getTileSize().width, g, v), x = e.skinTileIds[t];
        if (!x) {
            const i = this.layer._getTileConfig().tileSystem.scale.y, s = r.options.maxAvailableZoom;
            !ft(s) && s >= 0 && y > s && (b *= Math.pow(2, s - y), y = s), x = e.skinTileIds[t] = Xi(r, f, d, y, w, p, i, b, Ae);
        }
        const M = x[0];
        let S = !0;
        const C = [];
        for (let t = 0; t < M.length; t++) {
            const i = h.getCachedTile(M[t], !1);
            if (i) C.push(i); else {
                S = !1;
                const i = h.findParentTile(M[t]);
                i && C.push(i);
            }
        }
        const k = e.skinImages[t] || [];
        k.currentSkins = k.currentSkins || new Set;
        const T = new Set;
        let O = !1;
        for (let t = 0; t < k.length; t++) {
            if (!k[t].tile) {
                O = !0;
                continue;
            }
            const i = k[t].tile.info.id;
            T.add(i);
        }
        if (!C.length) return k.currentSkins.clear(), e.skinImages[t] = [], !1;
        const A = C.length ? C.map((t => t.info.id)).join() : C[0].info.id;
        if (!c && !O && k.tileIds === A) return !1;
        k.tileIds = A;
        let I = !1;
        k.currentSkins.clear(), k.length = 0;
        const E = k.currentSkins;
        let L = i.id;
        e.temp && (L += "-temp");
        for (let t = 0; t < C.length; t++) {
            const i = C[t].info.id;
            E.add(i);
            let e = this.ls(i);
            e && ((P = e) && P.texture) || (e = {
                tile: ut({}, C[t]),
                layer: r,
                refs: new Set,
                texture: h.createTerrainTexture(this.regl)
            }, this.cs(i, e)), e.refs.add(L), k.push(e), I = !0;
        }
        var P;
        return this.us(i, e, T, E, s), I && this.Ye++, e.skinImages[t] = k, r.fire("renderterrainskin", {
            tile: i,
            skinTiles: C
        }), S && (e.skinStatus[t] = 1), !0;
    }
    us(t, i, e, s, n) {
        if (!e.size) return;
        let r = t.id;
        i.temp && (r += "-temp");
        for (const t of e) if (!s || !s.has(t)) {
            const i = this.ls(t);
            this.fs(i, r, n);
        }
    }
    ls(t) {
        return this.Qe || (this.Qe = new Map), this.Qe.get(t);
    }
    cs(t, i) {
        this.Qe.set(t, i);
    }
    Ke(t, i) {
        const e = this.getMap();
        if (!t || !e || !i) return;
        this.Ge(t, "_renderTerrainMeshSkin");
        const s = i.skinImages, n = this.ds(i.renderedZoom);
        if (i.rendered && !n) return;
        i.skin ? (Te.framebuffer = i.skin, this.regl.clear(Te)) : i.skin = this.gs(t, i), 
        this.ps();
        const r = this.layer.options.debug, h = [], o = r && [], l = this.layer.getTileSize().width;
        if (s) for (let i = 0; i < s.length; i++) {
            const e = s[i];
            for (let i = 0; i < e.length; i++) {
                const {tile: s, texture: n, layer: r} = e[i];
                if ((s.info.offset[0] || s.info.offset[1]) && t.skinTileIds) {
                    const i = t.skinTileIds[r.getId()];
                    for (let t = 0; t < i.length; t++) if (s.info.x === i[t].x && s.info.y === i[t].y) {
                        s.info.offset = i[t].offset;
                        break;
                    }
                }
                const o = Ee(t, s, l), c = e[i].skinMesh || new a.Mesh(this.ws);
                c.setUniform("skinTexture", n);
                const u = r.getOpacity();
                c.setUniform("opacity", ft(u) ? 1 : u), c.setUniform("skinDim", o), c.setUniform("tileSize", l), 
                c.setUniform("x", t.x), c.setUniform("y", t.y), e[i].skinMesh = c, h.push(c);
            }
        }
        if (r) {
            const e = i.skinDebugMesh || new a.Mesh(this.ws);
            e.setUniform("tileSize", l);
            const s = i.debugTexture || this.vs(t, l, i.temp);
            i.debugTexture = s, i.skinDebugMesh = e, e.setUniform("opacity", 1), e.setUniform("skinTexture", s), 
            e.setUniform("skinDim", [ 0, 0, 1 ]), e.setUniform("tileSize", l), o.push(e);
        }
        if (h.length) {
            this._s.setMeshes(h);
            try {
                this.renderer.render(this.ys, null, this._s, i.skin);
            } catch (t) {
                throw console.error(i), t;
            }
        }
        o && o.length && this.layer.options.debug && (this._s.setMeshes(o), this.renderer.render(this.ys, null, this._s, i.skin)), 
        i.rendered = this.bs(i), i.renderedZoom = e.getZoom();
    }
    vs(t, i, e) {
        i *= 2;
        const {x: s, y: n, z: r} = t, h = `terrain:${s}/${n}/${r}` + (e ? "-temp" : ""), o = document.createElement("canvas");
        o.width = i, o.height = i;
        const a = o.getContext("2d");
        a.font = "60px monospace";
        const l = this.layer.options.debugOutline;
        return a.fillStyle = l, a.strokeStyle = l, a.fillText(h, 20, i - 40), a.beginPath(), 
        a.lineWidth = 4, a.moveTo(0, 0), a.lineTo(i, 0), a.lineTo(i, i), a.lineTo(0, i), 
        a.lineTo(0, 0), a.stroke(), this.regl.texture({
            data: o,
            flipY: !0,
            mag: "linear",
            min: "linear"
        });
    }
    gs(t) {
        const i = this.layer.getTileSize().width, e = 2 * i, s = 2 * i, n = this.regl, r = t.colorsTexture;
        let h;
        h = r && r instanceof Uint8Array ? n.texture({
            data: r,
            min: "linear",
            mag: "linear",
            type: "uint8",
            width: e,
            height: s,
            flipY: !0
        }) : n.texture({
            min: "linear",
            mag: "linear",
            type: "uint8",
            width: e,
            height: s,
            flipY: !0
        });
        const o = {
            width: e,
            height: s,
            colors: [ h ],
            colorFormat: "rgba",
            ignoreStatusCheck: !0,
            depthStencil: !1,
            depth: !1,
            stencil: !1
        }, a = n.framebuffer(o);
        return a.colorTex = h, a;
    }
    Xe(t) {
        this.qe.endFrame(t) && !Object.keys(this.tilesLoading).length && this.layer.fire("terrainreadyandrender");
    }
    Ue(t, i) {
        const {image: e, info: s} = t, n = e.data, r = n.width, {extent2d: h, res: o} = s, {extent2d: a, res: l} = i, c = h.getWidth(), u = h.getHeight();
        let f = (a.xmin * l / o - h.xmin) / c * (r - 1), d = (h.ymax - a.ymax * l / o) / u * (r - 1);
        const m = (a.xmax * l / o - h.xmin) / c * (r - 1);
        let g = Math.round(m - f);
        const p = Math.log2(g);
        g = Math.pow(2, Math.round(p)) + 1, f = Math.floor(f), d = Math.floor(d);
        const w = new Float32Array(g * g);
        let v = 1 / 0, _ = -1 / 0;
        for (let t = 0; t < g; t++) for (let i = 0; i < g; i++) {
            let e = t + f, s = i + d;
            e > r - 1 ? e = r - 1 : e < 0 && (e = 0), s > r - 1 ? s = r - 1 : s < 0 && (s = 0);
            const h = n.data[e + s * r];
            w[t + i * g] = h, h < v && (v = h), h > _ && (_ = h);
        }
        return {
            width: g,
            height: g,
            data: w,
            min: v,
            max: _
        };
    }
    getTileOpacity(t) {
        return this.bs(t) ? super.getTileOpacity(t) : (this.resetTileLoadTime(t), 0);
    }
    bs(t) {
        const i = this.layer.getSkinCount();
        if (!i) return !0;
        if (!t.skinStatus) return !1;
        for (let e = 0; e < i; e++) if (!t.skinStatus[e]) return !1;
        return !0;
    }
    ds(t) {
        const i = this.getMap().getZoom(), e = this.layer.getSkinLayers();
        for (let s = 0; s < e.length; s++) {
            const n = e[s] && e[s].getRenderer();
            if (n) {
                if (n.isAnimating && n.isAnimating()) return !0;
                if (n.needToRefreshTerrainTileOnZooming && n.needToRefreshTerrainTileOnZooming() && t !== i) return !0;
            }
        }
        return !1;
    }
    isValidCachedTile(t) {
        const i = !t.image.skinStatus;
        return t.image && !t.image.temp && (i || this.bs(t.image));
    }
    isTileComplete(t) {
        return t.image && !t.image.temp && this.bs(t.image);
    }
    xs() {
        const t = this.layer.options, i = this.layer.getTileSize().width;
        return ft(t.terrainWidth) ? i / 4 + 1 : t.terrainWidth;
    }
    Ms(t, i) {
        const e = this.layer.options.maxAvailableZoom - this.layer.options.zoomOffset, s = t.z - e, n = Math.pow(2, s), r = Math.floor(t.x / n), h = Math.floor(t.y / n), o = Math.floor(t.idx / n), a = Math.floor(t.idy / n), l = Le(r, h);
        this.Ss || (this.Ss = {});
        const c = !this.Ss[l];
        return c && i && (this.Ss[l] = new Set, this.Ss[l].url = this.layer.getTileUrl(r, h, e + this.layer.options.zoomOffset)), 
        {
            x: r,
            y: h,
            idx: o,
            idy: a,
            requests: this.Ss[l],
            isFirst: c,
            key: l
        };
    }
    loadTile(i) {
        const e = this.layer, s = this.xs(), n = e.getSpatialReference().getResolution(i.z);
        let r = this.getMap().pointAtResToDistance(1, 1, n);
        const h = e.options.zoomOffset || 0, o = e.options.maxAvailableZoom && e.options.maxAvailableZoom - h;
        if (o && i.z > o) {
            const t = this.je(i);
            if (-1 !== t.sourceZoom) return this.onTileLoad(t, i), t;
            {
                const {requests: s, isFirst: n, x: h, y: a, idx: l, idy: c} = this.Ms(i, !0);
                if (s.add(i), !n) return t;
                const u = i.z - o;
                r *= Math.pow(2, u);
                const f = [ h, a, o, l, c, i.res * Math.pow(2, u), i.error * Math.pow(2, u) ];
                i = e.createTileNode ? e.createTileNode(...f) : e.Cs(...f);
            }
        }
        const a = i.url, l = {}, c = e.options, u = e.getTileSize(), f = {
            terrainWidth: s,
            type: c.type,
            accessToken: c.accessToken,
            cesiumIonTokenURL: c.cesiumIonTokenURL,
            error: r,
            colors: c.colors,
            tileSize: u ? [ u.width, u.height ] : [ 256, 256 ],
            command: "loadTile"
        }, d = () => {
            this.workerConn.fetchTerrain(a, f, ((e, s) => {
                if (this.Ss) {
                    const t = Le(i.x, i.y), e = this.Ss[t];
                    if (e && e.size) {
                        this.tileCache.add(i.id, {
                            info: i,
                            image: l
                        });
                        for (const t of e) this.removeTileLoading(t);
                    }
                    delete this.Ss[t];
                }
                if (e) {
                    if (e.canceled) return;
                    return console.warn(e), void this.onTileError(l, i);
                }
                t.Util.extend(l, s), i.colorsTexture = l.colorsTexture, this.onTileLoad(l, i);
            }));
        }, m = t => {
            t && t.canceled || (console.warn(t), this.onTileError(l, i));
        };
        return this.loadTileBitmap && mt(this.loadTileBitmap) ? this.loadTileBitmap(a, i, ((t, i) => {
            t ? m(t) : i && i instanceof ImageBitmap ? (f.tileImage = i, d()) : m(new Error("bitmap is not ImageBitmap"));
        }), f) : d(), l;
    }
    deleteTile(t) {
        if (!t || !t.image) return;
        super.deleteTile(t);
        const {info: i, image: e} = t;
        e.temp || (delete i.skinTileIds, this.ns(t.info, e));
    }
    ns(t, i) {
        const e = i.skin;
        e && (e.destroy(), e.colorTex.destroy(), delete e.colorTex), i.debugTexture && (i.debugTexture.destroy(), 
        delete i.debugTexture, i.skinDebugMesh.dispose(), delete i.skinDebugMesh);
        const s = i.skinImages;
        if (s && s.length) {
            let e = t.id;
            i.temp && (e += "-temp");
            for (let t = 0; t < s.length; t++) {
                const i = s[t];
                if (i) {
                    for (let t = 0; t < i.length; t++) {
                        if (!i[t] || !i[t].tile) continue;
                        const s = i[t].tile.info.id, n = this.Qe && this.Qe.get(s);
                        n && this.fs(n, e);
                    }
                    i.length = 0;
                }
            }
        }
        i.terrainMesh && this.qe.deleteMesh(i.terrainMesh), i.image && i.image.close && i.image.close(), 
        delete i.skinImages, delete i.skin, delete i.skinStatus, delete i.skinTileIds, delete i.terrainMesh, 
        delete i.image, delete i.data, delete i.mesh, delete i.rendered;
    }
    fs(t, i, e) {
        t && (t.refs.delete(i), t.refs.size || (e ? e.push(t) : this.ts(t)));
    }
    ts(t) {
        if (!t || !t.tile) return;
        const i = t.tile.info.id, e = t.layer.getRenderer();
        delete t.canvas, delete t.layer, t.refs.clear(), t.texture && (e ? e.deleteTerrainTexture(t.texture) : t.texture.destroy && t.texture.destroy(), 
        delete t.texture), t.skinMesh && (t.skinMesh.dispose(), delete t.skinMesh), e && (e.removeTileCache && e.removeTileCache(i), 
        e.deleteTile && e.constructor.prototype.deleteTile.call(e, t.tile)), delete t.tile, 
        this.Qe.delete(i);
    }
    ks() {
        if (!this.Qe) return;
        const t = this.Qe.keys();
        for (const i of t) {
            const t = this.ls(i);
            this.ts(t);
        }
        this.Qe.clear();
    }
    abortTileLoading(t, i) {
        const e = this.layer, s = e.options.maxAvailableZoom && e.options.maxAvailableZoom - e.options.zoomOffset, n = (t, i) => {
            this.loadTileBitmap && mt(this.loadTileBitmap) ? this.loadTileBitmap(t, i, (() => {}), {
                command: "abortTile"
            }) : this.workerConn && this.workerConn.abortTerrain(t);
        };
        if (i) if (s && i.z > s) {
            const {requests: t, key: e} = this.Ms(i);
            t && t.size && (t.delete(i), t.size || (delete this.Ss[e], n(t.url, i)));
        } else i && i.url && n(i.url, i);
        super.abortTileLoading(t, i);
    }
    onTileError(t, i) {
        super.onTileError(t, i);
    }
    Ts(t) {
        const i = this.getCurrentTileZoom(), e = this.layer.getSpatialReference().getResolution(i), s = this.layer._getTileConfig().getTileIndex(t, e, this.layer.options.repeatWorld);
        return s.z = i, s;
    }
    Os(t, i, e, s, n) {
        const r = this.layer.getMinZoom(), h = this.As(i, e.x, e.y, e.z, r);
        if (h && h.image && h.image.data) {
            const i = h.info.extent2d, r = h.info.res / n, o = s.x - i.xmin * r, a = i.ymax * r - s.y;
            let l = this.Is(h.image.data, o / (i.getWidth() * r), a / (i.getHeight() * r));
            const c = this.layer.Es();
            0 !== c && (l *= c), t[0] = l, t[1] = null === l ? 0 : +(h.info.z === e.z);
        } else t[0] = null, t[1] = 0;
        return t;
    }
    As(t, i, e, s, n) {
        t || (t = this.layer._getTileId(i, e, s));
        const r = this.tilesInView[t] || this.tileCache.get(t);
        return !r && s - 1 >= n ? this.As(null, Math.floor(i / 2), Math.floor(e / 2), s - 1, n) : r;
    }
    Is(t, i, e) {
        const {width: s, height: n, data: r} = t, h = Math.floor((s - 1) * i), o = Math.floor((n - 1) * e) * s + h;
        return void 0 === r[o] ? null : r[o];
    }
    Ls(t, i, e) {
        t || (t = {
            tiles: {},
            dirty: !0,
            complete: !1
        });
        const s = this.layer, n = this.getCurrentTileZoom(), r = s.getSpatialReference().getResolution(n), {xmin: h, ymin: o, xmax: a, ymax: l} = i, c = s._getTileConfig();
        xe.set(h, o).Ps(e);
        const u = c._getTileNum(xe, e, !0);
        Me.set(a, l).Ps(e);
        const f = c._getTileNum(Me, e, !0), d = Math.min(u.x, f.x), m = Math.max(u.x, f.x), g = Math.min(u.y, f.y), p = Math.max(u.y, f.y), w = e / r;
        xe.set(h, o).Ps(w), Me.set(a, l).Ps(w);
        const v = Se.set(xe.x, xe.y, Me.x, Me.y), _ = s.getTileSize().width + 1;
        v.Rs(v.getWidth() / _), t.array = t.array || new Float32Array(_ * _);
        const y = t.tiles;
        t.complete = !0, t.array.fill(0);
        for (let i = d; i <= m; i++) for (let e = g; e <= p; e++) {
            const s = this.layer._getTileId(i, e, n);
            if (y[s]) continue;
            const r = this.tileCache.get(s);
            r ? (this.Fs(t.array, r, v, _), t.dirty = !0, y[s] = 1) : (t.dirty = t.dirty || void 0 !== t.tiles[s], 
            t.tiles[s] && delete t.tiles[s], t.complete = !1);
        }
        return t;
    }
    Fs(t, i, e, s) {
        const n = i.info.extent2d, r = n.intersection(e), {xmin: h, ymin: o, xmax: a, ymax: l} = r, {data: c} = i.image, u = c.width, f = e.getWidth() / s, d = Math.floor((h - e.xmin) / f), m = Math.floor((o - e.ymin) / f), g = Math.floor((a - e.xmin) / f) - d, p = Math.floor((l - e.ymin) / f) - m, w = n.getWidth() / u, v = Math.floor((h - n.xmin) / w), _ = Math.floor((o - n.ymin) / w), y = Math.floor(f / w);
        for (let i = 0; i <= g; i++) for (let e = 0; e <= p; e++) {
            const n = i + d + (m + e) * s;
            let r = 0;
            for (let t = 0; t < y; t++) for (let s = 0; s < y; s++) {
                const n = (v + Math.floor(i * y)) * u + t + _ + Math.floor(e * y) + s;
                r += c.data[n];
            }
            t[n] = r / Math.max(y, 1);
        }
        return t;
    }
    clear() {
        return this.clearTempResources(), super.clear();
    }
    clearTempResources() {
        this.ss && (this.ss.reset(), delete this.ss), this.Qe && this.ks();
    }
    onAdd() {
        super.onAdd(), this.prepareWorker();
    }
    onRemove() {
        this.workerConn && (this.workerConn.removeLayer(this.layer.getId(), (t => {
            if (t) throw t;
        })), this.workerConn.remove(), delete this.workerConn), this.clearTempResources(), 
        this.ys && (this.ys.dispose(), delete this.ys), this.ws && (this.ws.dispose(), delete this.ws), 
        delete this.Ss, super.onRemove(), this.qe && (this.qe.delete(), delete this.qe);
    }
    prepareWorker() {
        const t = this.layer.getMap();
        this.workerConn || (this.workerConn = new Ui(t.id));
        const i = this.workerConn;
        if (!i.isActive()) return;
        const e = this.layer.options || {}, s = this.layer.getId();
        i.addLayer(s, e, (t => {
            if (t) throw t;
            this.layer && (this.ready = !0, this.setToRedraw(), this.layer.fire("workerready"));
        }));
    }
    createContext() {
        this.canvas.gl && this.canvas.gl.wrap ? (this.gl = this.canvas.gl.wrap(), this.regl = this.canvas.gl.regl) : this.Hs(), 
        this.renderer = new a.Renderer(this.regl), this.layer.fire("contextcreate", {
            regl: this.regl
        });
    }
    $e() {
        const t = this.qe;
        "lit" === this.layer.options.shader || "pbr" === this.layer.options.shader ? (t && t.constructor === ae || !t) && (t && (t.delete(), 
        this.clear(), this.setToRedraw()), this.qe = new me(this.layer), this.layer.fire("paintercreated")) : (t && t.constructor === me || !t) && (t && (t.delete(), 
        this.clear(), this.setToRedraw()), this.qe = new ae(this.layer), this.layer.fire("paintercreated"));
    }
    Hs() {
        const t = this.layer, i = t.options.glOptions || {
            alpha: !0,
            depth: !0,
            antialias: this.layer.options.antialias
        };
        i.preserveDrawingBuffer = !0, i.stencil = !0, this.glOptions = i, this.gl = this.gl || this.Ds(this.canvas, i), 
        this.regl = v({
            gl: this.gl,
            attributes: i,
            extensions: [ "OES_element_index_uint" ],
            optionalExtensions: t.options.glExtensions
        });
    }
    Ds(t, i) {
        const e = [ "webgl", "experimental-webgl" ];
        let s = null;
        for (let n = 0; n < e.length; ++n) {
            try {
                s = t.getContext(e[n], i);
            } catch (t) {}
            if (s) break;
        }
        return s;
    }
    resizeCanvas(t) {
        this.canvas && super.resizeCanvas(t);
    }
    clearCanvas() {
        this.canvas && super.clearCanvas();
    }
    ps() {
        if (this.ys) return;
        const t = this.layer.getTileSize().width;
        this.ys = new a.MeshShader({
            vert: "#define SHADER_NAME TERRAIN_SKIN\nattribute vec2 aPosition;\nvoid main() {\n    gl_Position = vec4(aPosition, 0.0, 1.0);\n}",
            frag: "#define SHADER_NAME TERRAIN_SKIN\nprecision mediump float;\nuniform float tileSize;\nuniform sampler2D skinTexture;\nuniform vec3 skinDim;\nuniform float opacity;\nvoid main() {\n    vec2 fragCoord = gl_FragCoord.xy / 2.0;\n    vec2 resolution = vec2(tileSize);\n    vec2 uv = (fragCoord - skinDim.xy) /  (resolution * skinDim.z);\n    if (uv.x >= 0.0 && uv.x <= 1.0 && uv.y >= 0.0 && uv.y <= 1.0) {\n        gl_FragColor = texture2D(skinTexture, uv) * opacity;\n    } else {\n        gl_FragColor = vec4(0.0);\n    }\n}",
            extraCommandProps: {
                cull: {
                    enable: !1
                },
                viewport: {
                    x: 0,
                    y: 0,
                    width: 2 * t,
                    height: 2 * t
                },
                depth: {
                    enable: !1
                },
                stencil: {
                    enable: !1
                },
                blend: {
                    enable: !0,
                    func: {
                        src: "one",
                        dst: "one minus src alpha"
                    },
                    equation: "add"
                }
            }
        });
        const i = new Int8Array([ -1, -1, 1, 1, -1, 1, 1, 1, -1, -1, 1, -1 ]);
        this.ws = this.ws || new a.Geometry({
            aPosition: i
        }, 0, 6, {
            positionSize: 2
        }), this.ws.generateBuffers(this.regl), this._s = this._s || new a.Scene;
    }
    updateMaterial(t) {
        this.qe && t && this.qe.updateMaterial && (void 0 === this.Fe && (this.Fe = 1), 
        this.qe.updateMaterial(t, this.Fe++));
    }
    setMaterial(t) {
        this.qe && t && this.qe.setMaterial && (void 0 === this.Fe && (this.Fe = 1), this.qe.setMaterial(t, this.Fe++));
    }
    getAnalysisMeshes() {
        return this.qe && this.qe.Se ? this.qe.Se.getMeshes() : [];
    }
    Ge(t, i, e) {
        if (this.layer.options.debugTile) {
            if (Array.isArray(t)) {
                for (let s = 0; s < t.length; s++) t[s] && this.Ge(t[s], i + " at " + s, e);
                return;
            }
            if (!t) return;
            const {x: s, y: n, z: r} = this.layer.options.debugTile, {info: h} = t;
            h && (t = h), s === t.x && n === t.y && r === t.z && console.log(`Found debug tile in TerrainLayerRenderer.${i}:`, t);
        }
    }
}

const Ae = 1;

function Ie(t, i, e, s, n, r, h, o, a = 0) {
    t.font = "20px monospace", t.fillStyle = e, ke.y = o - 30, t.globalAlpha = 1, t.fillText(i, ke.x + n, ke.y + r + a), 
    t.globalAlpha = .6, t.strokeStyle = e, t.lineWidth = s, t.beginPath(), t.moveTo(n, r), 
    t.lineTo(n + h, r), t.lineTo(n + h, r + o), t.lineTo(n, r + o), t.lineTo(n, r), 
    t.stroke(), t.globalAlpha = 1;
}

function Ee(t, i, e) {
    const {res: s, extent2d: n, offset: r} = t, {info: h} = i, o = h.res / s, a = h.offset, l = h.extent2d.xmin * o, c = h.extent2d.ymin * o, u = r[0] - a[0], f = a[1] - r[1];
    return [ l - n.xmin + u, -(n.ymin - c + f), o * h.tileSize / e ];
}

function Le(t, i) {
    return t + "-" + i;
}

t.renderer.TileLayerCanvasRenderer.include({
    renderTerrainSkin(t, i, e) {
        const s = this.layer.getTileSize().width, n = i.options.debug;
        for (let t = 0; t < e.length; t++) {
            const {tile: i, texture: r} = e[t];
            if (!i.image) continue;
            const h = document.createElement("canvas");
            e[t].canvas = h, h.width = s, h.height = s;
            const o = h.getContext("2d");
            if (o.drawImage(i.image, 0, 0), n) {
                const {x: t, y: e, z: n} = i.info;
                Ie(o, `${t}/${e}/${n}`, "yellow", 1, 0, 0, s, s, -18);
            }
            r({
                data: h,
                width: s,
                height: s,
                flipY: !0,
                min: "linear mipmap linear",
                mag: "linear"
            });
        }
    },
    createTerrainTexture(t) {
        const i = this.layer.getTileSize().width, e = {
            width: i,
            height: i,
            flipY: !0,
            min: "linear mipmap linear",
            mag: "linear",
            depthStencil: !1,
            depth: !1,
            stencil: !1
        };
        return t.texture(e);
    },
    deleteTerrainTexture(t) {
        t.destroy();
    }
});

const Pe = {
    "clip-inside": .1,
    "clip-outside": .2,
    "flat-inside": .3,
    "flat-outside": .4,
    "color": .5,
    "texture": .6,
    "elevate": .7
}, Re = [], Fe = [ 1, 1, 1 ], He = {
    polygonFill: [ 255, 0, 0 ],
    polygonOpacity: .8
}, De = new i(0, 0), Ne = new i(0, 0), Ge = [], je = new i(0, 0), Be = new s(0, 0), ze = new s(0, 0), Ue = new s(0, 0);

class Ve extends n {
    getMode() {
        return this.Ns;
    }
    remove() {
        const t = this.getLayer();
        return t ? (t.removeMask(this), this.Gs(), super.remove(), this) : this;
    }
    getMesh(t, i, e) {
        return this.isVisible() && this.getLayer() ? (this.xt || (this.xt = this.Be(t, i, e)), 
        this.js(this.xt, i, e), this.xt) : null;
    }
    setCoordinates(t) {
        super.setCoordinates(t);
        const i = this.getLayer();
        if (i && (delete i._maskProjViewMatrix, delete i._maskExtentInWorld), !this.xt) return this;
        const e = this.getMode(), s = this.toGeoJSON();
        s.geometry.coordinates[0].reverse();
        const n = m.flatten(s.geometry.coordinates), {positions: r, uvs: h, triangles: o} = "texture" === e ? this.Bs(n) : this.zs(n), a = this.xt.geometry;
        if (a.updateData("POSITION", r), a.updateData("TEXCOORD", h), a.setElements(o), 
        this.Us(this.xt), this.Vs) {
            const t = this.zs(m.flatten(s.geometry.coordinates), !0).positions;
            this.Vs.geometry.updateData("POSITION", t), this.Us(this.Vs);
        }
    }
    Ws(t) {
        const i = this.getMode(), e = this.toGeoJSON();
        e.geometry.coordinates[0].reverse();
        const s = m.flatten(e.geometry.coordinates), {positions: n, uvs: r, triangles: h} = "texture" === i ? this.Bs(s) : this.zs(s), o = this.zs(m.flatten(e.geometry.coordinates), !0).positions, l = new a.Geometry({
            POSITION: n,
            TEXCOORD: r
        }, h, 0, {
            positionAttribute: "POSITION",
            uv0Attribute: "TEXCOORD"
        });
        l.generateBuffers(t);
        const c = new a.Geometry({
            POSITION: o,
            TEXCOORD: r
        }, h, 0, {
            positionAttribute: "POSITION",
            uv0Attribute: "TEXCOORD"
        });
        return c.generateBuffers(t), "texture" === i ? {
            geometry: l,
            copyGeometry: c
        } : l;
    }
    zs(t, i) {
        const e = this.getMap(), s = t.dimensions;
        for (let i = 0; i < t.vertices.length; i += s) {
            je.x = t.vertices[i], je.y = t.vertices[i + 1];
            const s = xt(e, je);
            t.vertices[i] = s[0], t.vertices[i + 1] = s[1];
        }
        const n = xt(e, this.getCenter()), r = [], h = .01 * this.getLayer().getMasks().indexOf(this), o = "texture" === this.getMode() ? 4 : t.vertices.length / s;
        for (let a = 0; a < o; a++) r.push(t.vertices[a * s] - n[0]), r.push(t.vertices[a * s + 1] - n[1]), 
        r.push(h + i ? e.altitudeToPoint(t.vertices[a * s + 2], e.getGLRes()) : 0);
        return {
            positions: r,
            uvs: this.qs(t.vertices, s),
            triangles: m(r, t.holes, 3)
        };
    }
    qs(t, i) {
        const e = [ 0, 0, 0, 1, 1, 1, 1, 0 ];
        if (this.hasHoles()) {
            const s = t.length / i * 2;
            for (let t = e.length / 2 - 1; t < s; t += 2) e[t] = e[t + 1] = 0;
        }
        return e;
    }
    Bs(t) {
        const i = t.dimensions, e = [], s = [], n = [], r = this.getMap();
        for (let e = 0; e < t.vertices.length; e += i) {
            je.x = t.vertices[e], je.y = t.vertices[e + 1];
            const i = xt(r, je);
            t.vertices[e] = i[0], t.vertices[e + 1] = i[1];
        }
        const h = xt(this.getMap(), this.getCenter()), o = {};
        o.a = {
            x: t.vertices[0 * i] - h[0],
            y: t.vertices[0 * i + 1] - h[1]
        }, o.b = {
            x: t.vertices[1 * i] - h[0],
            y: t.vertices[1 * i + 1] - h[1]
        }, o.c = {
            x: t.vertices[2 * i] - h[0],
            y: t.vertices[2 * i + 1] - h[1]
        }, o.d = {
            x: t.vertices[3 * i] - h[0],
            y: t.vertices[3 * i + 1] - h[1]
        }, this.$s = [];
        for (let e = 0; e < 4; e++) this.$s.push(t.vertices[e * i] - h[0]), this.$s.push(t.vertices[e * i + 1] - h[1]), 
        this.$s.push(0);
        for (let t = 0; t <= 20; t++) for (let i = 0; i <= 20; i++) {
            const n = i / 20, r = t / 20, h = (1 - n) * (1 - r) * o.a.x + n * (1 - r) * o.b.x + n * r * o.c.x + (1 - n) * r * o.d.x, a = (1 - n) * (1 - r) * o.a.y + n * (1 - r) * o.b.y + n * r * o.c.y + (1 - n) * r * o.d.y;
            e.push(h, a, 0), s.push(n, 1 - r);
        }
        for (let t = 0; t < 20; t++) for (let i = 0; i < 20; i++) {
            const e = 21 * t + i, s = e + 1, r = 21 * (t + 1) + i, h = r + 1;
            n.push(e, s, h), n.push(e, h, r);
        }
        return {
            positions: e,
            uvs: s,
            triangles: n
        };
    }
    clearMesh() {
        this.Gs(), delete this.xt, this.maskGeoJSON && (this.maskGeoJSON = null);
    }
    Xs() {
        return Pe[this.Ns];
    }
    Ys() {
        const t = this.getSymbol(), {polygonFill: i, polygonOpacity: e} = t || He, s = yt([], i);
        return s[3] = dt(e) ? e : "texture" === this.getMode() ? 1 : He.polygonOpacity, 
        s;
    }
    Js(t = 0) {
        const i = this.getMap(), e = i.getGLRes();
        return i.altitudeToPoint(t, e);
    }
    Us(t) {
        const i = xt(this.getMap(), this.getCenter()), e = l.fromRotationTranslationScale(t.localTransform, d.identity(Re), i, Fe);
        t.localTransform = e;
    }
    Gs() {
        this.xt && (this.xt.material && this.xt.material.dispose(), this.xt.geometry && this.xt.geometry.dispose(), 
        this.Vs && this.Vs.geometry && (this.Vs.geometry.dispose(), this.Vs.dispose()), 
        this.xt.dispose(), delete this.xt, delete this.Vs);
    }
    containsPoint(t) {
        const i = this.getExtent();
        if (je.set(t[0], t[1]), !i || !i.contains(je)) return !1;
        const e = this.getHoles();
        for (let i = 0; i < e.length; i++) if (this.Zs(e[i], t)) return !1;
        const s = this.getShell();
        return this.Zs(s, t);
    }
    Zs(t, i) {
        const e = this.Ks(t);
        let s = 0;
        for (let e = 0; e < t.length; e++) {
            De.x = t[e].x, De.y = t[e].y;
            const n = e + 1 >= t.length ? 0 : e + 1;
            Ne.x = t[n].x, Ne.y = t[n].y, je.x = i[0], je.y = i[1], Ge[0] = je, Ge[1] = De, 
            Ge[2] = Ne;
            s += this.Ks(Ge);
        }
        return !(Math.abs(s - e) > 1e-8);
    }
    Ks(t) {
        const i = this.getMap();
        let e = 0;
        const s = i.getGLRes(), n = i.coordToPointAtRes(t[0], s, Be);
        for (let a = 1; a < t.length - 1; a++) {
            const l = i.coordToPointAtRes(t[a], s, ze), c = i.coordToPointAtRes(t[a + 1], s, Ue);
            e += (r = n, o = c, (((h = l).x - r.x) * (o.y - r.y) - (h.y - r.y) * (o.x - r.x)) / 2);
        }
        var r, h, o;
        /*!
* Contains code from THREE.js
* MIT License
* https://github.com/mrdoob/three.js
*/        return e;
    }
}

for (var We = [], qe = 0; qe < 6; qe++) We[qe] = [];

var $e = [];

function Xe(t, i, e) {
    var s, n, r, h, o, a, l, c, u, f, d, m, g, p, w, v, _;
    n = (s = t)[0], r = s[1], h = s[2], o = s[3], a = s[4], l = s[5], c = s[6], u = s[7], 
    f = s[8], d = s[9], m = s[10], g = s[11], p = s[12], w = s[13], v = s[14], _ = s[15], 
    Ye(We[0], o - n, u - a, g - f, _ - p), Ye(We[1], o + n, u + a, g + f, _ + p), Ye(We[2], o + r, u + l, g + d, _ + w), 
    Ye(We[3], o - r, u - l, g - d, _ - w), Ye(We[4], o - h, u - c, g - m, _ - v), Ye(We[5], o + h, u + c, g + m, _ + v);
    for (var y = 0; y < 6; y++) {
        var b = We[y];
        if ($e[0] = b[0] > 0 ? i[1][0] : i[0][0], $e[1] = b[1] > 0 ? i[1][1] : i[0][1], 
        $e[2] = b[2] > 0 ? i[1][2] : i[0][2], Je(b, $e) < 0) return !1;
    }
    return !0;
}

function Ye(t, i, e, s, n) {
    var r = 1 / Math.sqrt(i * i + e * e + s * s);
    return t[0] = i * r, t[1] = e * r, t[2] = s * r, t[3] = n * r, t;
}

function Je(t, i) {
    return t[0] * i[0] + t[1] * i[1] + t[2] * i[2] + t[3];
}

const Ze = new i(0, 0), Ke = [ 0, 0, 0 ], Qe = [ 0, 0, 0 ], ts = l.identity([ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ]);

function is() {
    return this._maskList ? (this._maskList.forEach((t => {
        t.remove();
    })), this._maskList = [], this.updateMaskExtent(), this) : this;
}

function es() {
    for (let t = 0; t < this._maskList.length; t++) if (this._maskList[t].isVisible()) return !0;
    return !1;
}

function ss(t) {
    return class extends t {
        removeMask(t) {
            if (!this._maskList) return this;
            if (!t) return is.call(this), this;
            const i = Array.isArray(t) ? t : [ t ];
            for (let t = 0; t < i.length; t++) {
                const e = i[t], s = this._maskList.indexOf(e);
                s > -1 && this._maskList.splice(s, 1);
            }
            return this.updateMaskExtent(), this.fire("removemask", {
                masks: t
            }), this;
        }
        setMask(t) {
            return this.removeMask(null), this._maskList || (this._maskList = []), Array.isArray(t) ? t.forEach((t => {
                this._maskList.push(t);
            })) : this._maskList.push(t), this._maskList.forEach((t => {
                t._bindLayer(this), t.Qs && t.Qs();
            })), this.updateMaskExtent(), this.fire("setmask", {
                masks: t
            }), this;
        }
        onAdd() {
            super.onAdd(), this.updateMaskExtent();
        }
        getMasks() {
            return this._maskList || [];
        }
        onGeometryEvent(t) {
            if (!t || !t.target) return;
            "shapechange" === t.type && t.target instanceof Ve && t.target.clearMesh(), t.target instanceof Ve && this.updateMaskExtent(), 
            super.onGeometryEvent && super.onGeometryEvent(t);
        }
        identifyMask(t, i) {
            if (!this.getMap()) return [];
            if (!this._maskList || !this._maskList.length) return [];
            const e = ut({}, i);
            e.excludeMasks = !0;
            const s = this.identifyAtPoint(t, e), n = s.length && s[0].coordinate;
            if (n) {
                const t = this._maskList;
                if (!t) return [];
                const i = [];
                for (let e = 0; e < t.length; e++) {
                    const s = t[e].getMode();
                    !t[e].containsPoint(n) || "color" !== s && "texture" !== s || i.push(t[e]);
                }
                return i;
            }
            return [];
        }
        remove() {
            this._maskList && this._maskList.length && this._maskList.forEach((t => {
                t.remove();
            })), super.remove();
        }
        updateMask(t) {
            const i = this.getMap(), {projViewMatrix: e, mapExtent: s} = this.getProjViewMatrixInOrtho(t);
            Ze.x = s.xmin, Ze.y = s.ymin;
            const n = ns(Ke, Ze, i);
            Ze.x = s.xmax, Ze.y = s.ymax;
            const r = ns(Qe, Ze, i);
            return {
                projViewMatrix: e,
                extentInWorld: [ n[0], n[1], r[0], r[1] ]
            };
        }
        getProjViewMatrixInOrtho(t) {
            const i = this.getMap(), e = i.getView(), s = i.getFitZoom(t), n = t.getCenter();
            i.setView({
                center: n,
                zoom: s,
                pitch: 0,
                bearing: 0
            });
            const r = i.getExtent(), h = l.copy(ts, i.projViewMatrix);
            return i.setView(e), {
                mapExtent: r,
                projViewMatrix: h
            };
        }
        updateMaskExtent() {
            if (!this._maskList) return;
            if (!this.getMap()) return;
            const t = this.getRenderer();
            if (t && !this._maskList.length) return void t._clearMask();
            if (t && !es.call(this)) return t._deleteMaskUniforms(), void t.setToRedraw();
            const i = this.getMaskExtent();
            if (!i) return;
            const {extent: e, ratio: s, minHeight: n} = i, {projViewMatrix: r, extentInWorld: h} = this.updateMask(e);
            this._maskProjViewMatrix = r, this._maskExtentInWorld = h, t ? t.setMask(this._maskExtentInWorld, this._maskProjViewMatrix, s, n) : this.once("renderercreate", (t => {
                t.renderer.setMask(this._maskExtentInWorld, this._maskProjViewMatrix, s, n);
            }));
        }
        getMaskExtent() {
            let t = 1 / 0, i = 1 / 0, e = -1 / 0, s = -1 / 0, n = -1 / 0, h = 1 / 0, o = !1;
            const a = this.getMap();
            for (let r = 0; r < this._maskList.length; r++) {
                const l = this._maskList[r];
                if (!l.isVisible()) continue;
                const c = l.getExtent();
                if (c) {
                    if (l.xt && l.getBBox) {
                        const t = l.getBBox();
                        if (!Xe(a.projViewMatrix, t)) continue;
                    }
                    if (o = !0, c.xmin < t && (t = c.xmin), c.ymin < i && (i = c.ymin), c.xmax > e && (e = c.xmax), 
                    c.ymax > s && (s = c.ymax), l.tn) {
                        const t = l.tn();
                        t[0] < h && (h = t[0]), t[1] > n && (n = t[1]);
                    }
                }
            }
            if (!o) return null;
            const {ratio: l, minHeight: c} = function(t, i) {
                const e = t === 1 / 0 ? 0 : t, s = i === -1 / 0 ? 0 : i, n = Math.abs(s - e);
                return 0 === n ? {
                    ratio: 1,
                    minHeight: 0
                } : {
                    ratio: Math.pow(n, -1),
                    minHeight: e
                };
            }(h, n);
            return {
                extent: new r(t, i, e, s),
                ratio: l,
                minHeight: c
            };
        }
    };
}

function ns(t, e, s, n = 0) {
    if (!(s && e instanceof i)) return null;
    const r = s.coordinateToPointAtRes(e, s.getGLRes());
    return t[0] = r.x, t[1] = r.y, t[2] = n, t;
}

const rs = new t.Coordinate(0, 0), hs = new t.Coordinate(0, 0), os = new t.Point(0, 0), as = [], ls = {
    tileGrids: [],
    count: 0
}, cs = "01", us = "1";

class fs extends(ss(t.TileLayer)){
    constructor(t, i) {
        i && !i.tileSystem && ("cesium" === i.type || "cesium-ion" === i.type ? i.tileSystem = [ 1, 1, -180, -90 ] : "tianditu" === i.type && (i.tileSystem = [ 1, -1, -180, 90 ])), 
        i.tileSize || "mapbox" === i.type && (i.tileSize = 512), super(t, i);
    }
    onAdd() {
        const t = this.options, i = this.getMap().getProjection(), e = "EPSG:4326" === i.code || "EPSG:4490" === i.code, s = "EPSG:3857" === i.code;
        512 !== t.tileSize || t.spatialReference || ("mapbox" === t.type ? e ? t.spatialReference = "preset-4326-512" : s && (t.spatialReference = "preset-3857-512") : "cesium" === t.type || "cesium-ion" === t.type ? t.spatialReference = "preset-4326-512" : "tianditu" === t.type && (t.spatialReference = {
            "projection": "EPSG:4326",
            "fullExtent": {
                "top": 90,
                "left": -180,
                "bottom": -90,
                "right": 180
            },
            "resolutions": function() {
                const t = [];
                for (let i = 0; i <= 22; i++) t[i] = 90 / (128 * Math.pow(2, i));
                return t;
            }()
        })), t.terrainWidth || "tianditu" !== t.type || (t.terrainWidth = 65);
    }
    getTileUrl(t, i, e) {
        let s = super.getTileUrl(t, i, e);
        return "mapbox" === this.options.type && this.options.requireSkuToken && (this.en || (this.en = this.sn()), 
        s.indexOf("?") > -1 ? s += "&sku=" + this.en : s += "?sku=" + this.en), s;
    }
    getMaxAvailableZoom() {
        return this.getSpatialReference().getMaxZoom();
    }
    sn() {
        let t = "";
        for (let i = 0; i < 10; i++) t += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62 * Math.random())];
        return [ us, cs, t ].join("");
    }
    Es() {
        let t = this.options.exaggeration;
        return ft(t) && (t = 1), t;
    }
    setSkinLayers(t) {
        this.nn = t;
        const i = this.getRenderer();
        i && (i.clear(), i.setToRedraw());
    }
    getSkinTiles(i) {
        const e = this.getRenderer();
        if (!e) return ls;
        const s = e.getTileGridsInCurrentFrame().tileGrids[0];
        if (!s) return ls;
        const n = i.getId(), r = this._getTileConfig().tileSystem.scale, h = i.getTileSize().width, o = s.tiles;
        if (!o.length) return ls;
        const a = this.getMap(), l = s.parents || as, c = l.length, u = l.concat(o), f = i.getSpatialReference(), d = o[0].extent2d.getWidth(), m = r.x, g = r.y, p = [], w = [], v = new Set, _ = this._getTileConfig().tileSystem.scale.y;
        for (let e = 0; e < u.length; e++) {
            const s = u[e], {res: r} = s;
            let o = s.nw;
            o || (o = s.nw = a.pointAtResToCoord(s.extent2d.getMin(os), s.res));
            const {res: l, zoom: y} = Ki(f, s.z, r), b = l / r, x = Zi(l, h, r, d), {extent2d: M, offset: S} = s, C = x * s.x, k = x * s.y;
            if (s.skinTileIds || (s.skinTileIds = {}), !s.skinTileIds[n]) {
                const e = new Set, r = [], a = Ji(i, s.x, s.y, y, o, S, g, x, 0);
                for (let s = 0; s < a.length; s++) {
                    const n = a[s];
                    if (e.has(n.id)) continue;
                    n.idx = n.x, n.idy = n.y, n.res = l, n.url = i.getTileUrl(n.x, n.y, n.z + i.options.zoomOffset);
                    const o = m * (n.x - C) * h, c = g * (n.skinY - k) * h, u = M.xmin * b + o, f = M.ymax * b + c, d = M.ymin * b + c;
                    n.extent2d = _ > 0 ? new t.PointExtent(u, d, u + h, d + h) : new t.PointExtent(u, f - h, u + h, f), 
                    e.add(n.id), r.push(n);
                }
                s.skinTileIds[n] = r;
            }
            const T = s.skinTileIds[n];
            for (let t = 0; t < T.length; t++) v.has(T[t].id) || (e < c ? p.push(T[t]) : w.push(T[t]), 
            v.add(T[t].id));
        }
        return {
            tileGrids: [ {
                extent: s.extent,
                tiles: w,
                parents: p,
                count: w.length
            } ],
            count: w.length
        };
    }
    getSkinLayer(t) {
        return this.getSkinLayers()[t];
    }
    getSkinLayers() {
        return this.nn || as;
    }
    getSkinCount() {
        return this.nn && this.nn.length || 0;
    }
    queryTerrainByProjCoord(t, i) {
        i = i || [];
        const e = this.getRenderer();
        if (!e) return i[0] = null, i[1] = 0, i;
        const s = this.getMap(), n = e.Ts(t);
        if (!n) return i[0] = null, i[1] = 0, i;
        const r = s._prjToPointAtRes(t, 1, os);
        return e.Os(i, n.id, n, r, 1);
    }
    queryTileTerrainByProjCoord(t, i, e, s) {
        s = s || [];
        const n = this.getRenderer();
        if (!n) return s[0] = null, s[1] = 0, s;
        const r = this.getMap()._prjToPointAtRes(t, 1, os);
        return n.Os(s, i, e, r, 1);
    }
    queryTileTerrainByPointAtRes(t, i, e, s, n) {
        n = n || [];
        const r = this.getRenderer();
        return r ? r.Os(n, e, s, t, i) : (n[0] = null, n[1] = 0, n);
    }
    queryTerrain(t, i) {
        i = i || [];
        if (!this.getRenderer()) return i[0] = null, i[1] = 0, i;
        const e = this.getMap().getProjection().project(t, rs);
        return this.queryTerrainByProjCoord(e, i);
    }
    queryTileMesh(t, i) {
        const e = this.getRenderer();
        e && e.rn(t, i);
    }
    getTerrainTiles(i, e) {
        const {x: s, y: n, z: r, res: h, offset: o} = e, a = e.extent2d.getWidth(), l = this._getTileConfig(), c = i._getTileConfig(), u = this.getSpatialReference(), {res: f, zoom: d} = Ki(u, r, h), m = this.getTileSize().width, g = Zi(f, m, h, a);
        let p = e.nw;
        p || (p = e.nw = this.getMap().pointAtResToCoord(e.extent2d.getMin(os), e.res));
        const w = Xi(this, s, n, d, p, o, c.tileSystem.scale.y, g, 1)[0];
        for (let i = 0; i < w.length; i++) {
            const {x: e, y: s} = w[i], n = l.getTilePointNW(e, s, f, os);
            w[i].res = f, w[i].extent2d = new t.PointExtent(n.x, n.y, n.x + m, n.y - m);
        }
        return w;
    }
    isTerrainTileLoaded(t) {
        const i = this.getRenderer();
        return !!i && i.isTileCached(t);
    }
    updateMaterial(t) {
        if (!t) return;
        this.options.material || (this.options.material = {}), ut(this.options.material, t);
        const i = this.getRenderer();
        i && i.updateMaterial(t);
    }
    setMaterial(t) {
        if (!t) return;
        this.options.material = t;
        const i = this.getRenderer();
        i && i.setMaterial(t);
    }
    Cs(t, i, e, s, n, r, h, o, a, l) {
        const c = this.getMap(), u = this.options.zoomOffset;
        if (!a) {
            a = this._getTileConfig().getTilePrjExtent(t, i, r).convertTo((t => c._prjToPointAtRes(t, r, hs)));
        }
        const f = this._getTileOffset(e);
        return {
            parent: o,
            layer: this.getId(),
            x: t,
            y: i,
            z: e,
            idx: s,
            idy: n,
            res: r,
            extent2d: a,
            id: l || this._getTileId(t, i, e),
            url: this.getTileUrl(t, i, e + u),
            offset: f,
            error: h,
            children: []
        };
    }
}

fs.mergeOptions({
    "forceRenderOnMoving": !0,
    "forceRenderOnZooming": !0,
    "forceRenderOnRotating": !0,
    "fadeAnimation": !1,
    "fadeDuration": 1e3 / 60 * 15,
    "tileLimitPerFrame": 2,
    "newTerrainTileRenderLimitPerFrameOnInteracting": 1,
    "opacity": 1,
    "renderer": "gl",
    "pyramidMode": 1,
    "tileSize": 512,
    "terrainWidth": null,
    "backZoomOffset": 0,
    "depthMask": !0,
    "blendSrc": "one",
    "blendDst": "one minus src alpha",
    "requireSkuToken": !0,
    "cesiumIonTokenURL": "https://api.cesium.com/v1/assets/1/endpoint?access_token=",
    "tileRetryCount": 0,
    "shader": "default",
    "terrainTileMode": !0,
    "tempTileCacheSize": 64,
    "tileStackStartDepth": 7,
    "tileStackDepth": 6,
    "currentTilesFirst": !1,
    "exaggeration": 1,
    "colors": []
}), fs.registerJSONType("TerrainLayer"), fs.registerRenderer("gl", Oe);

const ds = [], ms = [], gs = [], ps = [], ws = new s(0, 0), vs = [], _s = [], ys = [], bs = [], xs = [], Ms = [], Ss = [], Cs = [], ks = [];

class Ts {
    constructor(t, i, e = !0) {
        this.hn = t, this.an = i, this.ln = e;
    }
    setFromPoint(t) {
        this.hn = Array.isArray(t) ? new i(t) : t;
    }
    setToPoint(t) {
        this.an = Array.isArray(t) ? new i(t) : t;
    }
    test(i, e, s = {}) {
        const n = s.count || 0, r = [];
        let h = this.hn, o = this.an;
        this.ln && (h = As(e, this.hn.x, this.hn.y, this.hn.z), o = As(e, this.an.x, this.an.y, this.an.z));
        const a = new t.math.Ray(h, o);
        for (let t = 0; t < i.length; t++) {
            const s = i[t];
            if (!this.cn(s.getBoundingBox(), a)) continue;
            const h = s.localTransform, o = s.geometry, c = o.data[o.desc.positionAttribute].array, u = o.data[o.desc.altitudeAttribute] && o.data[o.desc.altitudeAttribute].array || vs, f = o.indices;
            if (!(c && c.length && f && f.length)) continue;
            const d = l.multiply(bs, h, s.positionMatrix), m = this.un(s, a, e, c, u, f, o.desc.positionSize, d, n);
            if (m) {
                const t = {
                    mesh: s,
                    coordinates: m
                };
                if (r.push(t), 0 !== n && r.length >= n) break;
            }
        }
        return r;
    }
    un(t, i, e, s, n, r, h, o, a) {
        const l = [];
        for (let u = 0; u < r.length && !(u > t.properties.skirtOffset); u += 3) {
            const t = r[u], f = r[u + 1], d = r[u + 2], m = c.set(xs, s[t * h], s[t * h + 1], s[t * h + 2]), g = this.dn(ms, e, m, n[t] / 100, o), p = c.set(Ms, s[f * h], s[f * h + 1], s[f * h + 2]), w = this.dn(gs, e, p, n[f] / 100, o), v = c.set(Ss, s[d * h], s[d * h + 1], s[d * h + 2]), _ = this.dn(ps, e, v, n[d] / 100, o), y = c.set(ds, g, w, _), b = c.sub(_s, g, w), x = c.sub(ys, g, _), M = this.mn(Cs, y, i);
            if (M) {
                const i = e.pointAtResToAltitude(M[2], e.getGLRes());
                ws.x = M[0], ws.y = M[1];
                const s = e.pointAtResToCoordinate(ws, e.getGLRes());
                if (s.z = i, l.push({
                    coordinate: s,
                    indices: [ t, f, d ],
                    normal: c.cross([], b, x)
                }), 0 !== a && l.length >= a) break;
            }
        }
        return l.length ? l : null;
    }
    dn(t, i, s, n, r) {
        let h;
        return e.isNumber(n) ? (h = i.altitudeToPoint(n, i.getGLRes()), g.set(t, s[0], s[1], 0, 1), 
        g.transformMat4(t, t, r), t[2] = h) : (g.set(t, s[0], s[1], s[2], 1), g.transformMat4(t, t, r)), 
        t;
    }
    mn(t, i, e) {
        return e.intersectTriangle(i[0], i[1], i[2], !0, t);
    }
    cn(t, i) {
        return !!t && i.intersectBox(t, ks);
    }
}

const Os = new i(0, 0);

function As(t, i, e, s) {
    if (!t) return null;
    Os.set(i, e);
    const n = t.coordinateToPointAtRes(Os, t.getGLRes()), r = t.altitudeToPoint(s || 0, t.getGLRes());
    return [ n.x, n.y, r ];
}

const Is = () => {}, Es = new t.Coordinate(0, 0), Ls = [ 0, 0, 0 ], Ps = [ 0, 0, 0 ], Rs = [ 0, 0, 0 ];

class Fs extends t.Layer {
    static fromJSON(i) {
        if (!i || "GroupGLLayer" !== i.type) return null;
        const e = i.layers.map((i => t.Layer.fromJSON(i)));
        return new Fs(i.id, e, i.options);
    }
    constructor(t, i, e) {
        super(t, e), this.layers = i && i.slice() || [], this.layers.forEach((t => {
            if (t.getMap()) throw new Error(`layer(${t.getId()} is already added on map`);
        })), this.gn(), this.sortLayersByZIndex(), this.pn = {};
    }
    sortLayersByZIndex() {
        if (this.layers && this.layers.length) {
            for (let t = 0, i = this.layers.length; t < i; t++) this.layers[t].__group_gl_order = t;
            this.layers.sort(Ds);
        }
    }
    setSceneConfig(t) {
        this.options.sceneConfig = t;
        const i = this.getRenderer();
        return i && i.updateSceneConfig(), this;
    }
    getSceneConfig() {
        return JSON.parse(JSON.stringify(this.u()));
    }
    u() {
        return this.options.sceneConfig || {};
    }
    getGroundConfig() {
        return this.u().ground;
    }
    getWeatherConfig() {
        return this.u().weather;
    }
    getScanEffectConfig() {
        const t = this.u();
        return t.postProcess && t.postProcess.scanEffect;
    }
    addLayer(t, i) {
        if (t.getMap()) throw new Error(`layer(${t.getId()}) is already added on map`);
        if ("gl" !== t.options.renderer) throw new Error(`layer(${t.getId()})'s renderer is canvas, not supported to be added to GroupGLLayer`);
        void 0 === i ? this.layers.push(t) : this.layers.splice(i, 0, t), this.gn(), this.sortLayersByZIndex();
        const e = this.getRenderer();
        return e ? (this.wn(t), this.vn(), e.setToRedraw(), this) : this;
    }
    removeLayer(i) {
        t.Util.isString(i) && (i = this.getChildLayer(i));
        const e = this.layers.indexOf(i);
        if (e < 0) return this;
        const s = i.getRenderer();
        s && s.setTerrainHelper && s.setTerrainHelper(null), i._doRemove(), this._n(i), 
        delete this.pn[i.getId()], this.layers.splice(e, 1);
        const n = this.getRenderer();
        return n ? (this.vn(), n.setToRedraw(), this) : this;
    }
    clearLayers() {
        const t = this.getLayers();
        for (let i = 0; i < t.length; i++) t[i] && t[i].remove();
        return this;
    }
    Ai() {
        let t = 0;
        for (let i = 0; i < this.layers.length; i++) {
            const e = this.layers[i];
            e.setPolygonOffset && e.getPolygonOffsetCount && (t += e.getPolygonOffsetCount());
        }
        let i = 0;
        for (let e = this.layers.length - 1; e >= 0; e--) {
            const s = this.layers[e];
            s.setPolygonOffset && s.getPolygonOffsetCount && (s.setPolygonOffset(i, t), i += s.getPolygonOffsetCount());
        }
        this.yn = i;
    }
    getPolygonOffsetCount() {
        return this.yn;
    }
    getLayers() {
        return this.layers.slice();
    }
    ee() {
        return this.layers;
    }
    toJSON() {
        const t = [];
        if (this.layers) for (let i = 0; i < this.layers.length; i++) {
            const e = this.layers[i];
            e && (e && e.toJSON && t.push(e.toJSON()));
        }
        return {
            "type": this.getJSONType(),
            "id": this.getId(),
            "layers": t,
            "options": this.config()
        };
    }
    onLoadEnd() {
        this.layers.forEach((t => {
            this.wn(t);
        })), this.options.terrain && this.bn(), super.onLoadEnd();
    }
    wn(t) {
        const i = this.getMap();
        this.pn[t.getId()] = t, t._canvas = this.getRenderer().canvas, t._bindMap(i), t.once("renderercreate", this.xn, this), 
        t.remove = () => (this.removeLayer(t), t.constructor.prototype.remove.call(t), delete t.remove, 
        this), t.load(), this.Mn(t);
    }
    onRemove() {
        this.Sn(), this.layers.forEach((t => {
            this.Cn(t), t._doRemove(), this._n(t);
        })), this.pn = {}, this.clearAnalysis(), super.onRemove();
    }
    getChildLayer(t) {
        return this.pn[t] || null;
    }
    getLayer(t) {
        return this.getChildLayer(t);
    }
    Mn(t) {
        t.on("show hide", this.kn, this), t.on("idchange", this.Tn, this);
    }
    _n(t) {
        t.off("show hide", this.kn, this), t.off("idchange", this.Tn, this);
    }
    kn() {
        const t = this.getRenderer();
        t && t.setToRedraw();
    }
    Tn(t) {
        const i = t.new, e = t.old, s = this.getLayer(e);
        delete this.pn[e], this.pn[i] = s;
    }
    xn(t) {
        t.renderer.clearCanvas = Hs;
    }
    gn() {
        const t = {};
        this.layers.forEach((i => {
            const e = i.getId();
            if (t[e]) throw new Error(`Duplicate child layer id (${e}) in the GroupGLLayer (${this.getId()})`);
            t[e] = 1;
        }));
    }
    addAnalysis(t) {
        this.vi = this.vi || [], this.vi.push(t);
        const i = this.getRenderer();
        i && i.setToRedraw();
    }
    removeAnalysis(t) {
        if (this.vi) {
            const i = this.vi.indexOf(t);
            i > -1 && (this.vi.splice(i, 1), t.remove());
        }
        const i = this.getRenderer();
        i && i.setToRedraw();
    }
    clearAnalysis() {
        this.vi && (this.vi.forEach((t => {
            t.remove();
        })), this.vi = []);
        const t = this.getRenderer();
        t && t.setToRedraw();
    }
    identify(i, e) {
        const s = this.getMap(), n = this.getRenderer();
        if (!s || !n) return [];
        const r = s.coordToContainerPoint(new t.Coordinate(i));
        return this.identifyAtPoint(r, e);
    }
    identifyAtPoint(t, i = {}) {
        const e = i.includeInternals, s = this.getLayers(), n = i && i.childLayers || s, r = this.getMap();
        if (!r) return [];
        const h = ft(i.count) ? 1 : i.count;
        let o = [];
        for (let r = n.length - 1; r >= 0; r--) {
            const h = n[r];
            if (s.indexOf(h) < 0 || !h.identifyAtPoint) continue;
            const a = h.options.geometryEvents;
            if (e && (void 0 === a || !1 === a || 0 === a)) continue;
            if (h.isGeometryListening && e && i.eventTypes.indexOf("mousemove") >= 0 && !h.isGeometryListening(i.eventTypes)) continue;
            const l = h.identifyAtPoint(t, i);
            if (!l || !l.length) continue;
            const c = h.getId();
            for (let t = 0; t < l.length; t++) l[t] && (l[t].layer = c);
            o.push(...l);
        }
        if (i.orderByCamera) {
            const t = r.cameraPosition;
            o.sort(((i, e) => e.point ? i.point ? c.dist(i.point, t) - c.dist(e.point, t) : 1 : -1));
        }
        return h && (o = o.slice(0, h)), o;
    }
    getTerrain() {
        return this.options.terrain;
    }
    setTerrain(t) {
        return this.options.terrain = t, this.getRenderer() ? (this.bn(), this.getMap().updateCenterAltitude(), 
        this) : this;
    }
    removeTerrain() {
        return this.setTerrain(null);
    }
    updateTerrainMaterial(t) {
        this.On && t && (this.options.terrain.material ? ut(this.options.terrain.material, t) : this.options.terrain.material = t, 
        this.On.updateMaterial(t));
    }
    bn() {
        const t = this.getRenderer();
        t && t.setToRedraw();
        const i = this.options.terrain;
        if (this.On) {
            const t = this.On, e = t.options;
            if (i && e.urlTemplate === i.urlTemplate && e.spatialReference === i.spatialReference) {
                for (const e in i) "material" === e ? t.setMaterial(i[e]) : "urlTemplate" !== e && "spatialReference" !== e && t.config(e, i[e]);
                return this;
            }
            this.Sn();
        }
        if (this.An(), !i) return this;
        this.On = new fs("__terrain_in_group", i), this.vn();
        const e = this.On;
        e.on("tileload", this.In, this), this.wn(e);
        const s = i.masks;
        return s && s.length ? e.setMask(s) : e.removeMask(), this.fire("terrainlayercreated"), 
        this;
    }
    queryTerrain(t, i) {
        return this.On ? this.On.queryTerrain(t, i) : (i && (i[0] = null, i[1] = 0), [ null, 0 ]);
    }
    queryTerrainAtPoint(t) {
        if (!this.On) return null;
        const i = this.On.getRenderer().getAnalysisMeshes();
        return this.En(t, i);
    }
    query3DTilesAtPoint(i) {
        const e = this.ee().filter((t => t && t.isGeo3DTilesLayer));
        if (!e.length) return null;
        const s = {
            excludeMasks: !0
        };
        for (let n = 0; n < e.length; n++) {
            if (!e[n].getRenderer()) continue;
            const r = e[n].identifyAtPoint(i, s);
            if (r.length) return new t.Coordinate(r[0].coordinate);
        }
        return null;
    }
    En(i, e) {
        const s = this.getMap(), n = s.getGLRes();
        s.getContainerPointRay(Ps, Rs, i);
        const r = new Ts(Ps, Rs, !1).test(e, s, {
            count: 1
        }), h = [];
        r.forEach((t => {
            t.coordinates.forEach((t => {
                h.push(t.coordinate);
            }));
        }));
        const o = s.pointAtResToCoordinate(new t.Point(Ps[0], Ps[1]), n, Es);
        this.Ln || (this.Ln = s.altitudeToPoint(1, n)), o.z = Ps[2] / this.Ln;
        const a = c.set(Ls, o.x, o.y, o.z);
        return h.sort(((t, i) => c.dist(t.toArray(), a) - c.dist(i.toArray(), a))), h[0];
    }
    queryTerrainByProjCoord(t, i) {
        return this.On ? this.On.queryTerrainByProjCoord(t, i) : (i && (i[0] = null, i[1] = 0), 
        [ null, 0 ]);
    }
    vn() {
        if (!this.On) return;
        const t = this.layers, i = [];
        for (let e = 0; e < t.length; e++) {
            if (!t[e]) continue;
            const s = t[e], n = s.getRenderer();
            if (n.renderTerrainSkin) {
                if (n.deleteTile === Is) {
                    i.push(t[e]);
                    continue;
                }
                s.getTiles = () => this.On && this.On.getSkinTiles(s), n.drawTileOnTerrain ? n.drawTile = (...t) => n.drawTileOnTerrain(...t) : n.drawTile = Is, 
                n.deleteTile = Is, i.push(t[e]);
            }
            n.setTerrainHelper && n.setTerrainHelper(this.On);
        }
        this.On.setSkinLayers(i);
    }
    Cn(t) {
        if (!function(t) {
            if (!t) return !1;
            const i = t.getRenderer();
            if (!i) return !1;
            return !!i.renderTerrainSkin;
        }(t)) return;
        const i = t.getRenderer();
        i && (i.setTerrainHelper && i.setTerrainHelper(null), i.clear && i.clear(), delete i.drawTile, 
        delete i.deleteTile), delete t.getTiles;
    }
    An() {
        const t = this.layers;
        for (let i = 0; i < t.length; i++) t[i] && this.Cn(t[i]);
    }
    In() {
        const t = this.getRenderer();
        t && t.setToRedraw();
    }
    Sn() {
        if (this.On) {
            const t = this.On;
            t.off("tileload", this.In, this), this._n(t), this.On._doRemove(), delete this.On, 
            this.fire("terrainlayerremoved");
        }
    }
    getTerrainLayer() {
        return this.On;
    }
    _bindMap(...t) {
        if (this.options.single) {
            const i = t[0].getLayers();
            for (let t = 0; t < i.length; t++) if (i[t] instanceof Fs) throw new Error("Only one GroupGLLayer is allowed in a map instance. Set options.single to false if you want to add two or more GroupGLLayers.");
        }
        return super._bindMap(...t);
    }
    fire(...t) {
        if ("layerload" === t[0]) {
            const t = this.ee();
            for (const i of t) {
                const t = i.getRenderer();
                t && t.isRenderComplete() && i.fire("layerload");
            }
        }
        super.fire(...t);
    }
}

function Hs() {}

function Ds(t, i) {
    const e = t.getZIndex() - i.getZIndex();
    return 0 === e ? t.__group_gl_order - i.__group_gl_order : e;
}

var Ns;

Fs.mergeOptions({
    renderer: "gl",
    antialias: !0,
    extensions: [],
    single: !0,
    onlyWebGL1: !1,
    optionalExtensions: [ "ANGLE_instanced_arrays", "OES_element_index_uint", "OES_standard_derivatives", "OES_vertex_array_object", "OES_texture_half_float", "OES_texture_half_float_linear", "OES_texture_float", "OES_texture_float_linear", "WEBGL_depth_texture", "EXT_shader_texture_lod", "EXT_frag_depth", "EXT_texture_filter_anisotropic", "WEBGL_compressed_texture_astc", "WEBGL_compressed_texture_etc", "WEBGL_compressed_texture_etc1", "WEBGL_compressed_texture_pvrtc", "WEBGL_compressed_texture_s3tc", "WEBGL_compressed_texture_s3tc_srgb" ],
    forceRenderOnZooming: !0,
    forceRenderOnMoving: !0,
    forceRenderOnRotating: !0,
    viewMoveThreshold: 100,
    geometryEvents: !0,
    multiSamples: 4,
    forceRedrawPerFrame: !1
}), Fs.registerJSONType("GroupGLLayer"), Fs.registerRenderer("gl", Ni), Fs.registerRenderer("canvas", null), 
function(t) {
    t[t.AMBIENT = 0] = "AMBIENT", t[t.REALISTIC = 1] = "REALISTIC";
}(Ns || (Ns = {}));

class Gs {
    constructor(t) {
        this.Pn = t, this.B = new a.ResourceLoader;
    }
    getDirectionalLight() {
        return this.Bt && this.Bt.directional || {};
    }
    getAmbientLight() {
        return this.Bt && this.Bt.ambient || {};
    }
    getAmbientResource() {
        return this.Rn;
    }
    setConfig(t) {
        const i = this.Bt;
        this.Fn = t.urlModifier, this.Bt = JSON.parse(JSON.stringify(t));
        let e = !1;
        if (t && t.ambient && t.ambient.resource) {
            if (!(i && i.ambient && function(t, i) {
                if (!t.resource) return !1;
                if (t.resource.url !== i.resource.url) return !1;
                return !0;
            }(i.ambient, t.ambient))) return void this.Hn();
            this.Rn && (t.ambient.prefilterCubeSize !== i.ambient && i.ambient.prefilterCubeSize && this.Dn(), 
            e = !0, t.ambient.resource.sh && (this.Rn.sh = t.ambient.resource.sh));
        } else this.Nn(), e = i && i.ambient && i.ambient.resource;
        this.Pn.fire("updatelights", {
            ambientUpdate: e
        });
    }
    Gn(t) {
        const i = t.getLayers();
        for (let t = 0; t < i.length; t++) {
            const e = i[t] && i[t].getRenderer();
            if (e && e.regl) return e.regl;
        }
        const e = document.createElement("canvas"), s = w({
            canvas: e,
            attributes: {
                depth: !1,
                stencil: !1,
                alpha: !1
            },
            optionalExtensions: [ "OES_standard_derivatives", "OES_texture_half_float", "OES_texture_half_float_linear", "OES_texture_float", "OES_texture_float_linear" ]
        });
        return s.jn = !0, s;
    }
    Hn() {
        const t = this.Bt.ambient.resource, i = t && t.url;
        if (!i) return;
        const e = [];
        let s = 0, n = 0;
        const r = () => {
            n++, n >= s && this.Bn(e);
        }, h = function() {
            throw new Error(`skybox image with url(${this.src}) failed to load, please check the image's url.`);
        }, o = this.Fn;
        if (i.top || i.nx) {
            const {front: t, back: n, right: a, left: l, top: c, bottom: u} = i, {nx: f, ny: d, px: m, py: g, nz: p, pz: w} = i;
            let v;
            v = t ? [ l, a, n, t, c, u ] : [ f, m, p, w, g, d ], s = v.length;
            for (let t = 0; t < s; t++) {
                const i = new Image;
                i.onload = r, i.onerror = h, i.src = o && o(v[t]) || v[t], e[t] = i;
            }
        } else {
            const i = {
                url: t.url,
                arrayBuffer: !0,
                hdr: !0,
                flipY: !0
            };
            this.B.setURLModifier(o), this.zn = new a.Texture2D(i, this.B), this.zn.once("complete", (() => {
                this.Dn();
            })), this.zn.once("error", (() => {
                this.Un();
            }));
        }
    }
    dispose() {
        this.Nn();
    }
    Dn() {
        this.zn && (this.Rn = this.Vn(this.zn), this.Pn.fire("updatelights", {
            "ambientUpdate": !0
        }));
    }
    Un() {
        this.Pn.fire("hdrerror");
    }
    Bn(t) {
        this.Rn = this.Vn(t), this.Pn.fire("updatelights", {
            "ambientUpdate": !0
        });
    }
    Vn(t) {
        const i = this.Bt.ambient.resource, e = i.prefilterCubeSize || 512, s = this.Gn(this.Pn), n = a.pbr.PBRHelper.createIBLMaps(s, {
            envTexture: Array.isArray(t) ? t : t.getREGLTexture(s),
            ignoreSH: !!i.sh,
            envCubeSize: e,
            prefilterCubeSize: e,
            environmentExposure: this.Bt.ambient.exposure,
            format: "array"
        });
        if (i.sh && (n.sh = i.sh, Array.isArray(n.sh[0]))) {
            const t = n.sh, i = [];
            for (let e = 0; e < t.length; e++) i.push(...t[e]);
            n.sh = i;
        }
        return s.jn && (delete this.zn, s.destroy()), n;
    }
    Nn() {
        this.zn && (this.zn.dispose(), delete this.zn), delete this.Rn;
    }
}

let js, Bs, zs, Us, Vs;

h.include({
    setLights(t) {
        return this.options.lights = t, this.Wn(), this;
    },
    getLights() {
        return this.options.lights;
    },
    Wn() {
        this.qn || (this.qn = new Gs(this)), this.qn.setConfig(this.getLights());
    },
    getLightManager() {
        return this.qn ? this.qn : null;
    }
}), h.addOnLoadHook((function() {
    this.options.lights && this.Wn();
}));

const Ws = {
    color: [ 0, 0, 0, 0 ]
}, qs = {
    enable: !1
};

h.include({
    setPostProcessConfig(t) {
        return this.options.postProcessConfig = t, this;
    },
    getPostProcessConfig() {
        return this.options.postProcessConfig;
    }
});

const $s = o.MapCanvasRenderer.prototype.drawLayerCanvas;

o.MapCanvasRenderer.prototype.drawLayerCanvas = function() {
    const t = $s.apply(this, arguments);
    return t && function(t, i) {
        const e = t.map.getPostProcessConfig();
        if (!e || !e.enable) return;
        js || (s = i.width, n = i.height, js = document.createElement("canvas", s, n), Bs = w({
            canvas: js,
            attributes: {
                depth: !1,
                stencil: !1,
                alpha: !0,
                antialias: !1,
                premultipliedAlpha: !1
            }
        }), zs = Bs.texture({
            mag: "linear",
            min: "linear",
            mipmap: !1,
            flipY: !0,
            width: s,
            height: n
        }), Us = Bs.texture());
        var s, n;
        js.width === i.width && js.height === i.height || (js.width = i.width, js.height = i.height);
        Bs.clear(Ws);
        const r = e.filmicGrain || qs;
        void 0 === r.enable && (r.enable = !0);
        const h = e.vignette || qs;
        void 0 === h.enable && (h.enable = !0);
        const o = e.colorLUT || qs;
        void 0 === o.enable && (o.enable = !0);
        t.$n || (t.$n = {});
        const a = t.$n;
        if (o.enable) {
            const i = o.lut;
            if (!a.lutTexture || a.lutTexture.url !== i) {
                const e = new Image;
                e.onload = function() {
                    const s = {
                        data: e,
                        min: "linear",
                        mag: "linear"
                    }, n = a.lutTexture ? a.lutTexture.texture(s) : Bs.texture(s);
                    a.lutTexture = {
                        url: i,
                        texture: n
                    }, t.setLayerCanvasUpdated();
                }, e.src = i;
            }
        }
        const l = {
            "enableGrain": +!!r.enable,
            "grainFactor": void 0 === r.factor ? .15 : r.factor,
            "timeGrain": performance.now(),
            "enableVignette": +!!h.enable,
            "lensRadius": h.lensRadius || [ .8, .25 ],
            "frameMod": 1,
            "enableLut": +!!o.enable,
            "lookupTable": a.lutTexture ? a.lutTexture.texture : Us
        };
        Vs || (Vs = new xi(Bs));
        Vs.postprocess(null, l, zs({
            width: js.width,
            height: js.height,
            data: i,
            flipY: !0,
            mag: "linear",
            min: "linear",
            mipmap: !1
        })), r.enable && t.setLayerCanvasUpdated();
        t.context.drawImage(js, 0, 0, js.width, js.height);
    }(this, this.canvas), t;
};

const Xs = o.MapCanvasRenderer.prototype.renderFrame;

o.MapCanvasRenderer.prototype.renderFrame = function() {
    const t = Xs.apply(this, arguments), i = this.map.getPostProcessConfig(), e = i && i.filmicGrain;
    return !e || void 0 !== e.enable && !0 !== e.enable || this.setLayerCanvasUpdated(), 
    t;
};

const Ys = [];

function Js(t) {
    t.properties.showOnlyTimestamp && (delete t.properties.showOnlyTimestamp, Ks(t));
}

function Zs(t, i) {
    const e = t.geometry.properties;
    e.oldElementsBeforeHighlight || (e.oldElementsBeforeHighlight = t.geometry.elements), 
    e.elements && (e.oldElementsArrBeforeHighlight || (e.oldElementsArrBeforeHighlight = e.elements), 
    e.elements = i);
}

function Ks(t) {
    const i = t.geometry.properties.oldElementsBeforeHighlight;
    i && t.geometry.elements !== i && (t.geometry.deleteElements(), t.geometry.setElements(t.geometry.properties.oldElementsBeforeHighlight), 
    t.geometry.properties.oldElementsArrBeforeHighlight && (t.geometry.properties.elements = t.geometry.properties.oldElementsArrBeforeHighlight, 
    delete t.geometry.properties.oldElementsArrBeforeHighlight), delete t.geometry.properties.hasInvisible, 
    delete t.geometry.properties.oldElementsBeforeHighlight);
}

function Qs(t) {
    if (!t.properties.highlightTimestamp) return;
    const i = t.defines;
    delete i.HAS_HIGHLIGHT_COLOR, delete i.HAS_HIGHLIGHT_OPACITY, t.setDefines(i), delete t.properties.highlightTimestamp, 
    Ks(t), tn(t);
}

function tn(t) {
    if (!t) return;
    const {hlBloomMesh: i} = t.properties;
    if (i) {
        const e = i.geometry;
        e.elements && e.elements.destroy && e.deleteElements(), i.dispose(), delete t.properties.hlBloomMesh;
    }
}

var en = Object.freeze({
    __proto__: null,
    clearHighlight: Qs,
    clearShowOnly: Js,
    deleteHighlightBloomMesh: tn,
    highlightMesh: function(t, i, e, s, n) {
        const {highlightTimestamp: r} = i.properties;
        if (!e) return void (r && Qs(i));
        if (s === r) return;
        const h = i instanceof a.InstancedMesh, o = h ? i.instanceCount : i.geometry.getVertexCount();
        let {aHighlightColor: c, aHighlightOpacity: u} = i.geometry.properties;
        c && c.fill(0), u && u.fill(255);
        let f = !1, d = !1;
        const m = e.keys();
        let p = null, w = null;
        for (const t of m) if (n.has(t)) {
            const s = e.get(t), {color: r, bloom: h, visible: a, nodeIndex: l} = s;
            if (!ft(l) && l !== i.properties.nodeIndex) continue;
            let m, {opacity: v} = s;
            if (r && (f || (c || (c = new Uint8Array(4 * o)), f = !0), m = bt(Ys, r)), v = ft(v) ? 1 : v, 
            v < 1 && (d || (u || (u = new Uint8Array(o), u.fill(255)), d = !0)), !1 === a && (w || (w = new Set), 
            w.add(t)), m || v < 1 || h) {
                const i = n.get(t);
                if (i) for (let t = 0; t < i.length; t++) {
                    const e = i[t];
                    m && g.set(c.subarray(4 * e, 4 * e + 4), ...m), v < 1 && (u[e] = 255 * v), h && (p || (p = []), 
                    p.push(e));
                }
            }
        }
        const v = i.geometry, _ = i.defines;
        if (f ? (h ? (i.updateInstancedData("aHighlightColor", c), i.generateInstancedBuffers(t)) : (v.data.aHighlightColor ? v.updateData("aHighlightColor", c) : (v.data.aHighlightColor = c, 
        v.generateBuffers(t)), v.properties.aHighlightColor = c), _.HAS_HIGHLIGHT_COLOR = 1) : _.HAS_HIGHLIGHT_COLOR && (h ? (i.updateInstancedData("aHighlightColor", c), 
        i.generateInstancedBuffers(t)) : v.updateData("aHighlightColor", c), delete _.HAS_HIGHLIGHT_COLOR), 
        d ? (h ? (i.updateInstancedData("aHighlightOpacity", u), i.generateInstancedBuffers(t)) : (v.data.aHighlightOpacity ? v.updateData("aHighlightOpacity", u) : (v.data.aHighlightOpacity = u, 
        v.generateBuffers(t)), v.properties.aHighlightOpacity = u), _.HAS_HIGHLIGHT_OPACITY = 1) : _.HAS_HIGHLIGHT_OPACITY && (h ? (i.updateInstancedData("aHighlightOpacity", u), 
        i.generateInstancedBuffers(t)) : v.updateData("aHighlightOpacity", u), delete _.HAS_HIGHLIGHT_OPACITY), 
        w && w.size > 0) {
            let e = [];
            n.forEach(((t, i) => {
                w.has(i) || vt(e, t);
            })), v.properties.hasInvisible = !0, Zs(i, e);
            const s = {
                data: e,
                primitive: v.getPrimitive()
            };
            v.elements !== v.properties.oldElementsBeforeHighlight && v.elements.destroy && v.deleteElements(), 
            e = t.elements(s), v.setElements(e), v.generateBuffers(t);
        } else v.properties.hasInvisible && Ks(i);
        i.setDefines(_), i.properties.highlightTimestamp = s;
        let y = i.properties.hlBloomMesh;
        if (p && p.length) {
            if (y) {
                const t = l.copy(y.localTransform, i.localTransform), e = l.copy(y.positionMatrix, i.positionMatrix);
                y.setLocalTransform(t), y.setPositionMatrix(e), i.properties.hlBloomMesh.geometry.setElements(p);
            } else {
                const e = new a.Geometry(v.data, p, 0, v.desc);
                e.generateBuffers(t);
                const s = i.material;
                y = new a.Mesh(e, s, i.config);
                const n = i.uniforms;
                for (const t in n) Object.defineProperty(y.uniforms, t, {
                    enumerable: !0,
                    get: function() {
                        return i.getUniform(t);
                    }
                });
                const r = ut({}, i.defines);
                r.HAS_BLOOM = 1;
                const h = l.copy([], i.localTransform), o = l.copy([], i.positionMatrix);
                y.setLocalTransform(h), y.setPositionMatrix(o), ut(y.properties, i.properties), 
                ut(e.properties, v.properties), y.setDefines(r), y.bloom = 1;
            }
            i.properties.hlBloomMesh = y;
        } else y && tn(i);
    },
    showOnly: function(t, i, e, s, n) {
        const {showOnlyTimestamp: r} = i.properties;
        if (!e) return void (r && Js(i));
        if (s === r) return;
        i.properties.showOnlyTimestamp = s;
        const h = e.keys(), o = [];
        for (const t of h) {
            if (!n.has(t)) continue;
            const i = n.get(t);
            i && vt(o, i);
        }
        Zs(i, o), i.geometry.elements !== i.geometry.properties.oldElementsBeforeHighlight && i.geometry.elements.destroy && i.geometry.deleteElements();
        const a = {
            data: o,
            primitive: i.geometry.getPrimitive()
        };
        i.geometry.setElements(t.elements(a)), i.geometry.generateBuffers(t);
    }
});

const sn = [ 0, 0, 0, 0 ];

class nn {
    constructor(t, i, e, s, n, r) {
        this.renderer = new a.Renderer(t), this.sceneConfig = i, this.h = e, this.Xn = s, 
        this.Yn = n, this.yn = r || {
            factor: 0,
            units: 0
        }, this.o(), this.Jn = [];
    }
    render(t, i, e) {
        this.Zn();
        const s = this.h.getMap();
        this.renderer.regl.clear({
            color: sn,
            depth: 1,
            stencil: 255,
            framebuffer: this.Kn
        }), this.renderer.render(this.Qn, i, t, this.Kn);
        const n = this.h.getRenderer().canvas;
        this.Jn[0] = n.width, this.Jn[1] = n.height;
        const r = ut({
            colorRamp: this.tr,
            inputTexture: this.Kn,
            projViewMatrix: s.projViewMatrix,
            textureOutputSize: this.Jn
        }, i);
        return this.M(), this.renderer.render(this.ir, r, this.G, e);
    }
    dispose() {
        this.Qn && (this.Qn.dispose(), delete this.Qn), this.ir && (this.ir.dispose(), delete this.ir), 
        this.T && (this.T.geometry.dispose(), this.T.dispose(), delete this.T, delete this.G), 
        this.Kn && (this.Kn.destroy(), delete this.Kn);
    }
    er() {
        const t = this.Xn;
        let i = this.sr, e = this.nr;
        e ? e.clearRect(0, 0, 256, 1) : (i = this.sr = document.createElement("canvas"), 
        i.width = 256, i.height = 1, e = this.nr = i.getContext("2d"));
        const s = e.createLinearGradient(0, 0, 256, 1);
        for (let i = 0; i < t.length; i++) s.addColorStop(t[i][0], t[i][1]);
        e.fillStyle = s, e.fillRect(0, 0, 256, 1), this.tr && this.tr.destroy();
        const n = this.renderer.regl;
        this.tr = n.texture({
            width: 256,
            height: 1,
            data: i,
            min: "linear",
            mag: "linear",
            premultiplyAlpha: !0
        });
    }
    Zn() {
        const t = this.h.getRenderer().canvas, i = Math.ceil(t.width / 4), e = Math.ceil(t.height / 4), s = this.Kn;
        s.width === i && s.height === e || s.resize(i, e);
    }
    o() {
        this.er(), this.rr(), this.hr(), this._();
    }
    _() {
        const t = new a.Plane;
        t.generateBuffers(this.renderer.regl), this.T = new a.Mesh(t), this.G = new a.Scene([ this.T ]);
    }
    M() {
        const t = this.h.getMap(), i = Wt.getGroundTransform(this.T.localTransform, t);
        this.T.setLocalTransform(i);
    }
    hr() {
        const t = this.h.getRenderer().canvas, i = this.renderer.regl, e = i.hasExtension("OES_texture_half_float") ? "half float" : "float", s = Math.ceil(t.width / 4), n = Math.ceil(t.height / 4), r = i.texture({
            width: s,
            height: n,
            type: e,
            min: "linear",
            mag: "linear",
            format: "rgba"
        });
        this.Kn = i.framebuffer({
            width: s,
            height: n,
            color: [ r ]
        });
    }
    rr() {
        const t = this.h.getRenderer().canvas, i = this.sceneConfig.depthRange, e = {
            viewport: {
                x: 0,
                y: 0,
                width: () => t ? Math.ceil(t.width / 4) : 1,
                height: () => t ? Math.ceil(t.height / 4) : 1
            },
            depth: {
                enable: !0,
                func: "always"
            }
        };
        this.Yn && (e.stencil = this.Yn), this.Qn = new a.HeatmapShader({
            extraCommandProps: e
        }), this.ir = new a.HeatmapDisplayShader({
            x: 0,
            y: 0,
            width: () => t ? t.width : 1,
            height: () => t ? t.height : 1
        }, {
            extraCommandProps: {
                stencil: {
                    enable: !1
                },
                depth: {
                    enable: !0,
                    range: i || [ 0, 1 ],
                    func: "<="
                },
                polygonOffset: {
                    enable: !0,
                    offset: this.yn
                },
                scissor: {
                    enable: !1
                }
            }
        });
    }
}

class rn extends Ve {
    constructor(t, i) {
        super(t, i);
    }
    Be(t) {
        const i = this.Ws(t), e = new a.Mesh(i);
        return this.ar(e), this.Us(e), e;
    }
    js(t, i, e) {
        const s = this.Xs();
        t.setUniform("maskMode", s);
        const n = this.Ys();
        if (t.setUniform("maskColor", n), dt(i)) {
            const s = this.tn();
            s[0] = (s[0] - e) * i, s[1] = (s[1] - e) * i, t.setUniform("heightRange", s);
        }
    }
    setHeightRange(t) {
        this.options.heightRange = t, this._fireEvent("heightrangechange");
    }
    getHeightRange() {
        return this.options.heightRange;
    }
    tn() {
        const t = [ 0, 0 ];
        return this.options.heightRange && (t[0] = this.Js(this.options.heightRange[0]), 
        t[1] = this.Js(this.options.heightRange[1])), t;
    }
    ar(t) {
        const i = t.getDefines();
        i.HAS_MASK_COLOR = 1, t.setDefines(i);
    }
}

class hn extends rn {
    constructor(t, i) {
        super(t, i), this.Ns = "clip-inside";
    }
}

class on extends rn {
    constructor(t, i) {
        super(t, i), this.Ns = "clip-outside";
    }
}

class an extends Ve {
    constructor(t, i) {
        super(t, i);
    }
    setFlatheight(t) {
        this.options.flatHeight = t, this._fireEvent("flatheightchange");
    }
    Be(t) {
        const i = this.Ws(t), e = new a.Mesh(i);
        return this.ar(e), this.Us(e), e;
    }
    js(t) {
        const i = this.Xs();
        t.setUniform("maskMode", i);
        const e = this.Ys();
        t.setUniform("maskColor", e);
        const s = this.Js(this.options.flatHeight || 0);
        t.setUniform("flatHeight", s);
    }
    ar(t) {
        const i = t.getDefines();
        i.HAS_MASK_FLAT = 1, t.setDefines(i);
    }
    tn() {
        const t = [ 0, this.options.flatHeight ];
        return t[1] = this.Js(t[1]), t;
    }
}

let ln = class extends an {
    constructor(t, i) {
        super(t, i), this.Ns = "flat-inside";
    }
};

class cn extends an {
    constructor(t, i) {
        super(t, i), this.Ns = "flat-outside";
    }
}

class un extends Ve {
    constructor(t, i) {
        super(t, i), this.Ns = "color";
    }
    setHeightRange(t) {
        this.options.heightRange = t, this._fireEvent("heightrangechange");
    }
    Be(t) {
        const i = this.Ws(t), e = new a.Mesh(i);
        return this.ar(e), this.Us(e), e;
    }
    js(t, i, e) {
        const s = this.Xs();
        t.setUniform("maskMode", s);
        const n = this.Ys();
        if (t.setUniform("maskColor", n), dt(i)) {
            const s = this.tn();
            s[0] = (s[0] - e) * i, s[1] = (s[1] - e) * i, t.setUniform("heightRange", s);
        }
    }
    ar(t) {
        const i = t.getDefines();
        i.HAS_MASK_COLOR = 1, t.setDefines(i);
    }
    tn() {
        const t = [ 0, 0 ];
        return this.options.heightRange && (t[0] = this.Js(this.options.heightRange[0]), 
        t[1] = this.Js(this.options.heightRange[1])), t;
    }
}

class fn extends Ve {
    constructor(t, i) {
        super(t, i), this.Ns = "texture";
    }
    play() {
        this.lr && this.lr.play();
    }
    pause() {
        this.lr && this.lr.pause();
    }
    setAudio(t) {
        this.lr && (this.video.muted = t);
    }
    setUrl(t) {
        this.options.url = t, this.cr(t);
    }
    getState() {
        return this.ur;
    }
    Be(t) {
        const {geometry: i, copyGeometry: e} = this.Ws(t), s = new a.Mesh(i), n = this.dr(t);
        return s.material = new a.Material({
            maskTexture: n
        }), this.ar(s), this.Us(s), this.Vs = new a.Mesh(e), this.Us(this.Vs), s;
    }
    js(t) {
        const i = this.Xs();
        if (t.setUniform("maskMode", i), this.$s && this.$s.length) for (let i = 0; i < 4; i++) t.setUniform("mask_position" + i, this.$s.slice(3 * i, 3 * i + 3));
        const e = this.Ys();
        t.setUniform("maskColor", e);
    }
    ar(t) {
        const i = t.getDefines();
        i.HAS_TEXTURE = 1, t.setDefines(i);
    }
    dr(t) {
        this.cr();
        return t.texture();
    }
    cr() {
        this.ur = "stop";
        const t = this.options.url, i = this.options.elementId;
        let e = document.getElementById(i);
        if (t && (e = document.createElement("video"), e.src = t), !e) throw new Error("there is no element or url setting for video mask");
        e.autoplay = this.options.autoplay || !0, e.loop = this.options.loop || !0, e.muted = this.options.muted || !0, 
        e.play(), e.addEventListener("playing", (() => {
            this.ur = "playing";
        })), e.addEventListener("pause", (() => {
            this.ur = "pause";
        })), this.lr = e;
    }
    De() {
        const t = this.xt;
        if (t && t.material) {
            const i = t.material.get("maskTexture");
            i && this.lr && this.Ne() && i(this.lr);
        }
    }
    Ne() {
        return "playing" === this.ur;
    }
}

class dn extends Ve {
    constructor(t, i) {
        super(t, i), this.Ns = "texture";
    }
    setUrl(t) {
        this.options.url = t;
        const i = this.xt;
        if (i && i.material) {
            const t = i.material.get("maskTexture");
            if (t) {
                this.mr(t);
                const i = this.getLayer();
                i && i.getRenderer().setToRedraw();
            }
        }
    }
    Be(t) {
        const {geometry: i, copyGeometry: e} = this.Ws(t), s = new a.Mesh(i), n = t.texture();
        return this.mr(n), s.material = new a.Material({
            maskTexture: n
        }), this.ar(s), this.Us(s), this.Vs = new a.Mesh(e), this.Us(this.Vs), s;
    }
    js(t) {
        const i = this.Xs();
        t.setUniform("maskMode", i);
        const e = this.Ys();
        if (t.setUniform("maskColor", e), this.$s && this.$s.length) for (let i = 0; i < 4; i++) t.setUniform("mask_position" + i, this.$s.slice(3 * i, 3 * i + 3));
    }
    ar(t) {
        const i = t.getDefines();
        i.HAS_TEXTURE = 1, t.setDefines(i);
    }
    mr(t) {
        const i = new Image;
        i.src = this.options.url, i.crossOrigin = "anonymous", i.onload = function() {
            t(i);
        }, i.onerror = function() {
            console.warn("Image load error");
        };
    }
    getBBox() {
        return this.Vs.getBoundingBox();
    }
}

class mn extends an {
    constructor(t, i) {
        super(t, i), this.setElevation(i.elevation), this.Ns = "elevate";
    }
    setElevation(t) {
        this.options.elevation = t, this.setFlatheight(this.options.elevation);
    }
}

const gn = new s(0, 0), pn = new s(0, 0), wn = new s(0, 0), vn = new s(0, 0);

class _n extends rn {
    constructor(t, i) {
        super([], i), this.gr = t;
    }
    setPosition(t) {
        this.gr = t, this.Qs();
    }
    getPosition() {
        return this.gr;
    }
    setWidth(t) {
        this.options.width = t, this.Qs();
    }
    setLength(t) {
        this.options.length = t, this.Qs();
    }
    setHeight(t) {
        this.options.height = t, this.Qs();
    }
    setRotation(t) {
        this.options.rotation = t, this.Qs();
    }
    Qs() {
        const t = this.getLayer();
        if (!t) return;
        const i = t.getMap();
        if (i) {
            const {length: t, width: e, height: s} = this.options, n = this.gr, r = this.options.rotation || 0, {coordinates: h, heightRange: o} = this.pr(i, n, t, e, s, r);
            this.setCoordinates(h), this.setHeightRange(o);
        }
    }
    pr(t, i, e, s, n, r) {
        const h = t.getGLRes(), o = t.distanceToPointAtRes(s / 2, 0, h, gn), a = t.distanceToPointAtRes(0, e / 2, h, pn), l = t.coordinateToPointAtRes(i, h, wn), c = l.x - o.x, u = l.x + o.x, f = l.y + a.y, d = l.y - a.y, m = this.wr([ [ c, f ], [ u, f ], [ u, d ], [ c, d ] ], l, r);
        vn.set(m[0][0], m[0][1]);
        const g = t.pointAtResToCoordinate(vn, h);
        vn.set(m[1][0], m[1][1]);
        const p = t.pointAtResToCoordinate(vn, h);
        vn.set(m[2][0], m[2][1]);
        const w = t.pointAtResToCoordinate(vn, h);
        vn.set(m[3][0], m[3][1]);
        const v = t.pointAtResToCoordinate(vn, h), _ = i.z - n / 2, y = [ _, i.z + n / 2 ];
        return {
            coordinates: [ [ g.x, g.y, _ ], [ p.x, p.y, _ ], [ w.x, w.y, _ ], [ v.x, v.y, _ ], [ g.x, g.y, _ ] ],
            heightRange: y
        };
    }
    wr(t, i, e) {
        for (let s = 0; s < t.length; s++) u.rotate(t[s], t[s], [ i.x, i.y ], e * Math.PI / 180);
        return t;
    }
}

class yn extends _n {
    constructor(t, i) {
        super(t, i), this.Ns = "clip-inside";
    }
}

class bn extends _n {
    constructor(t, i) {
        super(t, i), this.Ns = "clip-outside";
    }
}

class xn extends t.DrawTool {
    constructor(t) {
        super(t), this.on("enable", this.vr, this), this.on("disable", this._r, this), this.yr = [];
    }
    addTo(t) {
        return t && (super.addTo(t), this.Pn = t, this.br()), this;
    }
    br() {
        const i = t.INTERNAL_LAYER_PREFIX + "drawtool";
        this.Pn.getLayer(i).hide();
    }
    vr() {
        this.on("drawstart", this.Mr, this).on("drawvertex", this.Sr, this).on("mousemove", this.Cr, this).on("drawend", this.kr, this);
    }
    _r() {
        this.off("drawstart", this.Mr, this).off("drawvertex", this.Sr, this).off("mousemove", this.Cr, this).off("drawend", this.kr, this);
    }
    Tr(i) {
        const {coordinate: e, containerPoint: s} = i, n = this.Pn.getLayers((t => t.queryTerrainAtPoint))[0];
        if (!n) return e.z = e.z || 0, e;
        const r = n.identify(e, {
            includeInternals: !1
        })[0];
        let h = null;
        if (r && r.coordinate ? h = new t.Coordinate(r.coordinate) : (e.z = e.z || 0, h = e), 
        n.getTerrainLayer()) {
            const t = n.queryTerrainAtPoint(s);
            return t && t.z > h.z ? t : h;
        }
        return h;
    }
    Mr(t) {
        const i = this.Tr(t);
        i && (this.Or = !0, this.yr.push(i), this.Ar(i));
    }
    Sr(t) {
        const i = this.Tr(t);
        i && (this.Or = !0, this.yr[this.yr.length - 1] = i, this.Ir());
    }
    Cr(t) {
        const i = this.Tr(t);
        i && (this.Or ? this.yr.push(i) : this.yr[this.yr.length - 1] = i, this.Ir(), this.Or = !1);
    }
    kr(t) {
        const i = this.Tr(t);
        i && (this.yr.push(i), this.Er());
    }
    Er() {
        this.Ir(), this.yr = [], this.Lr = null, this.Pr = null;
    }
    remove() {
        this.Rr && this.Rr.remove(), this.Fr && this.Fr.remove();
    }
    clear() {
        this.Rr && this.Rr.clear(), this.Fr && this.Fr.clear();
    }
}

xn.mergeOptions({
    "mode": "LineString",
    "language": "zh-CN",
    "metric": !0,
    "imperial": !1,
    "once": !0,
    "symbol": {
        "lineColor": "#e8542b",
        "lineWidth": 2,
        "polygonFill": "#eee",
        "polygonOpacity": .5
    },
    "vertexSymbol": {
        "markerType": "ellipse",
        "markerFill": "#e8542b",
        "markerLineColor": "#fff",
        "markerLineWidth": 2,
        "markerWidth": 10,
        "markerHeight": 10,
        "markerDy": 0
    },
    "labelSymbol": {
        "boxStyle": {
            "padding": [ 15, 6 ],
            "verticalAlignment": "top",
            "horizontalAlignment": "left",
            "minWidth": 150,
            "minHeight": 30,
            "symbol": {
                "markerType": "square",
                "markerFill": "rgb(60, 60, 60)",
                "markerFillOpacity": .8,
                "markerLineColor": "#fff",
                "markerLineWidth": 2,
                "textDx": -110
            }
        },
        "textSymbol": {
            "textFill": "#fff",
            "textSize": 16,
            "textVerticalAlignment": "top"
        }
    }
});

class Mn extends xn {
    br() {
        super.br(), this.Rr = new t.VectorLayer(t.INTERNAL_LAYER_PREFIX + "_distance3dtool", {
            enableAltitude: !0
        }).addTo(this.Pn), this.Fr = new t.VectorLayer(t.INTERNAL_LAYER_PREFIX + "_distance3dtool_marker", {
            enableAltitude: !0
        }).addTo(this.Pn);
    }
    Ir() {
        this.Lr.setCoordinates(this.yr);
        const i = this.Fr.getGeometries(), e = this.Rr.getGeometries().length;
        for (let t = 0; t < i.length; t++) {
            const s = i[t].getId();
            s !== "label" + e && s.indexOf(`${e}_`) > -1 && i[t].remove();
        }
        for (let i = 0; i < this.yr.length; i++) new t.Marker(this.yr[i], {
            id: e + "_" + i,
            symbol: this.options.vertexSymbol
        }).addTo(this.Fr);
        this.Hr();
    }
    Hr() {
        const i = this.getMeasureResult(), e = (("zh-CN" === this.options.language ? 0 : 1) ? "distance: " : "距离: ") + this.Dr(i), s = this.yr[this.yr.length - 1], n = this.Rr.getGeometries().length, r = t.Util.extend({
            id: "label" + n
        }, this.options.labelSymbol);
        this.Pr ? (this.Pr.setContent(e), this.Pr.setCoordinates(s)) : this.Pr = new t.Label(e, s, r).addTo(this.Fr);
    }
    Dr(t) {
        let i;
        i = "zh-CN" === this.options.language ? [ " 米", " 公里", " 英尺", " 英里" ] : [ " m", " km", " feet", " mile" ];
        let e = "";
        return this.options.metric && (this.Nr = t < 1e3 ? t.toFixed(1) : (t / 1e3).toFixed(2), 
        this.Gr = t < 1e3 ? i[0] : i[1]), this.options.imperial && (t *= 3.2808399, e.length > 0 && (e += "\n"), 
        this.Nr = t < 5280 ? t.toFixed(1) : (t / 5280).toFixed(2), this.Gr = t < 5280 ? i[2] : i[3]), 
        e += this.Nr + this.Gr, e;
    }
    Ar(i) {
        this.Lr || (this.Lr = new t.LineString([ i ], {
            symbol: this.options.symbol
        }).addTo(this.Rr)), this.Ir(), this.Or = !0;
    }
    getMeasureResult() {
        return this.Lr.getLength();
    }
}

class Sn extends xn {
    br() {
        super.br(), this.Rr = new t.VectorLayer(t.INTERNAL_LAYER_PREFIX + "_area3dtool", {
            enableAltitude: !0
        }).addTo(this.Pn), this.Fr = new t.VectorLayer(t.INTERNAL_LAYER_PREFIX + "_area3dtool_marker", {
            enableAltitude: !0
        }).addTo(this.Pn);
    }
    Ir() {
        const i = this.jr(this.yr);
        this.Lr.setCoordinates(i), this.Br.setCoordinates(i);
        const e = this.Fr.getGeometries(), s = this.Rr.getGeometries().length;
        for (let t = 0; t < e.length; t++) {
            const i = e[t].getId();
            i !== "label" + s && i.indexOf(`${s}_`) > -1 && e[t].remove();
        }
        for (let i = 0; i < this.yr.length; i++) new t.Marker(this.yr[i], {
            id: s + "_" + i,
            symbol: this.options.vertexSymbol
        }).addTo(this.Fr);
        this.Hr();
    }
    jr(t) {
        const i = t.map((t => t));
        return t.length > 2 && i.push(t[0]), i;
    }
    Hr() {
        const i = this.getMeasureResult(), e = (("zh-CN" === this.options.language ? 0 : 1) ? "area: " : "面积: ") + this.Dr(i), s = this.yr[this.yr.length - 1], n = this.Rr.getGeometries().length, r = t.Util.extend({
            id: "label" + n
        }, this.options.labelSymbol);
        this.Pr ? (this.Pr.setContent(e), this.Pr.setCoordinates(s)) : this.Pr = new t.Label(e, s, r).addTo(this.Fr);
    }
    Dr(t) {
        let i;
        i = "zh-CN" === this.options.language ? [ " 平方米", " 平方公里", " 平方英尺", " 平方英里" ] : [ " sq.m", " sq.km", " sq.ft", " sq.mi" ];
        let e = "";
        if (this.options.metric && (this.Nr = t < 1e6 ? t.toFixed(2) : (t / 1e6).toFixed(2), 
        this.Gr = t < 1e6 ? i[0] : i[1]), this.options.imperial) {
            t *= 3.2808399, e.length > 0 && (e += "\n");
            const s = 27878400;
            this.Nr = t < s ? t.toFixed(2) : (t / s).toFixed(2), this.Gr = t < s ? i[2] : i[3];
        }
        return e += this.Nr + this.Gr, e;
    }
    Ar(i) {
        this.Lr || (this.Lr = new t.LineString([ i ], {
            symbol: this.options.symbol
        }).addTo(this.Rr), this.Br = new t.Polygon([ i ])), this.Ir(), this.Or = !0;
    }
    getMeasureResult() {
        return this.Br.getArea();
    }
}

const Cn = [ [ "直线距离", "垂直高度", "水平距离" ], [ "spatial distance", "vertical height", "horizontal distance" ] ];

class kn extends xn {
    br() {
        super.br(), this.Fr = new t.VectorLayer(t.INTERNAL_LAYER_PREFIX + "_height3dtool_marker", {
            enableAltitude: !0
        }).addTo(this.Pn).bringToFront(), this.Rr = new t.VectorLayer(t.INTERNAL_LAYER_PREFIX + "_height3dtool", {
            enableAltitude: !0
        }).addTo(this.Pn).bringToFront();
    }
    Sr(t) {
        super.Sr(t), this.yr.length > 1 && (this.Er(), this.disable());
    }
    Ir() {
        const i = this.Fr.getGeometries(), e = this.Rr.getGeometries().length;
        for (let t = 0; t < i.length; t++) {
            const s = i[t].getId();
            s !== "label" + e + "_" + t && 0 === s.indexOf(`${e}_`) && i[t].remove();
        }
        for (let i = 0; i < this.yr.length; i++) new t.Marker(this.yr[i], {
            id: e + "_" + i,
            symbol: this.options.vertexSymbol
        }).addTo(this.Fr);
        const s = this.yr.length;
        if (s > 1) {
            const i = this.yr[s - 1].x, n = this.yr[s - 1].y, r = this.yr[s - 2].z, h = new t.Coordinate([ i, n, r ]);
            new t.Marker(h, {
                id: e + "_2",
                symbol: this.options.vertexSymbol
            }).addTo(this.Fr);
            const o = [].concat(this.yr);
            o.push(h), o.push(this.yr[0]);
            const a = o.map((t => t.z));
            this.Lr.setCoordinates(o), this.Lr.setProperties({
                altitude: a
            });
            const l = this.Pn.getProjection().measureLenBetween(o[0], o[2]), c = o[1].z - o[2].z, u = Math.sqrt(Math.pow(l, 2) + Math.pow(c, 2));
            this.Hr(o, [ u, c, l ]);
        }
    }
    Hr(i, e) {
        for (let s = 0; s < i.length - 1; s++) {
            const n = i[s], r = i[s + 1], h = e[s], o = "zh-CN" === this.options.language ? 0 : 1, a = this.Dr(h), l = Cn[o][s] + ":" + a, c = "label" + this.Rr.getGeometries().length + "_" + s, u = JSON.parse(JSON.stringify(this.options.labelSymbol));
            u.id = c, s < 2 && (u.boxStyle.symbol.textDx *= -1);
            const f = 1 === s ? n : new t.Coordinate((n.x + r.x) / 2, (n.y + r.y) / 2, (n.z + r.z) / 2), d = this.Fr.getGeometryById(c), m = `${c}_marker`, g = this.Fr.getGeometryById(m);
            d ? (d.setContent(l), d.setCoordinates(f), g.setCoordinates(f)) : (new t.Label(l, f, u).addTo(this.Fr), 
            new t.Marker(f, {
                id: m,
                symbol: this.options.vertexSymbol
            }).addTo(this.Fr));
        }
    }
    Dr(t) {
        let i;
        i = "zh-CN" === this.options.language ? [ " 米", " 公里", " 英尺", " 英里" ] : [ " m", " km", " feet", " mile" ];
        let e = "";
        return this.options.metric && (this.Nr = t < 1e3 ? t.toFixed(1) : (t / 1e3).toFixed(2), 
        this.Gr = t < 1e3 ? i[0] : i[1]), this.options.imperial && (t *= 3.2808399, e.length > 0 && (e += "\n"), 
        this.Nr = t < 5280 ? t.toFixed(1) : (t / 5280).toFixed(2), this.Gr = t < 5280 ? i[2] : i[3]), 
        e += this.Nr + this.Gr, e;
    }
    Ar(i) {
        this.Lr || (this.Lr = new t.LineString([ i ], {
            symbol: this.options.symbol
        }).addTo(this.Rr)), this.Ir(), this.Or = !0;
    }
    getMeasureResult() {
        return this.Lr.getLength();
    }
}

export { Sn as Area3DTool, yn as BoxInsideClipMask, bn as BoxOutsideClipMask, hn as ClipInsideMask, on as ClipOutsideMask, un as ColorMask, re as ContextUtil, Mn as Distance3DTool, mn as ElevateMask, ln as FlatInsideMask, cn as FlatOutsideMask, Wt as GroundPainter, Fs as GroupGLLayer, nn as HeatmapProcess, kn as Height3DTool, en as HighlightUtil, dn as ImageMask, ss as MaskLayerMixin, ye as MaskRendererMixin, xn as Measure3DTool, Ts as RayCaster, fn as VideoMask, at as color };
//# sourceMappingURL=gl.es.js.map
